import translations from './i18n';
const ext = {
  th: {
    lt_bet_lotto: 'แทงหวย',
    lt_lotto_result: 'ผลหวย',
    lt_poy: 'โพยหวย',
    lt_fill_code: 'กรอกโค้ด',
    lt_create_number_set: 'สร้างเลขชุด',
    lt_check_lotto: 'ตรวจหวย',
    lt_lucky_numbers_group: 'กลุ่มเลขเด็ด',
    lt_lotto_schedule_soon: 'ตารางหวยเร็วๆนี้',
    lt_bet_now: 'แทงเลย',
    lt_games: 'เกมส์',
    lt_financial_report: 'รายงานการเงิน',
    lt_deposit_withdraw_list: 'รายการฝาก/ถอน',
    lt_report_deposit_withdraw_problem: 'แจ้งปัญหาฝาก/ถอน',
    lt_sport: 'กีฬา',
    lt_casino_online: 'คาสิโนออนไลน์',
    lt_wheel_games: 'เกมส์กงล้อ',
    lt_rules: 'กฏกติกา',
    lt_register_via_admin: 'สมัครสมาชิกผ่านแอดมิน',
    lt_forgot_password: 'ลืมรหัสผ่าน',
    lt_check_lotto_result: 'ตรวจผลหวย',
    lt_latest_lotto_result: 'ผลหวยล่าสุด',
    lt_fill_coupon_code: 'กรอกโค้ดคูปอง',
    lt_how_to_bet_lotto: 'วิธีการแทงหวย',
    lt_report_problem_24hr: 'แจ้งปัญหา 24 ชม.',
    lt_today_bet_amount: 'ยอดแทงวันนี้',
    lt_total: 'ยอดรวม',
    lt_result_announced: 'ออกผลแล้ว',
    lt_result_pending: 'ยังไม่ออกผล',
    lt_today_list: 'รายการวันนี้',
    lt_all_lotto: 'หวยทั้งหมด',
    lt_all_history: 'ย้อนหลังทั้งหมด',
    lt_poy_short: 'โพย',
    lt_not_announced_yet: 'ที่ยังไม่ออกผล',
    lt_previous: 'ก่อนหน้า',
    lt_poy_number: 'โพยเลขที่',
    lt_stake: 'เงินเดิมพัน',
    lt_win_lose: 'ผลแพ้/ชนะ',
    lt_no_items: 'ไม่มีรายการ',
    lt_poy_detail: 'รายละเอียดโพย',
    lt_return_poy: 'คืนโพย',
    lt_round_date: 'รอบ/วันที่',
    lt_win_loss_result: 'ผลได้เสีย',
    lt_order_no: 'ลำดับ',
    lt_won: 'ถูกรางวัล',
    lt_not_won: 'ไม่ถูกรางวัล',
    lt_winning_number: 'เลขที่ออก',
    lt_payout_rate: 'ราคาจ่าย',
    lt_bet_price: 'ราคาแทง',
    lt_day: 'วัน',
    lt_hour: 'ชั่วโมง',
    lt_minute: 'นาที',
    lt_second: 'วินาที',
    lt_welcome_marquee: 'ยินดีต้อนรับทุกท่านสู่ Salmon168 เว็บหวยออนไลน์ที่มาแรงที่สุดในขณะนี้',
    lt_thai_lotto: 'หวยไทย',
    lt_thai_lotto_group: 'กลุ่มหวยไทย',
    lt_back_home: 'หน้าหลัก',
    lt_go_back: 'ย้อนกลับ',
    lt_latest_update: 'อัปเดตล่าสุด',
    lt_or: 'หรือ',
    lt_register_via_admin_short: 'สมัครผ่านแอดมิน',
    lt_specify_phone: 'ระบุเบอร์โทรศัพท์',
    lt_register_phone: 'ลงทะเบียนเบอร์โทรศัพท์',
    lt_enter_phone_ph: 'ใส่เบอร์โทรศัพท์',
    lt_enter_phone_verify: 'กรุณาใส่หมายเลขโทรศัพท์เพื่อยืนยันตัวตน',
    lt_enter_captcha: 'กรุณากรอกอักขระ 4 ตัวในภาพ',
    lt_confirm_phone: 'ยืนยันเบอร์โทรศัพท์',
    lt_enter_sms_code: 'โปรดนำเลข ที่ได้รับจาก sms มากรอกในช่องว่าง',
    lt_request_otp_again_5min: 'ขอรหัส OTP ได้อีกครั้งใน 5 นาที',
    lt_enter_otp_within_5min: 'กรุณาใส่หมายเลขที่ระบบได้ส่งไปยังเบอร์โทรศัพท์ของท่านภายใน 5 นาที',
    lt_send_code_to_phone: 'ส่งรหัสไปยังเบอร์',
    lt_resend_otp: 'ส่งรหัส OTP',
    lt_create_account: 'สร้างบัญชี',
    lt_username_label: 'ชื่อผู้ใช้งาน',
    lt_password_label: 'รหัสผ่าน',
    lt_confirm_password_label: 'ยืนยันรหัสผ่าน',
    lt_confirm_password_ph: 'กรอก password อีกครั้ง',
    lt_select_known_channel: 'เลือกช่องทางที่รู้จักเว็บ',
    lt_add_bank_account: 'เพิ่มบัญชีธนาคาร',
    lt_select_bank: 'เลือกธนาคาร',
    lt_please_select_bank: 'กรุณาเลือกธนาคาร',
    lt_account_name_label: 'ชื่อบัญชี',
    lt_account_name_ph: 'ชื่อ นามสกุล หน้าสมุดบัญชี',
    lt_account_no_label: 'เลขที่บัญชี',
    lt_numbers_only_ph: 'ระบุเฉพาะตัวเลข',
    lt_confirm_account_no: 'ยืนยันเลขที่บัญชี',
    lt_confirm_account_no_ph: 'ยืนยันเลขที่บัญชีอีกครั้ง',
    lt_add_account: 'เพิ่มบัญชี',
    lt_next: 'ถัดไป',
    lt_skip_verify: 'ข้ามการยืนยัน',
    lt_confirm_otp: 'ยืนยัน OTP',
    lt_already_member: 'มีสมาชิกอยู่แล้ว',
    lt_phone_already_used: 'เบอร์นี้มีผู้ใช้งานแล้ว',
    lt_phone: 'เบอร์',
    lt_phone_has_account: 'มีรหัสผู้ใช้งานแล้ว',
    lt_please_register_new_phone: 'กรุณาทำการสมัครด้วยเบอร์ใหม่ หรือ',
    lt_reset_password_if_forgot: 'ทำการรีเซ็ตรหัสผ่านในกรณีที่ลืมรหัสผ่าน',
    lt_register_new_phone: 'สมัครด้วยเบอร์ใหม่',
    lt_reset_password: 'ทำการรีเซ็ตรหัสผ่าน',
    lt_choose_contact_channel: 'เลือกช่องทางการติดต่อเรา',
    lt_contact_via_line: 'ติดต่อผ่านไลน์',
    lt_live_chat_with_staff: 'แชทสดกับพนักงาน',
    lt_unmute: 'เปิดเสียง',
    lt_mute: 'ปิดเสียง',
    lt_rules_title: 'กฏและกติกา',
    lt_welcome_lotto_online: 'ยินดีต้อนรับสู่หวยออนไลน์',
    lt_payout_rate_title: 'อัตราการจ่าย',
    lt_i_understand_accept: 'ฉันเข้าใจและยอมรับ',
    lt_account_settings: 'ตั้งค่าบัญชีผู้ใช้',
    lt_bank_account: 'บัญชีธนาคาร',
    lt_how_to_use: 'วิธีใช้งาน',
    lt_help_center: 'ศูนย์ช่วยเหลือ',
    lt_lucky_numbers_daily: 'เลขเด็ดเลขดังประจำวัน',
    lt_how_to_register: 'วิธีสมัครสมาชิก',
    lt_register_steps: 'ขั้นตอนการสมัครสมาชิก',
    lt_register_via_admin_alt: 'สมัครผ่านเเอดมิน',
    lt_admin_help_register: 'ให้แอดมินช่วยสมัครสมาชิก',
    lt_prize_1: 'รางวัลที่ 1',
    lt_two_down: '2 ตัวล่าง',
    lt_three_front: '3 ตัวหน้า',
    lt_three_down: '3 ตัวล่าง',
    lt_three_up: '3 ตัวบน',
    lt_foreign_lotto: 'หวยต่างประเทศ',
    lt_online_lotto: 'หวยออนไลน์',
    lt_foreign_stock_lotto: 'หวยหุ้นต่างประเทศ',
    lt_special_stock_lotto: 'หวยหุ้นพิเศษ',
    lt_stock_lotto: 'หวยหุ้น',
    lt_stock_lotto_vip: 'หวยหุ้น VIP',
    lt_popular_lotto: 'หวยเด่นยอดนิยม',
    lt_result_rooms: 'ห้องโชว์ผลรางวัล',
    lt_showing_result: 'โชว์ผลรางวัล',
    lt_countdown_hot_lotto: 'นับถอยหลังหวยดัง',
    lt_thai_gov_lotto: 'หวยรัฐบาลไทย',
    lt_live_chat: 'แชทสด',
    lt_teach_usage: 'สอนใช้งาน',
    lt_install_app: 'ติดตั้ง APP',
    lt_lao_tonight: 'หวยลาวทูไนท์',
    lt_balance_remaining: 'ยอดเงินคงเหลือ',
    lt_lotto_soon: 'หวยเร็วๆนี้',
    lt_close_at: 'ปิดรับ',
    lt_survey: 'แบบสำรวจ',
    lt_survey_q: 'ท่านรู้จักเว็บไซท์ของเรามาจากทางช่องทางใด?',
    lt_install_app2: 'ติดตั้งแอปฯ',
    lt_boss_gives_luck: 'เถ้าเเก่ ให้โชค',
    lt_browser_not_support: 'เบราว์เซอร์ไม่รองรับ กรุณาทำตามขั้นตอนต่อไปนี้',
    lt_play_history: 'ประวัติการเล่น',
    lt_detail: 'รายละเอียด',
    lt_transaction_time: 'เวลาที่ทำรายการ',
    lt_provider: 'ผู้ให้บริการ',
    lt_ticket_no: 'เลขที่ตั๋ว',
    lt_event: 'อีเวนต์',
    lt_brought_forward: 'ยอดยกมา',
    lt_credit: 'เครดิต',
    lt_balance: 'ยอดคงเหลือ',
    lt_report_credit_deposit: 'แจ้งเติมเครดิต',
    lt_customer_bank_account: 'บัญชีธนาคารของลูกค้า',
    lt_select_transfer_channel: 'เลือกช่องทางการโอนเงิน',
    lt_transaction_channel: 'ช่องทางธุรกรรม',
    lt_please_select_channel: 'กรุณาเลือกช่องทางธุรกรรม',
    lt_payment_gateway: 'Payment Gateway',
    lt_selected: 'เลือกแล้ว',
    lt_amount_to_transfer: 'จำนวนเงินที่ต้องการโอน (จำนวนเต็ม)',
    lt_min_max_amount_ph: 'ขั้นต่ำ: 20.00 / สูงสุด: 500,000.00',
    lt_continue: 'ดำเนินการต่อ',
    lt_transfer_to_add_credit: 'โอนเงินเพื่อเติมเครดิต',
    lt_bank: 'ธนาคาร',
    lt_use_this_account_only: '***กรุณาใช้บัญชีนี้ในการโอนเท่านั้น***',
    lt_web_bank_account: 'บัญชีธนาคารของเว็บ',
    lt_report_transfer: 'แจ้งโอนเงิน',
    lt_uploading_slip: 'กำลังอัปโหลดสลิป...',
    lt_amount_must_transfer: 'จำนวนเงินที่ต้องโอน:',
    lt_check_account_before_transfer: 'หมายเหตุ: กรุณาตรวจสอบเลขบัญชีก่อนทำการโอนเงินทุกครั้ง',
    lt_transfer_within_5min: 'กรุณาโอนเงินภายในเวลา: 5 นาที',
    lt_report_withdraw: 'แจ้งถอนเงิน',
    lt_select_your_bank_account: 'เลือกบัญชีธนาคารของท่าน',
    lt_select_account_below: '*กรุณาเลือกบัญชีด้านล่างตามที่ท่านต้องการ',
    lt_withdrawable_amount: 'จำนวนเงินที่ถอนได้',
    lt_some_locked_minbet: 'จำนวนเงินในกระเป๋าอาจจะมีบางส่วนถูกล็อคสำหรับการแทงขั้นต่ำ',
    lt_withdraw_cond1: '- ลูกค้าต้องมียอดเดิมพัน 10% ของยอดฝาก และไม่ติดยอดเดิมพันโปรโมชั่น จึงจะสามารถถอนเครดิตได้ทั้งหมด',
    lt_withdraw_cond2: '- กรณีแทงหวย ระบบจะนับยอดเดิมพัน เฉพาะหวยที่ออกผลแล้วเท่านั้น',
    lt_withdraw_cond3: '- ยอดถอนขั้นต่ำ 100 บาท',
    lt_search_product_name: 'ค้นหารายชื่อสินค้า',
    lt_not_accepting_yet: 'ยังไม่รับแทง',
    lt_time_expired: 'หมดเวลา',
    lt_payout_rate_short: 'อัตราจ่าย',
    lt_rules_short: 'กติกา',
    lt_open_88_rounds: 'เปิด 88 รอบ',
    lt_24hr: '24 ชม.',
    lt_draw_date: 'งวดวันที่',
    lt_time_left: 'เหลือเวลา',
    lt_open_betting: 'เปิดรับแทง',
    lt_lotto_4d: 'หวย 4D',
    lt_yeekee: 'หวยยี่กี',
    lt_not_accepting: 'ไม่รับแทง',
    lt_waiting_accept: 'รอรับแทง',
    lt_not_drawn_yet: 'ยังไม่ออกรางวัล',
    lt_waiting_result: 'รอออกผล',
    lt_pays: 'จ่าย',
    lt_min_bet_per_time: 'แทงขั้นต่ำต่อครั้ง',
    lt_max_bet_per_time: 'แทงสูงสุดต่อครั้ง',
    lt_history_stats: 'สถิติย้อนหลัง',
    lt_two_up: '2 บน',
    lt_two_low: '2 ล่าง',
    lt_high: 'สูง',
    lt_low: 'ต่ำ',
    lt_even: 'คู่',
    lt_odd: 'คี่',
    lt_bet_amount_of_selected_date: 'ยอดแทงของวันที่เลือก',
    lt_select_date_range: 'เลือกช่วงวันที่',
    lt_from_date: 'ตั้งแต่วันที่',
    lt_to_date: 'ถึงวันที่',
    lt_start_ph: 'เริ่ม',
    lt_to_ph: 'ถึง',
    lt_all: 'ทั้งหมด',
    lt_today: 'วันนี้',
    lt_yesterday: 'เมื่อวาน',
    lt_last_7days: '7 วันล่าสุด',
    lt_last_30days: '30 วันล่าสุด',
    lt_date_label: 'วันที่',
    lt_date_colon: 'วันที่ :',
    lt_select_date_ph: 'เลือกวันที่',
    lt_today_list2: 'รายการวันนี้',
    lt_bet_amount2: 'ยอดแทง',
    lt_manage_number_set: 'จัดการเลขชุด',
    lt_show: 'แสดง',
    lt_items: 'รายการ',
    lt_number_set_name: 'ชื่อเลขชุด',
    lt_created_datetime: 'วัน-เวลา ที่สร้าง',
    lt_manage: 'จัดการ',
    lt_delete: 'ลบ',
    lt_coupon: 'คูปอง',
    lt_refer_friend: 'แนะนำเพื่อน',
    lt_income: 'รายได้',
    lt_withdraw_income: 'ถอนรายได้',
    lt_max_revenue_share: 'ส่วนแบ่งรายได้สูงสุด:',
    lt_current_income: 'รายได้ปัจจุบัน',
    lt_referred_members: 'สมาชิกแนะนำ',
    lt_total_bets: 'แทงทั้งหมด',
    lt_total_clicks: 'คลิกทั้งหมด',
    lt_referral_link_banner: 'ลิงก์แนะนำ และแบนเนอร์',
    lt_link_to_promote: 'ลิงก์สำหรับโปรโมท',
    lt_copy_referral_link: 'คัดลอกลิงก์แนะนำ',
    lt_share_to_facebook: 'แชร์ไปเฟสบุ๊ค',
    lt_share_to_line: 'แชร์ไปไลน์',
    lt_note_excl: 'หมายเหตุ!',
    lt_link_banned_text: 'ลิงก์ถูกแบนจาก google, facebook หรือช่องทางอื่นๆ',
    lt_send_referral_to_line: 'ให้ส่งลิงก์แนะนำเพื่อนของท่านมายังทางไลน์ พร้อมระบุปัญหา',
    lt_for_new_referral_link: 'สำหรับรับลิงก์ใหม่ในการแนะนำเพื่อน',
    lt_product: 'สินค้า',
    lt_share_percent: 'ส่วนแบ่ง %',
    lt_all_lotto_paren: 'หวยทั้งหมด (หวย)',
    lt_slot: 'สล็อต',
    lt_casino: 'คาสิโน',
    lt_note: 'หมายเหตุ',
    lt_share_is_max_per_type: 'ส่วนแบ่งในการแนะนำจะเป็นค่าสูงสุดของแต่ละประเภทหวย',
    lt_share_help_link: 'ลิงก์ช่วยแชร์ ช่วยแนะนำ',
    lt_share_help_max: 'ลิงก์ช่วยแชร์รับสูงสุด',
    lt_just_copy_share_earn: '(เพียงก๊อปปี้ลิงก์ไปแชร์ก็ได้เงินแล้ว)',
    lt_more_share_more_earn: 'ยิ่งแชร์มากยิ่งได้มาก',
    lt_aff_desc1: 'ท่านสามารถนำลิงก์แนะนำนี้หรือนำป้ายแบนเนอร์ ไปแชร์ในช่องทางต่างๆ ไม่ว่าจะเป็น เว็บไชต์ส่วนตัว, Blog, Facebook หรือ Social Network อื่นๆ หากมีการสมัครสมาชิกโดยคลิกผ่านลิงก์ของท่านเข้ามา ลูกค้าที่สมัครเข้ามาก็จะอยู่ภายใต้เครือข่ายของท่านทันที และหากลูกค้าภายใต้เครือข่ายของท่านมีการเดิมพันเข้ามา ทุกยอดการเดิมพัน ท่านจะได้รับส่วนแบ่งในการแนะนำสูงสุด 8% ทันทีโดยไม่มีเงื่อนไข',
    lt_aff_note_rate: 'ส่วนแบ่งในการแนะนำอาจจะมีอัตราแตกต่างกันไปในหวยแต่ละประเภท',
    lt_aff_example: 'ตัวอย่างดังนี้',
    lt_aff_ex1: 'ลูกค้าท่าน 1 คน แทง 1,000 บาท ท่านจะได้ 8%',
    lt_aff_ex2: 'ลูกค้าท่าน 10 คน แทง 1,000 บาท ท่านจะได้รับ 8%',
    lt_aff_ex3: 'ลูกค้าท่าน 100 คน แทง 1,000 บาท ท่านจะได้รับ 8%',
    lt_aff_desc2: 'สามารถทำรายได้หลัก 100,000 บาทต่อเดือนได้ง่ายๆ เพราะทางเรามีหวยเปิดรับทายผลทุกวัน มีมากกว่าวันละ 200 รอบ เปิดรับแทงออนไลน์ตลอด 24 ชม. และรายได้ทุกบาททุกสตางค์ของท่านสามารถตรวจสอบได้ทุกขั้นตอน งานนี้แจกจริง จ่ายจริง ที่นี่ที่เดียวที่ให้คุณมากกว่าใคร คัดลอกลิงก์แนะนำไปแชร์ได้เลย',
    lt_member_referred: 'สมาชิกที่แนะนำ',
    lt_datetime: 'วัน-เวลา',
    lt_registered_at: 'ที่สมัคร',
    lt_username: 'ยูสเซอร์เนม',
    lt_play_lotto_amount: 'ยอดเล่น หวย',
    lt_play_slot_amount: 'ยอดเล่น Slot',
    lt_hanoi_lotto: 'หวยฮานอย',
    lt_msg_confirm_delete_set: 'คุณแน่ใจนะว่าต้องการลบ เลขชุดนี้?',
    lt_msg_delete_success: 'ลบสำเร็จ',
    lt_msg_item_deleted: 'รายการถูกลบเรียบร้อยแล้ว!',
    lt_msg_cannot_delete: 'ไม่สามารถลบได้',
    lt_msg_error: 'เกิดข้อผิดพลาด!',
    lt_msg_error_title: 'ข้อผิดพลาด',
    lt_msg_cannot_delete_item: 'ไม่สามารถลบรายการนี้ได้!',
    lt_msg_confirm_return_poy: 'ยืนยันการคืนโพย',
    lt_msg_confirm_return_poy_text: 'คุณต้องการคืนโพยนี้ใช่หรือไม่? ยอดเงินจะถูกคืนให้ทันที',
    lt_msg_confirm_return_poy_btn: 'ยืนยัน คืนโพย',
    lt_msg_return_poy_success: 'คืนโพยสำเร็จ',
    lt_msg_return_poy_refunded: 'ยกเลิกโพยและคืนเงินเรียบร้อยแล้ว',
    lt_msg_return_poy_partial: 'ยกเลิกโพยเรียบร้อยแล้ว แต่การคืนเงินอาจใช้เวลาสักครู่ กรุณาตรวจสอบยอดเงินภายหลัง',
    lt_msg_ok: 'ตกลง',
    lt_msg_cannot_return_poy: 'ไม่สามารถคืนโพยได้',
    lt_msg_error_try_again: 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง',
    lt_msg_error_generic: 'เกิดข้อผิดพลาด',
    lt_msg_proceed_within_5min: 'กรุณาดำเนินการภายใน 5 นาที',
    lt_msg_min_withdraw_50: 'ขั้นต่ำในการถอน 50 บาท',
    lt_msg_error_try_again2: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
    lt_msg_mobile_link_unavailable: 'ลิงก์มือถือไม่พร้อมใช้งาน',
    lt_msg_game_link_unavailable: 'ลิงก์เกมไม่พร้อมใช้งาน',
    lt_msg_link_unavailable: 'ลิงก์ไม่พร้อมใช้งาน',
    lt_msg_enter_coupon: 'กรุณากรอก Code Coupon',
    lt_msg_not_logged_in: 'คุณไม่ได้ล๊อคอิน',
    lt_msg_invalid_token: 'Token ไม่ถูกต้อง',
    lt_msg_user_not_found: 'ไม่พบข้อมูลผู้ใช้',
    lt_msg_password_incomplete: 'Password คุณไม่ครบ 6 ตัวโปรดตรวจสอบ',
    lt_msg_no_phone: 'คุณไม่ทำการใส่ เบอร์โทรศัพท์',
    lt_msg_wrong_phone: 'คุณใส่เบอร์ผิดพลาด',
    lt_msg_otp_mismatch: 'รหัสยืนยันไม่ตรงกัน',
    lt_msg_pass_max15: 'พาสเวิดสูงสุดไม่เกิน 15 ตัว',
    lt_msg_pass_min6: 'พาสเวิดไม่น้อยกว่า 6 ตัว',
    lt_msg_register_error: 'เกิดข้อผิดพลาดในการลงทะเบียน',
    lt_msg_phone_in_use: 'เบอร์นี้มีคนใช้แล้ว',
    lt_msg_otp_send_error: 'เกิดข้อผิดพลาดในการส่ง OTP',
    lt_msg_otp_limit: 'ไม่สามารถขอ OTP ได้แล้ว คุณสามารถขอใหม่ได้หลังจาก 10 นาที',
    lt_msg_otp_wait_5min: 'อีก 5 นาทีสามารถทำรายการไหม่ได้',
    lt_lotto_short: 'หวย',
    lt_slot_casino: 'สล็อต/คาสิโน',
    lt_play_casino_amount: 'ยอดเล่น Casino',
    lt_play_sport_amount: 'ยอดเล่น Sport',
    lt_deposit_amount: 'ยอดเติม',
    lt_withdraw_amount: 'ยอดถอน',
    lt_select_month: 'เลือกเดือน',
    lt_total_month: 'ยอดรวม (เดือน)',
    lt_report_withdraw_income: 'แจ้งถอนรายได้',
    lt_income_credit_note: 'รายได้ ระบบแนะนำ จะถอนเข้าเป็นเงินเครดิต',
    lt_contact_agent_note: 'หากสงสัยโปรดติดต่อเอเย่นต์ที่ท่านสมัครสมาชิก',
    lt_current_income_remaining: 'รายได้ปัจจุบัน - คงเหลือ',
    lt_no_income: 'ไม่มียอดรับ',
    lt_receiving_credit: 'กำลังรับเครดิต...',
    lt_receive_credit: 'รับเครดิต',
    lt_recent_receive_history: 'ประวัติการการรับล่าสุด',
    lt_calculated_at: 'ที่คำนวณ',
    lt_amount_calculated: 'จำนวนที่คำนวณ',
    lt_loss_rebate: 'คืนยอดเสีย',
    lt_loss_rebate_condition: 'เงื่อนไขคืนยอดเสีย',
    lt_loss_rebate_percent: 'เปอเซนต์ยอดเสียที่คืน:',
    lt_loss_rebate_this_month: 'คืนยอดเสียสะสมเดือนนี้',
    lt_current_withdraw_amount: 'ยอดถอนปัจจุบัน',
    lt_loss_rebate_percent_label: 'เปอเซนต์ยอดเสียที่คืน',
    lt_loss_rebate_percent_max: 'เปอเซนต์ยอดเสียที่คืนสูงสุด',
    lt_loss_rebate_formula: 'เงื่อนไข ฝาก - ถอน = เปอร์ฺเซ็น * ยอดคำนวณ',
    lt_play_loss_get_back: 'เล่นเสียได้คืน',
    lt_loss_rebate_desc: 'หากท่านเล่นเสีย ท่านจะได้รับเงินคืนตามเปอร์เซ็นต์ที่กำหนด และสามารถถอนออกเป็นเครดิตได้',
    lt_final_decision_note: 'คำตัดสินของบริษัทถือเป็นที่สิ้นสุด',
    lt_report_receive_loss: 'แจ้งรับยอดเสีย',
    lt_loss_credit_note: 'ยอดเสีย ระบบคืนยอดเสีย จะถอนเข้าเป็นเงินเครดิต',
    lt_current_amount_remaining: 'ยอดปัจจุบัน - คงเหลือ',
    lt_recent_loss_history: 'ประวัติการรับยอดเสียล่าสุด',
    lt_minigame: 'มินิเกม',
    lt_number_set_detail: 'รายละเอียดเลขชุด',
    lt_delete_this_item: 'ลบรายการนี้',
    lt_set_name: 'ชื่อชุด',
    lt_created_at: 'สร้างเมื่อ',
    lt_number_set: 'ชุดตัวเลข',
    lt_notification_msg: 'ข้อความแจ้งเตือน',
    lt_confirm_delete_set: 'คุณแน่ใจนะว่าต้องการลบ เลขชุดนี้ ?',
    lt_profile: 'โปรไฟล์',
    lt_manage_password: 'จัดการรหัสผ่าน',
    lt_password_note: 'หมายเหตุ: กรณีจำรหัสผ่านปัจจุบันไม่ได้ กรุณาติดต่อแอดมิน ทางไลน์',
    lt_old_password: 'รหัสผ่านเดิม',
    lt_new_password: 'รหัสผ่านใหม่',
    lt_confirm_new_password: 'ยืนยันรหัสผ่านใหม่',
    lt_change_password: 'เปลี่ยนรหัสผ่าน',
    lt_deposit_withdraw_status: 'สถานะ ฝาก-ถอนเงิน',
    lt_report_deposit_withdraw: 'แจ้งปัญหาฝาก / ถอน',
    lt_deposit_short: 'ฝาก',
    lt_withdraw_short: 'ถอน',
    lt_click_item_for_detail: '*คลิกที่รายการเพื่อดูรายละเอียดเพิ่มเติม',
    lt_deposit_credit: 'ฝากเครดิต',
    lt_withdraw_credit: 'ถอนเครดิต',
    lt_bonus: 'โบนัส',
    lt_status: 'สถานะ',
    lt_processing: 'กำลังดำเนินการ',
    lt_pending: 'รอดำเนินการ',
    lt_cancelled_by_player: 'ยกเลิก (ยกเลิกโดยผู้เล่น)',
    lt_failed_by_system: 'ไม่สำเร็จ (โดยระบบ)',
    lt_success_status: 'สำเร็จ',
    lt_transaction_no: 'เลขที่รายการ',
    lt_remaining: 'คงเหลือ',
    lt_note_colon: 'หมายเหตุ:',
    lt_topup_by_user: 'เติมเงินโดยผู้ใช้งาน',
    lt_play_game: 'เล่นเกม',
    lt_bet_lotto2: 'แทงหวย',
    lt_system: 'ระบบ',
    lt_financial_report2: 'รายงานการเงิน',
    lt_click_item_history_3days: '*คลิกที่รายการเพื่อดูรายละเอียดเพิ่มเติม - รายการย้อนหลังไม่เกิน 3 วัน',
    lt_prize_result: 'ผลรางวัล',
    lt_search_lotto_name: 'ค้นหาชื่อหวย',
    lt_search_lotto_ph: 'พิมพ์ชื่อหวย, รหัสหวย หรือรอบหวย',
    lt_no_lotto_found: 'ไม่พบข้อมูลหวยที่ค้นหา',
    lt_foreign_lotto_group: 'กลุ่มหวยต่างประเทศ',
    lt_online_lotto_group: 'กลุ่มหวยออนไลน์',
    lt_stock_lotto_group: 'กลุ่มหวยหุ้น',
    lt_special_stock_lotto_group: 'กลุ่มหวยหุ้นพิเศษ',
    lt_past_results: 'ผลย้อนหลัง',
    lt_how_to_deposit: 'วิธีฝากเงิน',
    lt_image: 'รูปภาพ',
    lt_video: 'วีดีโอ',
    lt_how_to_buy_lotto: 'วิธีซื้อหวย',
    lt_how_to_change_password: 'วิธีการเปลี่ยนรหัสผ่าน',
    lt_change_password_short: 'เปลี่ยนรหัสผ่าน',
    lt_deposit_money: 'ฝากเงิน',
    lt_how_to_register2: 'วิธีการสมัครสมาชิก',
    lt_register_member: 'สมัครสมาชิก',
    lt_forgot_password_title: 'หากลืมรหัสผ่าน',
    lt_how_to_catch_win: 'วิธีการจับวิน',
    lt_catch_win: 'จับวิน',
    lt_how_to_bet_rood: 'วิธีการแทงรูด',
    lt_bet_rood: 'แทงรูด',
    lt_how_to_deposit_decimal: 'วิธีการฝากเงินระบบทศนิยม',
    lt_boss: 'เถ้าแก่',
    lt_bank_account_title: 'บัญชีธนาคาร',
    lt_usable_bank_account: 'บัญชีธนาคารที่สามารถใช้ได้',
    lt_game: 'เกม',
    lt_wheel: 'กงล้อ',
    lt_checkin: 'เชคอิน',
    lt_open_card: 'เปิดไพ่',
    lt_search_game_name: 'ค้นหารายชื่อเกม',
    lt_upload_slip: 'อัพโหลด Slip',
    lt_upload_slip_only: 'อัพโหลดเฉพาะภาพ Slip',
    lt_upload: 'อัปโหลด',
    lt_confirm_upload: 'ยืนยันการอัพโหลด',
    lt_upload_slip_success: 'อัปโหลดสลิปสำเร็จแล้ว',
    lt_username_account: 'ชื่อผู้ใช้งาน',
    lt_select_transaction_channel: 'กรุณาเลือกช่องทางธุรกรรม',
    lt_amount_only_numbers_ph: 'ระบุเฉพาะตัวเลข',
    lt_company_pleased: 'บริษัทมีความยินดีเป็นอย่างยิ่งที่ได้รับใช้ท่าน',
    lt_terms_intro: 'เพื่อให้ท่านทราบถึงสิทธิประโยชน์ของสมาชิกกรุณาอ่านข้อตกลงอย่างละเอียดก่อนที่จะลงทะเบียนสมัครเป็นสมาชิกและใช้บริการ',
    lt_terms_accept_intro: 'เมื่อสมัครสมาชิกแล้วทางเว็บจะถือว่า สมาชิกได้อ่านและยอมรับ',
    lt_terms_policy: '" นโยบายและเงื่อนไขการให้บริการของเว็บไซต์"',
    lt_terms_h_benefit: 'การรักษาผลประโยชน์และช่วยเหลือการเดิมพันออนไลน์',
    lt_terms_b1: 'ถ้าสมาชิกหลุดออกจากเว็บไซต์ระหว่างการเดิมพัน บัญชีของท่านจะไม่มีผลกระทบต่อผลลัพธ์ของการเดิมพัน',
    lt_terms_b2a: 'ไม่ต้องวิตกกังวล ถ้าสมาชิกออกจากเว็บไซด์ระหว่างการเดิมพัน สมาชิกจะถูกออกจากระบบช่วงเวลาหนึ่ง จากนั้นสมาชิกสามารถเข้าสู่ระบบ',
    lt_terms_b2b: 'ได้อีกครั้งตามปกติ',
    lt_terms_h_protect: 'การให้ความคุ้มครอง',
    lt_terms_protect1: 'ได้มีการจัดเตรียม ระบบที่มีประสิทธิภาพ ความรวดเร็วและการบริการลูกค้าที่เป็นมิตร ถ้าหากท่านมีคำถามหรือคำแนะนำใด ๆ กรุณาอย่าลังเลใจที่จะโทรศัพท์มาทางฝ่ายบริการลูกค้า ซึ่งจะมีให้บริการตลอด 24 ชั่วโมง ทุกวันไม่มีวันหยุดและทางเราจะตอบกลับอย่างรวดเร็วที่สุด',
    lt_terms_protect2: 'ขอรับรองว่าจะรักษาข้อมูลส่วนตัวของท่านไว้เป็นความลับอย่างปลอดภัย',
    lt_terms_h_bet: 'ข้อตกลงในการเดิมพัน',
    lt_terms_bet1: 'เพื่อหลีกเลี่ยงปัญหาต่างๆในขณะที่ใช้งานเว็บไซต์ สมาชิกกรุณาอ่านกฎกติกาของบริษัทอย่างละเอียดและระมัดระวัง เมื่อสมาชิกเข้าสู่หน้าเดิมพันทางบริษัทจะถือว่าท่านได้ยอมรับข้อตกลงของทาง',
    lt_terms_bet2a: 'การเดิมพันจะต้องอยู่ใน',
    lt_terms_period: '"ระยะเวลาที่กำหนด"',
    lt_terms_bet2b: 'มิฉะนั้นจะถือว่าการเดิมครั้งนั้นเป็น',
    lt_terms_void: '"โมฆะ"',
    lt_terms_bet2c: 'ถ้าการเดิมพันได้มีการยกเลิกหรือหยุดพักชั่วคราว เนื่องจากเหตุผลใดๆก็ตามก่อนการเล่น การเดิมพันครั้งนั้นจะถือว่าเป็น',
    lt_terms_bet2d: 'และทางบริษัทจะคืนเครดิตให้กับสมาชิก',
    lt_terms_bet3a: 'เป็นความรับผิดชอบของสมาชิกที่จะคอยดูผลลัพธ์ จากช่องหน้าต่างที่แสดงให้เห็นถึงผลการเดิมพันแพ้หรือชนะ ทางบริษัทจะยึดถือข้อมูล',
    lt_terms_bet_detail: '"รายละเอียดการวางเดิมพัน"',
    lt_terms_bet3b: 'ของสมาชิก ในกรณีที่สมาชิกมีความสงสัย และต้องการตรวจสอบข้อมูลในการคำนวณของการเดิมพันนั้นๆ',
    lt_terms_bet4: 'ถ้าหากเกิดความผิดพลาดของระบบระหว่างการเดิมพันหรือความผิดพลาดโดยไม่ได้เจตนาของพนักงาน ทางบริษัทขอสงวนสิทธ์ที่จะแก้ไขผลลัพธ์ให้ถูกต้อง และจะมีการพิมพ์ข้อความที่ได้มีการแก้ไขเผยแพร่ไว้ที่แถบตัววิ่งในหน้าเว็บไซต์ บริษัทจะไม่มีการแจ้งสมาชิกเป็นการส่วนตัว',
    lt_terms_bet5: 'เป็นความรับชอบของสมาชิกที่จะทำให้แน่ใจว่าชื่อผู้ใช้และรหัสผ่านสำหรับเข้าเว็บไซต์นั้นถูกต้อง และกรุณาเปลี่ยนรหัสผ่านของสมาชิกอย่างน้อยเดือนละครั้ง เพื่อความปลอดภัย ถ้าหากท่านพบหรือสงสัยว่ามีผู้อื่นได้เข้าไปเล่นในบัญชีของท่านโดยไม่รับอนุญาต กรุณา แจ้งตัวแทนของท่านทันทีเพื่อเปลี่ยนรหัสส่วนตัว (หากมีการเดิมพันก่อนที่จะเปลี่ยนรหัสเดิมจะถือว่าการเดิมพันนั้นเป็นผล)',
    lt_terms_bet6: 'ก่อนเริ่มการเดิมพันแต่ละครั้ง ท่านสมาชิกควรจะตรวจสอบวงเงินของท่านเสียก่อน ถ้าหากท่านมีข้อสงสัยใดๆ เกี่ยวกับวงเงิน กรุณาแจ้งตัวแทนของท่านสมาชิกทันที',
    lt_terms_bet7: 'ในกรณีที่เหตุการณ์ไม่คาดคิดเกิดขึ้น อย่างเช่น ข้อมูลสูญหายเนื่องจากระบบอินเตอร์เน็ตขัดข้อง ทางบริษัทจะมีการประกาศให้รู้ถึงสาเหตุ และวิธีการแก้ปัญหา',
    lt_terms_bet8: 'ชั่วโมงการให้บริการ 24 ชั่วโมง/วัน และไม่มีวันหยุด',
    lt_terms_bet9: 'กรณีตรวจพบการใช้ตั้งแต่ 1 ยูสเซอร์ขึ้นไปเพื่อแทงทบ, แทงหวย 2 ตัว เกิน 50 หมายเลข/แทงหวย 3 ตัว เกิน 250 หมายเลข ต่อหวยงวดนั้นๆ ไม่ว่าจะแยกหรือรวมบิล หรือทางบริษัทตัดสินแล้วว่าการเดิมพันผิดปกติ ทางบริษัทมีสิทธิ์ในการระงับการใช้งานและยึดเครดิตของสมาชิกโดยไม่ต้องแจ้งล่วงหน้า',
    lt_terms_bet10: 'คำตัดสินของบริษัทถือเป็นที่สิ้นสุด',
    lt_terms_h_security: 'ระบบการรักษาความปลอดภัย',
    lt_terms_sec1: 'ข้อมูลทางด้านบัญชีเพื่อวัตถุประสงค์เฉพาะบุคคล ข้อมูลที่ทางสมาชิกให้มาในการเปิดบัญชีจะถูกเก็บเป็นความลับขั้นสูงสุด ทางบริษัทจะไม่เผยแพร่ข้อมูลนี้ให้กับบุคคลที่สามหรือองค์กรอื่นๆ ล่วงรู้ ไม่ว่าจะเป็นบัญชีอีเมล์ หรือข้อมูลอื่นๆ ที่ทางสมาชิกกรอกในใบสมัคร ข้อมูลเหล่านี้จะใช้ในจุดมุ่งหมายที่ตั้งใจเอาไว้เท่านั้น เช่น การส่งเช็คเงินสดสำหรับผู้ชนะหรือข้อมูลอื่นๆ ตามที่สมาชิกร้องขอ',
    lt_terms_sec2: 'ความปลอดภัยทางบริษัทได้ใช้วิธีที่มีประสิทธิภาพมากที่สุดเพื่อทำให้ท่านแน่ใจในความปลอดภัยของข้อมูลของท่าน ทางเราจะพยายามให้ดีที่สุดที่จะรักษาความถูกต้องแน่นอน และความลับเฉพาะของข้อมูล เพื่อป้องกันไม่ให้ข้อมูลรั่วไหลหรือนำไปใช้อย่างไม่ถูกต้อง ถ้าท่านมีข้อสงสัยใดๆ ที่เกี่ยวข้องกับการรักษาความลับ ความปลอดภัยของข้อมูล กรุณาติดต่อฝ่ายบริการลูกค้า พวกเรายินดีให้บริการ 24 ชั่วโมง/วัน ทุกวันไม่มีวันหยุด',
  },
  en: {
    lt_bet_lotto: 'Bet Lotto',
    lt_lotto_result: 'Lotto Results',
    lt_poy: 'Bet Slip',
    lt_fill_code: 'Enter Code',
    lt_create_number_set: 'Create Number Set',
    lt_check_lotto: 'Check Lotto',
    lt_lucky_numbers_group: 'Lucky Numbers Group',
    lt_lotto_schedule_soon: 'Upcoming Lotto Schedule',
    lt_bet_now: 'Bet Now',
    lt_games: 'Games',
    lt_financial_report: 'Financial Report',
    lt_deposit_withdraw_list: 'Deposit / Withdraw List',
    lt_report_deposit_withdraw_problem: 'Report Deposit / Withdraw Issue',
    lt_sport: 'Sports',
    lt_casino_online: 'Online Casino',
    lt_wheel_games: 'Wheel Games',
    lt_rules: 'Rules',
    lt_register_via_admin: 'Register via Admin',
    lt_forgot_password: 'Forgot Password',
    lt_check_lotto_result: 'Check Lotto Results',
    lt_latest_lotto_result: 'Latest Lotto Results',
    lt_fill_coupon_code: 'Enter coupon code',
    lt_how_to_bet_lotto: 'How to Bet Lotto',
    lt_report_problem_24hr: 'Report Issue 24h',
    lt_today_bet_amount: "Today's Bets",
    lt_total: 'Total',
    lt_result_announced: 'Result Announced',
    lt_result_pending: 'Pending Result',
    lt_today_list: "Today's List",
    lt_all_lotto: 'All Lotto',
    lt_all_history: 'All History',
    lt_poy_short: 'Slip',
    lt_not_announced_yet: 'Pending Result',
    lt_previous: 'Previous',
    lt_poy_number: 'Slip No.',
    lt_stake: 'Stake',
    lt_win_lose: 'Win / Lose',
    lt_no_items: 'No items',
    lt_poy_detail: 'Slip Detail',
    lt_return_poy: 'Cancel Slip',
    lt_round_date: 'Round / Date',
    lt_win_loss_result: 'Win / Loss',
    lt_order_no: 'No.',
    lt_won: 'Won',
    lt_not_won: 'Not Won',
    lt_winning_number: 'Winning Number',
    lt_payout_rate: 'Payout Rate',
    lt_bet_price: 'Bet Amount',
    lt_day: 'Day',
    lt_hour: 'Hour',
    lt_minute: 'Min',
    lt_second: 'Sec',
    lt_welcome_marquee: 'Welcome everyone to Salmon168, the hottest online lottery site right now',
    lt_thai_lotto: 'Thai Lotto',
    lt_thai_lotto_group: 'Thai Lotto Group',
    lt_back_home: 'Home',
    lt_go_back: 'Back',
    lt_latest_update: 'Latest Update',
    lt_or: 'or',
    lt_register_via_admin_short: 'Register via Admin',
    lt_specify_phone: 'Enter Phone Number',
    lt_register_phone: 'Register Phone Number',
    lt_enter_phone_ph: 'Enter phone number',
    lt_enter_phone_verify: 'Please enter your phone number for identity verification',
    lt_enter_captcha: 'Please enter the 4 characters in the image',
    lt_confirm_phone: 'Verify Phone Number',
    lt_enter_sms_code: 'Please enter the code received from SMS in the blanks',
    lt_request_otp_again_5min: 'You can request an OTP again in 5 minutes',
    lt_enter_otp_within_5min: 'Please enter the code the system sent to your phone within 5 minutes',
    lt_send_code_to_phone: 'Code sent to',
    lt_resend_otp: 'Resend OTP',
    lt_create_account: 'Create Account',
    lt_username_label: 'Username',
    lt_password_label: 'Password',
    lt_confirm_password_label: 'Confirm Password',
    lt_confirm_password_ph: 'Enter password again',
    lt_select_known_channel: 'Select how you knew the site',
    lt_add_bank_account: 'Add Bank Account',
    lt_select_bank: 'Select Bank',
    lt_please_select_bank: 'Please select a bank',
    lt_account_name_label: 'Account Name',
    lt_account_name_ph: 'Name - Surname on the bankbook',
    lt_account_no_label: 'Account Number',
    lt_numbers_only_ph: 'Numbers only',
    lt_confirm_account_no: 'Confirm Account Number',
    lt_confirm_account_no_ph: 'Confirm account number again',
    lt_add_account: 'Add Account',
    lt_next: 'Next',
    lt_skip_verify: 'Skip Verification',
    lt_confirm_otp: 'Confirm OTP',
    lt_already_member: 'Already a member',
    lt_phone_already_used: 'This number is already in use',
    lt_phone: 'Number',
    lt_phone_has_account: 'already has an account',
    lt_please_register_new_phone: 'Please register with a new number, or',
    lt_reset_password_if_forgot: 'reset your password if you forgot it',
    lt_register_new_phone: 'Register with a new number',
    lt_reset_password: 'Reset Password',
    lt_choose_contact_channel: 'Choose a way to contact us',
    lt_contact_via_line: 'Contact via Line',
    lt_live_chat_with_staff: 'Live chat with staff',
    lt_unmute: 'Unmute',
    lt_mute: 'Mute',
    lt_rules_title: 'Rules & Regulations',
    lt_welcome_lotto_online: 'Welcome to Online Lottery',
    lt_payout_rate_title: 'Payout Rate',
    lt_i_understand_accept: 'I understand and accept',
    lt_account_settings: 'Account Settings',
    lt_bank_account: 'Bank Account',
    lt_how_to_use: 'How to Use',
    lt_help_center: 'Help Center',
    lt_lucky_numbers_daily: "Today's Lucky Numbers",
    lt_how_to_register: 'How to Register',
    lt_register_steps: 'Registration Steps',
    lt_register_via_admin_alt: 'Register via Admin',
    lt_admin_help_register: 'Let the admin help you register',
    lt_prize_1: '1st Prize',
    lt_two_down: 'Last 2 Digits',
    lt_three_front: 'First 3 Digits',
    lt_three_down: 'Last 3 Digits',
    lt_three_up: 'Top 3 Digits',
    lt_foreign_lotto: 'Foreign Lotto',
    lt_online_lotto: 'Online Lotto',
    lt_foreign_stock_lotto: 'Foreign Stock Lotto',
    lt_special_stock_lotto: 'Special Stock Lotto',
    lt_stock_lotto: 'Stock Lotto',
    lt_stock_lotto_vip: 'Stock Lotto VIP',
    lt_popular_lotto: 'Popular Lotto',
    lt_result_rooms: 'Result Rooms',
    lt_showing_result: 'Showing Results',
    lt_countdown_hot_lotto: 'Hot Lotto Countdown',
    lt_thai_gov_lotto: 'Thai Government Lotto',
    lt_live_chat: 'Live Chat',
    lt_teach_usage: 'How-To Guide',
    lt_install_app: 'Install APP',
    lt_lao_tonight: 'Laos Tonight Lotto',
    lt_balance_remaining: 'Remaining Balance',
    lt_lotto_soon: 'Upcoming Lotto',
    lt_close_at: 'Closes',
    lt_survey: 'Survey',
    lt_survey_q: 'How did you hear about our website?',
    lt_install_app2: 'Install App',
    lt_boss_gives_luck: 'Boss Brings Luck',
    lt_browser_not_support: 'Browser not supported. Please follow these steps',
    lt_play_history: 'Play History',
    lt_detail: 'Detail',
    lt_transaction_time: 'Transaction Time',
    lt_provider: 'Provider',
    lt_ticket_no: 'Ticket No.',
    lt_event: 'Event',
    lt_brought_forward: 'Brought Forward',
    lt_credit: 'Credit',
    lt_balance: 'Balance',
    lt_report_credit_deposit: 'Report Credit Deposit',
    lt_customer_bank_account: "Customer's Bank Account",
    lt_select_transfer_channel: 'Select transfer method',
    lt_transaction_channel: 'Transaction Channel',
    lt_please_select_channel: 'Please select a transaction channel',
    lt_payment_gateway: 'Payment Gateway',
    lt_selected: 'Selected',
    lt_amount_to_transfer: 'Amount to transfer (whole number)',
    lt_min_max_amount_ph: 'Min: 20.00 / Max: 500,000.00',
    lt_continue: 'Continue',
    lt_transfer_to_add_credit: 'Transfer to add credit',
    lt_bank: 'Bank',
    lt_use_this_account_only: '***Please use this account for transfer only***',
    lt_web_bank_account: "Website's Bank Account",
    lt_report_transfer: 'Report Transfer',
    lt_uploading_slip: 'Uploading slip...',
    lt_amount_must_transfer: 'Amount to transfer:',
    lt_check_account_before_transfer: 'Note: Please verify the account number before every transfer',
    lt_transfer_within_5min: 'Please transfer within: 5 minutes',
    lt_report_withdraw: 'Report Withdrawal',
    lt_select_your_bank_account: 'Select your bank account',
    lt_select_account_below: '*Please select the account below as you wish',
    lt_withdrawable_amount: 'Withdrawable Amount',
    lt_some_locked_minbet: 'Part of your wallet balance may be locked for minimum betting',
    lt_withdraw_cond1: '- Customers must wager 10% of the deposit and have no pending promotion turnover to withdraw all credit',
    lt_withdraw_cond2: '- For lottery bets, the system counts turnover only for lotteries that have already drawn',
    lt_withdraw_cond3: '- Minimum withdrawal 100 Baht',
    lt_search_product_name: 'Search product name',
    lt_not_accepting_yet: 'Not accepting bets',
    lt_time_expired: 'Time Expired',
    lt_payout_rate_short: 'Payout',
    lt_rules_short: 'Rules',
    lt_open_88_rounds: 'Open 88 rounds',
    lt_24hr: '24 hrs.',
    lt_draw_date: 'Draw Date',
    lt_time_left: 'Time Left',
    lt_open_betting: 'Open for Betting',
    lt_lotto_4d: 'Lotto 4D',
    lt_yeekee: 'Yeekee',
    lt_not_accepting: 'Not Accepting',
    lt_waiting_accept: 'Awaiting Acceptance',
    lt_not_drawn_yet: 'Not Drawn Yet',
    lt_waiting_result: 'Awaiting Result',
    lt_pays: 'pays',
    lt_min_bet_per_time: 'Min bet per round',
    lt_max_bet_per_time: 'Max bet per round',
    lt_history_stats: 'Past Statistics',
    lt_two_up: 'Top 2',
    lt_two_low: 'Bottom 2',
    lt_high: 'High',
    lt_low: 'Low',
    lt_even: 'Even',
    lt_odd: 'Odd',
    lt_bet_amount_of_selected_date: 'Bets for selected date',
    lt_select_date_range: 'Select date range',
    lt_from_date: 'From Date',
    lt_to_date: 'To Date',
    lt_start_ph: 'Start',
    lt_to_ph: 'To',
    lt_all: 'All',
    lt_today: 'Today',
    lt_yesterday: 'Yesterday',
    lt_last_7days: 'Last 7 Days',
    lt_last_30days: 'Last 30 Days',
    lt_date_label: 'Date',
    lt_date_colon: 'Date :',
    lt_select_date_ph: 'Select date',
    lt_today_list2: "Today's List",
    lt_bet_amount2: 'Bet Amount',
    lt_manage_number_set: 'Manage Number Sets',
    lt_show: 'Show',
    lt_items: 'items',
    lt_number_set_name: 'Number Set Name',
    lt_created_datetime: 'Created Date-Time',
    lt_manage: 'Manage',
    lt_delete: 'Delete',
    lt_coupon: 'Coupon',
    lt_refer_friend: 'Refer a Friend',
    lt_income: 'Income',
    lt_withdraw_income: 'Withdraw Income',
    lt_max_revenue_share: 'Max revenue share:',
    lt_current_income: 'Current Income',
    lt_referred_members: 'Referred Members',
    lt_total_bets: 'Total Bets',
    lt_total_clicks: 'Total Clicks',
    lt_referral_link_banner: 'Referral Link & Banner',
    lt_link_to_promote: 'Link to promote',
    lt_copy_referral_link: 'Copy referral link',
    lt_share_to_facebook: 'Share to Facebook',
    lt_share_to_line: 'Share to Line',
    lt_note_excl: 'Note!',
    lt_link_banned_text: 'the link is banned by Google, Facebook or other channels',
    lt_send_referral_to_line: 'send your referral link to our Line with the problem stated',
    lt_for_new_referral_link: 'to receive a new referral link',
    lt_product: 'Product',
    lt_share_percent: 'Share %',
    lt_all_lotto_paren: 'All Lotto (Lotto)',
    lt_slot: 'Slots',
    lt_casino: 'Casino',
    lt_note: 'Note',
    lt_share_is_max_per_type: 'The referral share is the maximum of each lottery type',
    lt_share_help_link: 'Share & Refer Link',
    lt_share_help_max: 'Share link gets max',
    lt_just_copy_share_earn: '(Just copy the link to share and earn money)',
    lt_more_share_more_earn: 'The more you share, the more you earn',
    lt_aff_desc1: 'You can share this referral link or banner across various channels, such as your personal website, blog, Facebook, or other social networks. If someone registers by clicking through your link, that customer immediately joins your network. And if customers in your network place bets, on every bet you will instantly receive a referral share of up to 8% with no conditions.',
    lt_aff_note_rate: 'The referral share rate may differ for each lottery type.',
    lt_aff_example: 'For example:',
    lt_aff_ex1: '1 customer bets 1,000 Baht, you get 8%',
    lt_aff_ex2: '10 customers bet 1,000 Baht, you receive 8%',
    lt_aff_ex3: '100 customers bet 1,000 Baht, you receive 8%',
    lt_aff_desc2: 'You can easily earn a main income of 100,000 Baht per month, because we have lotteries open for betting every day, more than 200 rounds a day, online betting 24 hours, and every Baht of your income can be verified at every step. This is the real deal, real payouts, only here giving you more than anyone. Copy the referral link and share it now.',
    lt_member_referred: 'Referred Members',
    lt_datetime: 'Date-Time',
    lt_registered_at: 'Registered',
    lt_username: 'Username',
    lt_play_lotto_amount: 'Lotto Play Amount',
    lt_play_slot_amount: 'Slot Play Amount',
    lt_hanoi_lotto: 'Hanoi Lotto',
    lt_msg_confirm_delete_set: 'Are you sure you want to delete this number set?',
    lt_msg_delete_success: 'Deleted Successfully',
    lt_msg_item_deleted: 'The item has been deleted!',
    lt_msg_cannot_delete: 'Cannot Delete',
    lt_msg_error: 'An error occurred!',
    lt_msg_error_title: 'Error',
    lt_msg_cannot_delete_item: 'Cannot delete this item!',
    lt_msg_confirm_return_poy: 'Confirm Slip Cancellation',
    lt_msg_confirm_return_poy_text: 'Do you want to cancel this slip? The amount will be refunded immediately.',
    lt_msg_confirm_return_poy_btn: 'Confirm Cancel Slip',
    lt_msg_return_poy_success: 'Slip Cancelled Successfully',
    lt_msg_return_poy_refunded: 'Slip cancelled and amount refunded successfully',
    lt_msg_return_poy_partial: 'Slip cancelled successfully, but the refund may take a moment. Please check your balance later.',
    lt_msg_ok: 'OK',
    lt_msg_cannot_return_poy: 'Cannot Cancel Slip',
    lt_msg_error_try_again: 'An error occurred. Please try again.',
    lt_msg_error_generic: 'An error occurred',
    lt_msg_proceed_within_5min: 'Please proceed within 5 minutes',
    lt_msg_min_withdraw_50: 'Minimum withdrawal is 50 Baht',
    lt_msg_error_try_again2: 'An error occurred. Please try again.',
    lt_msg_mobile_link_unavailable: 'Mobile link unavailable',
    lt_msg_game_link_unavailable: 'Game link unavailable',
    lt_msg_link_unavailable: 'Link unavailable',
    lt_msg_enter_coupon: 'Please enter a coupon code',
    lt_msg_not_logged_in: 'You are not logged in',
    lt_msg_invalid_token: 'Invalid token',
    lt_msg_user_not_found: 'User data not found',
    lt_msg_password_incomplete: 'Your password is not 6 characters, please check',
    lt_msg_no_phone: 'You did not enter a phone number',
    lt_msg_wrong_phone: 'You entered the wrong number',
    lt_msg_otp_mismatch: 'The verification code does not match',
    lt_msg_pass_max15: 'Password must not exceed 15 characters',
    lt_msg_pass_min6: 'Password must be at least 6 characters',
    lt_msg_register_error: 'An error occurred during registration',
    lt_msg_phone_in_use: 'This number is already in use',
    lt_msg_otp_send_error: 'An error occurred sending OTP',
    lt_msg_otp_limit: 'You can no longer request an OTP. You can request again after 10 minutes.',
    lt_msg_otp_wait_5min: 'You can make a request again in 5 minutes',
    lt_lotto_short: 'Lotto',
    lt_slot_casino: 'Slots/Casino',
    lt_play_casino_amount: 'Casino Play Amount',
    lt_play_sport_amount: 'Sport Play Amount',
    lt_deposit_amount: 'Deposit Amount',
    lt_withdraw_amount: 'Withdrawal Amount',
    lt_select_month: 'Select Month',
    lt_total_month: 'Total (Month)',
    lt_report_withdraw_income: 'Report Income Withdrawal',
    lt_income_credit_note: 'Referral system income will be withdrawn as credit',
    lt_contact_agent_note: 'If in doubt, please contact the agent you registered with',
    lt_current_income_remaining: 'Current Income - Remaining',
    lt_no_income: 'No income to receive',
    lt_receiving_credit: 'Receiving credit...',
    lt_receive_credit: 'Receive Credit',
    lt_recent_receive_history: 'Recent Receive History',
    lt_calculated_at: 'Calculated',
    lt_amount_calculated: 'Amount Calculated',
    lt_loss_rebate: 'Loss Rebate',
    lt_loss_rebate_condition: 'Loss Rebate Conditions',
    lt_loss_rebate_percent: 'Loss rebate percent:',
    lt_loss_rebate_this_month: 'Accumulated loss rebate this month',
    lt_current_withdraw_amount: 'Current Withdrawal Amount',
    lt_loss_rebate_percent_label: 'Loss Rebate Percent',
    lt_loss_rebate_percent_max: 'Max loss rebate percent',
    lt_loss_rebate_formula: 'Condition: Deposit - Withdraw = Percent * Calculated Amount',
    lt_play_loss_get_back: 'Lose and get it back',
    lt_loss_rebate_desc: 'If you lose, you will get a refund at the set percentage and can withdraw it as credit',
    lt_final_decision_note: "The company's decision is final",
    lt_report_receive_loss: 'Report Loss Receipt',
    lt_loss_credit_note: 'Loss rebate system amount will be withdrawn as credit',
    lt_current_amount_remaining: 'Current Amount - Remaining',
    lt_recent_loss_history: 'Recent Loss Receipt History',
    lt_minigame: 'Mini Game',
    lt_number_set_detail: 'Number Set Detail',
    lt_delete_this_item: 'Delete this item',
    lt_set_name: 'Set Name',
    lt_created_at: 'Created At',
    lt_number_set: 'Number Set',
    lt_notification_msg: 'Notification',
    lt_confirm_delete_set: 'Are you sure you want to delete this number set?',
    lt_profile: 'Profile',
    lt_manage_password: 'Manage Password',
    lt_password_note: 'Note: If you forgot your current password, please contact the admin via Line',
    lt_old_password: 'Old Password',
    lt_new_password: 'New Password',
    lt_confirm_new_password: 'Confirm New Password',
    lt_change_password: 'Change Password',
    lt_deposit_withdraw_status: 'Deposit-Withdrawal Status',
    lt_report_deposit_withdraw: 'Report Deposit / Withdrawal',
    lt_deposit_short: 'Deposit',
    lt_withdraw_short: 'Withdraw',
    lt_click_item_for_detail: '*Click an item for more details',
    lt_deposit_credit: 'Deposit Credit',
    lt_withdraw_credit: 'Withdraw Credit',
    lt_bonus: 'Bonus',
    lt_status: 'Status',
    lt_processing: 'Processing',
    lt_pending: 'Pending',
    lt_cancelled_by_player: 'Cancelled (by player)',
    lt_failed_by_system: 'Failed (by system)',
    lt_success_status: 'Success',
    lt_transaction_no: 'Transaction No.',
    lt_remaining: 'Remaining',
    lt_note_colon: 'Note:',
    lt_topup_by_user: 'Topped up by user',
    lt_play_game: 'Play Game',
    lt_bet_lotto2: 'Bet Lotto',
    lt_system: 'System',
    lt_financial_report2: 'Financial Report',
    lt_click_item_history_3days: '*Click an item for more details - history up to 3 days',
    lt_prize_result: 'Prize Results',
    lt_search_lotto_name: 'Search lotto name',
    lt_search_lotto_ph: 'Type lotto name, code or round',
    lt_no_lotto_found: 'No lotto found',
    lt_foreign_lotto_group: 'Foreign Lotto Group',
    lt_online_lotto_group: 'Online Lotto Group',
    lt_stock_lotto_group: 'Stock Lotto Group',
    lt_special_stock_lotto_group: 'Special Stock Lotto Group',
    lt_past_results: 'Past Results',
    lt_how_to_deposit: 'How to Deposit',
    lt_image: 'Image',
    lt_video: 'Video',
    lt_how_to_buy_lotto: 'How to Buy Lotto',
    lt_how_to_change_password: 'How to Change Password',
    lt_change_password_short: 'Change Password',
    lt_deposit_money: 'Deposit',
    lt_how_to_register2: 'How to Register',
    lt_register_member: 'Register',
    lt_forgot_password_title: 'If you forgot your password',
    lt_how_to_catch_win: 'How to Pick Win',
    lt_catch_win: 'Pick Win',
    lt_how_to_bet_rood: 'How to Bet Rood',
    lt_bet_rood: 'Bet Rood',
    lt_how_to_deposit_decimal: 'How to Deposit (decimal system)',
    lt_boss: 'Boss',
    lt_bank_account_title: 'Bank Account',
    lt_usable_bank_account: 'Usable bank account',
    lt_game: 'Game',
    lt_wheel: 'Wheel',
    lt_checkin: 'Check-in',
    lt_open_card: 'Open Card',
    lt_search_game_name: 'Search game name',
    lt_upload_slip: 'Upload Slip',
    lt_upload_slip_only: 'Upload slip image only',
    lt_upload: 'Upload',
    lt_confirm_upload: 'Confirm Upload',
    lt_upload_slip_success: 'Slip uploaded successfully',
    lt_username_account: 'Username',
    lt_select_transaction_channel: 'Please select a transaction channel',
    lt_amount_only_numbers_ph: 'Numbers only',
    lt_company_pleased: 'The company is very pleased to serve you',
    lt_terms_intro: 'So that you are aware of member benefits, please read the agreement carefully before registering as a member and using the services of',
    lt_terms_accept_intro: 'Once registered, the website will consider that the member has read and accepted',
    lt_terms_policy: '" the website\'s service policy and terms"',
    lt_terms_h_benefit: 'Protecting interests and assisting online betting',
    lt_terms_b1: 'If a member disconnects from the website during betting, your account will not affect the betting result',
    lt_terms_b2a: 'No need to worry. If a member exits the website during betting, the member will be logged out for a while, then the member can log in to',
    lt_terms_b2b: 'again as usual',
    lt_terms_h_protect: 'Providing protection',
    lt_terms_protect1: 'has prepared an efficient system, fast and friendly customer service. If you have any questions or suggestions, please do not hesitate to call our customer service, available 24 hours a day, every day with no holidays, and we will reply as quickly as possible',
    lt_terms_protect2: 'guarantees that your personal information will be kept safely confidential',
    lt_terms_h_bet: 'Betting Agreement',
    lt_terms_bet1: 'To avoid problems while using the website, members please read the company rules carefully. When a member enters the betting page, the company considers that you have accepted the agreement of',
    lt_terms_bet2a: 'Bets must be placed within',
    lt_terms_period: '"the specified time"',
    lt_terms_bet2b: 'otherwise that bet will be considered',
    lt_terms_void: '"void"',
    lt_terms_bet2c: 'If a bet is cancelled or temporarily suspended for any reason before the game, that bet will be considered',
    lt_terms_bet2d: 'and the company will refund the credit to the member',
    lt_terms_bet3a: 'It is the member\'s responsibility to watch the result from the window showing the win or loss of the bet. The company will rely on the data of',
    lt_terms_bet_detail: '"betting details"',
    lt_terms_bet3b: 'of the member, in case the member has doubts and wants to verify the data in the calculation of that bet',
    lt_terms_bet4: 'If a system error occurs during betting or an unintentional staff error, the company reserves the right to correct the result, and the corrected message will be printed on the running banner on the website. The company will not notify members personally',
    lt_terms_bet5: 'It is the member\'s responsibility to ensure the username and password for the website are correct, and please change your password at least once a month for security. If you find or suspect that someone else has accessed your account without permission, please notify your representative immediately to change the personal password (if a bet is placed before changing the password, that bet will be considered valid)',
    lt_terms_bet6: 'Before each bet, the member should check their balance first. If you have any doubts about the balance, please notify your representative immediately',
    lt_terms_bet7: 'In case of unexpected events, such as data loss due to internet failure, the company will announce the cause and the solution',
    lt_terms_bet8: 'Service hours 24 hours/day with no holidays',
    lt_terms_bet9: 'If usage of 1 or more accounts is detected for martingale betting, 2-digit lottery over 50 numbers / 3-digit lottery over 250 numbers per draw, whether split or combined bills, or the company judges the betting abnormal, the company has the right to suspend usage and seize the member\'s credit without prior notice',
    lt_terms_bet10: 'The company\'s decision is final',
    lt_terms_h_security: 'Security System',
    lt_terms_sec1: 'Account data is for individual purposes only. Data provided by the member when opening an account is kept top secret. The company will not disclose this data to third parties or other organizations, whether email accounts or other data filled in the application. This data is used only for the intended purpose, such as sending cash checks for winners or other data as requested by the member',
    lt_terms_sec2: 'For security, the company uses the most efficient methods to ensure the safety of your data. We will do our best to maintain accuracy and confidentiality of data, to prevent data leakage or misuse. If you have any doubts related to confidentiality and data security, please contact customer service. We are pleased to serve 24 hours/day, every day with no holidays',
  },
  zh: {
    lt_bet_lotto: '投注彩票',
    lt_lotto_result: '彩票结果',
    lt_poy: '投注单',
    lt_fill_code: '输入代码',
    lt_create_number_set: '创建号码组',
    lt_check_lotto: '查询彩票',
    lt_lucky_numbers_group: '幸运号码群',
    lt_lotto_schedule_soon: '即将开奖时间表',
    lt_bet_now: '立即投注',
    lt_games: '游戏',
    lt_financial_report: '财务报表',
    lt_deposit_withdraw_list: '存款/取款记录',
    lt_report_deposit_withdraw_problem: '存款/取款问题反馈',
    lt_sport: '体育',
    lt_casino_online: '在线娱乐场',
    lt_wheel_games: '转盘游戏',
    lt_rules: '规则',
    lt_register_via_admin: '通过客服注册',
    lt_forgot_password: '忘记密码',
    lt_check_lotto_result: '查询彩票结果',
    lt_latest_lotto_result: '最新彩票结果',
    lt_fill_coupon_code: '输入优惠码',
    lt_how_to_bet_lotto: '彩票投注方法',
    lt_report_problem_24hr: '24小时问题反馈',
    lt_today_bet_amount: '今日投注额',
    lt_total: '总额',
    lt_result_announced: '已开奖',
    lt_result_pending: '未开奖',
    lt_today_list: '今日记录',
    lt_all_lotto: '全部彩票',
    lt_all_history: '全部历史',
    lt_poy_short: '投注单',
    lt_not_announced_yet: '未开奖',
    lt_previous: '之前',
    lt_poy_number: '投注单号',
    lt_stake: '投注金额',
    lt_win_lose: '输/赢',
    lt_no_items: '暂无记录',
    lt_poy_detail: '投注单详情',
    lt_return_poy: '退单',
    lt_round_date: '场次/日期',
    lt_win_loss_result: '输赢结果',
    lt_order_no: '序号',
    lt_won: '中奖',
    lt_not_won: '未中奖',
    lt_winning_number: '开奖号码',
    lt_payout_rate: '赔付价',
    lt_bet_price: '投注价',
    lt_day: '天',
    lt_hour: '小时',
    lt_minute: '分',
    lt_second: '秒',
    lt_welcome_marquee: '欢迎各位光临 Salmon168，目前最火爆的在线彩票网站',
    lt_thai_lotto: '泰国彩票',
    lt_thai_lotto_group: '泰国彩票组',
    lt_back_home: '首页',
    lt_go_back: '返回',
    lt_latest_update: '最新更新',
    lt_or: '或',
    lt_register_via_admin_short: '通过客服注册',
    lt_specify_phone: '输入手机号码',
    lt_register_phone: '登记手机号码',
    lt_enter_phone_ph: '输入手机号码',
    lt_enter_phone_verify: '请输入手机号码以验证身份',
    lt_enter_captcha: '请输入图中的4个字符',
    lt_confirm_phone: '验证手机号码',
    lt_enter_sms_code: '请将短信收到的验证码填入空格',
    lt_request_otp_again_5min: '5分钟后可再次请求OTP',
    lt_enter_otp_within_5min: '请在5分钟内输入系统发送到您手机的验证码',
    lt_send_code_to_phone: '验证码发送至',
    lt_resend_otp: '重新发送OTP',
    lt_create_account: '创建账户',
    lt_username_label: '用户名',
    lt_password_label: '密码',
    lt_confirm_password_label: '确认密码',
    lt_confirm_password_ph: '再次输入密码',
    lt_select_known_channel: '选择您了解本站的渠道',
    lt_add_bank_account: '添加银行账户',
    lt_select_bank: '选择银行',
    lt_please_select_bank: '请选择银行',
    lt_account_name_label: '账户名',
    lt_account_name_ph: '存折上的姓名',
    lt_account_no_label: '账号',
    lt_numbers_only_ph: '仅限数字',
    lt_confirm_account_no: '确认账号',
    lt_confirm_account_no_ph: '再次确认账号',
    lt_add_account: '添加账户',
    lt_next: '下一步',
    lt_skip_verify: '跳过验证',
    lt_confirm_otp: '确认OTP',
    lt_already_member: '已是会员',
    lt_phone_already_used: '此号码已被使用',
    lt_phone: '号码',
    lt_phone_has_account: '已有账户',
    lt_please_register_new_phone: '请用新号码注册，或',
    lt_reset_password_if_forgot: '如忘记密码请重置密码',
    lt_register_new_phone: '用新号码注册',
    lt_reset_password: '重置密码',
    lt_choose_contact_channel: '选择联系我们的方式',
    lt_contact_via_line: '通过Line联系',
    lt_live_chat_with_staff: '与客服在线聊天',
    lt_unmute: '开启声音',
    lt_mute: '关闭声音',
    lt_rules_title: '规则与条款',
    lt_welcome_lotto_online: '欢迎来到在线彩票',
    lt_payout_rate_title: '赔付率',
    lt_i_understand_accept: '我已了解并接受',
    lt_account_settings: '账户设置',
    lt_bank_account: '银行账户',
    lt_how_to_use: '使用方法',
    lt_help_center: '帮助中心',
    lt_lucky_numbers_daily: '每日热门号码',
    lt_how_to_register: '注册方法',
    lt_register_steps: '注册步骤',
    lt_register_via_admin_alt: '通过客服注册',
    lt_admin_help_register: '让客服帮您注册',
    lt_prize_1: '一等奖',
    lt_two_down: '后2位',
    lt_three_front: '前3位',
    lt_three_down: '后3位',
    lt_three_up: '上3位',
    lt_foreign_lotto: '国外彩票',
    lt_online_lotto: '在线彩票',
    lt_foreign_stock_lotto: '国外股票彩票',
    lt_special_stock_lotto: '特别股票彩票',
    lt_stock_lotto: '股票彩票',
    lt_stock_lotto_vip: '股票彩票VIP',
    lt_popular_lotto: '热门彩票',
    lt_result_rooms: '结果房间',
    lt_showing_result: '显示结果',
    lt_countdown_hot_lotto: '热门彩票倒计时',
    lt_thai_gov_lotto: '泰国政府彩票',
    lt_live_chat: '在线聊天',
    lt_teach_usage: '使用教学',
    lt_install_app: '安装APP',
    lt_lao_tonight: '老挝今夜彩',
    lt_balance_remaining: '剩余余额',
    lt_lotto_soon: '即将开奖彩票',
    lt_close_at: '截止',
    lt_survey: '问卷调查',
    lt_survey_q: '您从哪个渠道了解到我们的网站？',
    lt_install_app2: '安装应用',
    lt_boss_gives_luck: '老板送好运',
    lt_browser_not_support: '浏览器不支持，请按以下步骤操作',
    lt_play_history: '游戏记录',
    lt_detail: '详情',
    lt_transaction_time: '交易时间',
    lt_provider: '提供商',
    lt_ticket_no: '票号',
    lt_event: '赛事',
    lt_brought_forward: '上期结余',
    lt_credit: '额度',
    lt_balance: '余额',
    lt_report_credit_deposit: '申请充值',
    lt_customer_bank_account: '客户银行账户',
    lt_select_transfer_channel: '选择转账方式',
    lt_transaction_channel: '交易渠道',
    lt_please_select_channel: '请选择交易渠道',
    lt_payment_gateway: 'Payment Gateway',
    lt_selected: '已选择',
    lt_amount_to_transfer: '要转账的金额（整数）',
    lt_min_max_amount_ph: '最低: 20.00 / 最高: 500,000.00',
    lt_continue: '继续',
    lt_transfer_to_add_credit: '转账充值',
    lt_bank: '银行',
    lt_use_this_account_only: '***请仅使用此账户转账***',
    lt_web_bank_account: '网站银行账户',
    lt_report_transfer: '申请转账',
    lt_uploading_slip: '正在上传凭证...',
    lt_amount_must_transfer: '需转账金额：',
    lt_check_account_before_transfer: '注意：每次转账前请核对账号',
    lt_transfer_within_5min: '请在5分钟内转账',
    lt_report_withdraw: '申请取款',
    lt_select_your_bank_account: '选择您的银行账户',
    lt_select_account_below: '*请按需选择下方账户',
    lt_withdrawable_amount: '可提款金额',
    lt_some_locked_minbet: '钱包中部分余额可能被锁定用于最低投注',
    lt_withdraw_cond1: '- 客户须有充值额10%的投注量且无促销流水，方可提取全部额度',
    lt_withdraw_cond2: '- 彩票投注时，系统仅计算已开奖彩票的投注量',
    lt_withdraw_cond3: '- 最低提款100泰铢',
    lt_search_product_name: '搜索产品名称',
    lt_not_accepting_yet: '尚未接受投注',
    lt_time_expired: '已截止',
    lt_payout_rate_short: '赔付',
    lt_rules_short: '规则',
    lt_open_88_rounds: '开88场',
    lt_24hr: '24小时',
    lt_draw_date: '开奖日期',
    lt_time_left: '剩余时间',
    lt_open_betting: '开放投注',
    lt_lotto_4d: '彩票4D',
    lt_yeekee: '一期彩',
    lt_not_accepting: '未接受投注',
    lt_waiting_accept: '等待接受',
    lt_not_drawn_yet: '尚未开奖',
    lt_waiting_result: '等待开奖',
    lt_pays: '赔付',
    lt_min_bet_per_time: '每场最低投注',
    lt_max_bet_per_time: '每场最高投注',
    lt_history_stats: '历史统计',
    lt_two_up: '上2位',
    lt_two_low: '下2位',
    lt_high: '大',
    lt_low: '小',
    lt_even: '双',
    lt_odd: '单',
    lt_bet_amount_of_selected_date: '所选日期的投注额',
    lt_select_date_range: '选择日期范围',
    lt_from_date: '起始日期',
    lt_to_date: '结束日期',
    lt_start_ph: '开始',
    lt_to_ph: '至',
    lt_all: '全部',
    lt_today: '今天',
    lt_yesterday: '昨天',
    lt_last_7days: '最近7天',
    lt_last_30days: '最近30天',
    lt_date_label: '日期',
    lt_date_colon: '日期 :',
    lt_select_date_ph: '选择日期',
    lt_today_list2: '今日记录',
    lt_bet_amount2: '投注额',
    lt_manage_number_set: '管理号码组',
    lt_show: '显示',
    lt_items: '条',
    lt_number_set_name: '号码组名称',
    lt_created_datetime: '创建日期时间',
    lt_manage: '管理',
    lt_delete: '删除',
    lt_coupon: '优惠券',
    lt_refer_friend: '推荐好友',
    lt_income: '收入',
    lt_withdraw_income: '提取收入',
    lt_max_revenue_share: '最高分成：',
    lt_current_income: '当前收入',
    lt_referred_members: '推荐会员',
    lt_total_bets: '总投注',
    lt_total_clicks: '总点击',
    lt_referral_link_banner: '推荐链接和横幅',
    lt_link_to_promote: '推广链接',
    lt_copy_referral_link: '复制推荐链接',
    lt_share_to_facebook: '分享到Facebook',
    lt_share_to_line: '分享到Line',
    lt_note_excl: '注意！',
    lt_link_banned_text: '链接被Google、Facebook或其他渠道封禁',
    lt_send_referral_to_line: '请将您的推荐链接连同问题发送到我们的Line',
    lt_for_new_referral_link: '以获取新的推荐链接',
    lt_product: '产品',
    lt_share_percent: '分成 %',
    lt_all_lotto_paren: '全部彩票（彩票）',
    lt_slot: '老虎机',
    lt_casino: '娱乐场',
    lt_note: '注意',
    lt_share_is_max_per_type: '推荐分成为各彩票类型的最高值',
    lt_share_help_link: '分享推荐链接',
    lt_share_help_max: '分享链接最高',
    lt_just_copy_share_earn: '（只需复制链接分享即可赚钱）',
    lt_more_share_more_earn: '分享越多赚得越多',
    lt_aff_desc1: '您可将此推荐链接或横幅分享到各种渠道，如个人网站、博客、Facebook 或其他社交网络。若有人通过您的链接点击注册，该客户将立即归入您的网络。若您网络下的客户进行投注，每笔投注您都将立即获得最高 8% 的推荐分成，无任何条件。',
    lt_aff_note_rate: '推荐分成比例可能因彩票类型而异。',
    lt_aff_example: '示例如下：',
    lt_aff_ex1: '1 位客户投注 1,000 泰铢，您可得 8%',
    lt_aff_ex2: '10 位客户投注 1,000 泰铢，您可得 8%',
    lt_aff_ex3: '100 位客户投注 1,000 泰铢，您可得 8%',
    lt_aff_desc2: '您可轻松实现每月 100,000 泰铢的主要收入，因为我们每天都有彩票开放投注，每天超过 200 场，24 小时在线投注，您的每一分收入都可在每个环节核实。真实派发，真实支付，唯此一家给您更多。立即复制推荐链接分享吧。',
    lt_member_referred: '推荐的会员',
    lt_datetime: '日期时间',
    lt_registered_at: '注册时间',
    lt_username: '用户名',
    lt_play_lotto_amount: '彩票投注额',
    lt_play_slot_amount: '老虎机投注额',
    lt_hanoi_lotto: '河内彩',
    lt_msg_confirm_delete_set: '您确定要删除此号码组吗？',
    lt_msg_delete_success: '删除成功',
    lt_msg_item_deleted: '项目已删除！',
    lt_msg_cannot_delete: '无法删除',
    lt_msg_error: '发生错误！',
    lt_msg_error_title: '错误',
    lt_msg_cannot_delete_item: '无法删除此项目！',
    lt_msg_confirm_return_poy: '确认退单',
    lt_msg_confirm_return_poy_text: '您要退此单吗？金额将立即退还。',
    lt_msg_confirm_return_poy_btn: '确认退单',
    lt_msg_return_poy_success: '退单成功',
    lt_msg_return_poy_refunded: '已取消投注单并退款成功',
    lt_msg_return_poy_partial: '投注单已取消，但退款可能需要片刻。请稍后查看余额。',
    lt_msg_ok: '确定',
    lt_msg_cannot_return_poy: '无法退单',
    lt_msg_error_try_again: '发生错误，请重试。',
    lt_msg_error_generic: '发生错误',
    lt_msg_proceed_within_5min: '请在5分钟内操作',
    lt_msg_min_withdraw_50: '最低提款50泰铢',
    lt_msg_error_try_again2: '发生错误，请重试。',
    lt_msg_mobile_link_unavailable: '手机链接不可用',
    lt_msg_game_link_unavailable: '游戏链接不可用',
    lt_msg_link_unavailable: '链接不可用',
    lt_msg_enter_coupon: '请输入优惠码',
    lt_msg_not_logged_in: '您尚未登录',
    lt_msg_invalid_token: '令牌无效',
    lt_msg_user_not_found: '未找到用户数据',
    lt_msg_password_incomplete: '您的密码不足6位，请检查',
    lt_msg_no_phone: '您未输入手机号码',
    lt_msg_wrong_phone: '您输入的号码有误',
    lt_msg_otp_mismatch: '验证码不匹配',
    lt_msg_pass_max15: '密码不得超过15位',
    lt_msg_pass_min6: '密码至少6位',
    lt_msg_register_error: '注册时发生错误',
    lt_msg_phone_in_use: '此号码已被使用',
    lt_msg_otp_send_error: '发送OTP时发生错误',
    lt_msg_otp_limit: '您无法再请求OTP。10分钟后可再次请求。',
    lt_msg_otp_wait_5min: '5分钟后可再次操作',
    lt_lotto_short: '彩票',
    lt_slot_casino: '老虎机/娱乐场',
    lt_play_casino_amount: '娱乐场投注额',
    lt_play_sport_amount: '体育投注额',
    lt_deposit_amount: '充值额',
    lt_withdraw_amount: '提款额',
    lt_select_month: '选择月份',
    lt_total_month: '总计（月）',
    lt_report_withdraw_income: '申请提取收入',
    lt_income_credit_note: '推荐系统收入将作为额度提取',
    lt_contact_agent_note: '如有疑问请联系您注册的代理',
    lt_current_income_remaining: '当前收入 - 余额',
    lt_no_income: '无可领取额',
    lt_receiving_credit: '正在领取额度...',
    lt_receive_credit: '领取额度',
    lt_recent_receive_history: '最近领取记录',
    lt_calculated_at: '计算时间',
    lt_amount_calculated: '计算金额',
    lt_loss_rebate: '亏损返还',
    lt_loss_rebate_condition: '亏损返还条件',
    lt_loss_rebate_percent: '亏损返还百分比：',
    lt_loss_rebate_this_month: '本月累计亏损返还',
    lt_current_withdraw_amount: '当前提款额',
    lt_loss_rebate_percent_label: '亏损返还百分比',
    lt_loss_rebate_percent_max: '最高亏损返还百分比',
    lt_loss_rebate_formula: '条件：存款 - 取款 = 百分比 * 计算金额',
    lt_play_loss_get_back: '亏损可返还',
    lt_loss_rebate_desc: '若您亏损，将按规定百分比获得返还，并可提取为额度',
    lt_final_decision_note: '公司的裁决为最终决定',
    lt_report_receive_loss: '申请领取亏损返还',
    lt_loss_credit_note: '亏损返还系统金额将作为额度提取',
    lt_current_amount_remaining: '当前金额 - 余额',
    lt_recent_loss_history: '最近亏损返还记录',
    lt_minigame: '小游戏',
    lt_number_set_detail: '号码组详情',
    lt_delete_this_item: '删除此项',
    lt_set_name: '组名',
    lt_created_at: '创建于',
    lt_number_set: '号码组',
    lt_notification_msg: '通知消息',
    lt_confirm_delete_set: '您确定要删除此号码组吗？',
    lt_profile: '个人资料',
    lt_manage_password: '管理密码',
    lt_password_note: '注意：如忘记当前密码，请通过Line联系客服',
    lt_old_password: '旧密码',
    lt_new_password: '新密码',
    lt_confirm_new_password: '确认新密码',
    lt_change_password: '修改密码',
    lt_deposit_withdraw_status: '存取款状态',
    lt_report_deposit_withdraw: '存款/取款问题反馈',
    lt_deposit_short: '存款',
    lt_withdraw_short: '取款',
    lt_click_item_for_detail: '*点击项目查看更多详情',
    lt_deposit_credit: '存入额度',
    lt_withdraw_credit: '提取额度',
    lt_bonus: '奖金',
    lt_status: '状态',
    lt_processing: '处理中',
    lt_pending: '等待处理',
    lt_cancelled_by_player: '已取消（玩家取消）',
    lt_failed_by_system: '失败（系统）',
    lt_success_status: '成功',
    lt_transaction_no: '交易号',
    lt_remaining: '余额',
    lt_note_colon: '备注：',
    lt_topup_by_user: '用户充值',
    lt_play_game: '玩游戏',
    lt_bet_lotto2: '投注彩票',
    lt_system: '系统',
    lt_financial_report2: '财务报表',
    lt_click_item_history_3days: '*点击项目查看更多详情 - 历史记录不超过3天',
    lt_prize_result: '开奖结果',
    lt_search_lotto_name: '搜索彩票名称',
    lt_search_lotto_ph: '输入彩票名称、代码或场次',
    lt_no_lotto_found: '未找到彩票',
    lt_foreign_lotto_group: '国外彩票组',
    lt_online_lotto_group: '在线彩票组',
    lt_stock_lotto_group: '股票彩票组',
    lt_special_stock_lotto_group: '特别股票彩票组',
    lt_past_results: '历史开奖',
    lt_how_to_deposit: '充值方法',
    lt_image: '图片',
    lt_video: '视频',
    lt_how_to_buy_lotto: '购买彩票方法',
    lt_how_to_change_password: '修改密码方法',
    lt_change_password_short: '修改密码',
    lt_deposit_money: '充值',
    lt_how_to_register2: '注册方法',
    lt_register_member: '注册',
    lt_forgot_password_title: '忘记密码时',
    lt_how_to_catch_win: '抓组方法',
    lt_catch_win: '抓组',
    lt_how_to_bet_rood: '拖注方法',
    lt_bet_rood: '拖注',
    lt_how_to_deposit_decimal: '小数充值方法',
    lt_boss: '老板',
    lt_bank_account_title: '银行账户',
    lt_usable_bank_account: '可用银行账户',
    lt_game: '游戏',
    lt_wheel: '转盘',
    lt_checkin: '签到',
    lt_open_card: '翻牌',
    lt_search_game_name: '搜索游戏名称',
    lt_upload_slip: '上传凭证',
    lt_upload_slip_only: '仅上传凭证图片',
    lt_upload: '上传',
    lt_confirm_upload: '确认上传',
    lt_upload_slip_success: '凭证上传成功',
    lt_username_account: '用户名',
    lt_select_transaction_channel: '请选择交易渠道',
    lt_amount_only_numbers_ph: '仅限数字',
    lt_company_pleased: '本公司非常荣幸为您服务',
    lt_terms_intro: '为使您了解会员权益，请在注册成为会员并使用服务前仔细阅读协议',
    lt_terms_accept_intro: '注册后，本网站将视为会员已阅读并接受',
    lt_terms_policy: '"网站服务政策与条款"',
    lt_terms_h_benefit: '保护权益及协助在线投注',
    lt_terms_b1: '若会员在投注期间与网站断线，您的账户不会影响投注结果',
    lt_terms_b2a: '无需担心。若会员在投注期间退出网站，会员将被登出一段时间，之后会员可再次登录',
    lt_terms_b2b: '如常使用',
    lt_terms_h_protect: '提供保障',
    lt_terms_protect1: '已准备高效的系统、快速且友好的客户服务。若您有任何问题或建议，请随时致电客服，每日24小时全天候服务，无休，我们将尽快回复',
    lt_terms_protect2: '保证将您的个人信息安全保密',
    lt_terms_h_bet: '投注协议',
    lt_terms_bet1: '为避免使用网站时出现问题，请会员仔细阅读公司规则。会员进入投注页面时，公司视为您已接受其协议',
    lt_terms_bet2a: '投注必须在',
    lt_terms_period: '"规定时间内"',
    lt_terms_bet2b: '否则该投注将被视为',
    lt_terms_void: '"无效"',
    lt_terms_bet2c: '若投注因任何原因在游戏前被取消或暂停，该投注将被视为',
    lt_terms_bet2d: '公司将向会员退还额度',
    lt_terms_bet3a: '会员有责任从显示输赢结果的窗口查看结果。公司将以以下数据为准',
    lt_terms_bet_detail: '"投注详情"',
    lt_terms_bet3b: '会员若有疑问并想核实该投注计算数据时',
    lt_terms_bet4: '若投注期间发生系统错误或员工无意错误，公司保留更正结果的权利，更正信息将在网站滚动栏发布。公司不会单独通知会员',
    lt_terms_bet5: '会员有责任确保登录网站的用户名和密码正确，并请至少每月更改一次密码以保安全。若您发现或怀疑他人未经许可进入您的账户，请立即通知您的代理更改个人密码（若在更改密码前已投注，该投注视为有效）',
    lt_terms_bet6: '每次投注前，会员应先检查余额。若您对余额有任何疑问，请立即通知您的代理',
    lt_terms_bet7: '若发生意外事件，如因网络故障导致数据丢失，公司将公布原因及解决方法',
    lt_terms_bet8: '服务时间每日24小时，无休',
    lt_terms_bet9: '若检测到使用1个或以上账户进行加倍投注、2位彩超过50个号码／3位彩超过250个号码每期，无论拆单或合单，或公司判定投注异常，公司有权在不事先通知的情况下暂停使用并没收会员额度',
    lt_terms_bet10: '公司的裁决为最终决定',
    lt_terms_h_security: '安全系统',
    lt_terms_sec1: '账户数据仅用于个人目的。会员开户时提供的数据将被严格保密。公司不会向第三方或其他组织透露此数据，无论是邮箱账户还是申请中填写的其他数据。这些数据仅用于预定目的，如向中奖者寄送现金支票或会员要求的其他数据',
    lt_terms_sec2: '为安全起见，公司采用最高效的方法确保您的数据安全。我们将尽力维护数据的准确性和保密性，以防数据泄露或滥用。若您对保密及数据安全有任何疑问，请联系客服。我们乐意每日24小时全天候服务，无休',
  },
  ja: {
    lt_bet_lotto: '宝くじを買う',
    lt_lotto_result: '宝くじ結果',
    lt_poy: 'ベットスリップ',
    lt_fill_code: 'コード入力',
    lt_create_number_set: '番号セット作成',
    lt_check_lotto: '宝くじ照会',
    lt_lucky_numbers_group: 'ラッキーナンバーグループ',
    lt_lotto_schedule_soon: '近日の宝くじスケジュール',
    lt_bet_now: '今すぐ買う',
    lt_games: 'ゲーム',
    lt_financial_report: '財務レポート',
    lt_deposit_withdraw_list: '入出金履歴',
    lt_report_deposit_withdraw_problem: '入出金トラブル報告',
    lt_sport: 'スポーツ',
    lt_casino_online: 'オンラインカジノ',
    lt_wheel_games: 'ルーレットゲーム',
    lt_rules: 'ルール',
    lt_register_via_admin: '管理者経由で登録',
    lt_forgot_password: 'パスワードを忘れた',
    lt_check_lotto_result: '宝くじ結果照会',
    lt_latest_lotto_result: '最新の宝くじ結果',
    lt_fill_coupon_code: 'クーポンコードを入力',
    lt_how_to_bet_lotto: '宝くじの買い方',
    lt_report_problem_24hr: '24時間トラブル報告',
    lt_today_bet_amount: '本日の投注額',
    lt_total: '合計',
    lt_result_announced: '抽選済み',
    lt_result_pending: '抽選待ち',
    lt_today_list: '本日の履歴',
    lt_all_lotto: 'すべての宝くじ',
    lt_all_history: 'すべての履歴',
    lt_poy_short: 'ベットスリップ',
    lt_not_announced_yet: '抽選待ち',
    lt_previous: '以前',
    lt_poy_number: 'スリップ番号',
    lt_stake: '賭け金',
    lt_win_lose: '勝敗',
    lt_no_items: '記録がありません',
    lt_poy_detail: 'スリップ詳細',
    lt_return_poy: 'スリップ取消',
    lt_round_date: '回/日付',
    lt_win_loss_result: '損益',
    lt_order_no: '番号',
    lt_won: '当選',
    lt_not_won: '落選',
    lt_winning_number: '抽選番号',
    lt_payout_rate: '払戻レート',
    lt_bet_price: '賭け額',
    lt_day: '日',
    lt_hour: '時間',
    lt_minute: '分',
    lt_second: '秒',
    lt_welcome_marquee: '皆様、Salmon168へようこそ。今最も人気のオンライン宝くじサイトです',
    lt_thai_lotto: 'タイ宝くじ',
    lt_thai_lotto_group: 'タイ宝くじグループ',
    lt_back_home: 'ホーム',
    lt_go_back: '戻る',
    lt_latest_update: '最新の更新',
    lt_or: 'または',
    lt_register_via_admin_short: '管理者経由で登録',
    lt_specify_phone: '電話番号を入力',
    lt_register_phone: '電話番号を登録',
    lt_enter_phone_ph: '電話番号を入力',
    lt_enter_phone_verify: '本人確認のため電話番号を入力してください',
    lt_enter_captcha: '画像の4文字を入力してください',
    lt_confirm_phone: '電話番号を確認',
    lt_enter_sms_code: 'SMSで受け取ったコードを空欄に入力してください',
    lt_request_otp_again_5min: '5分後に再度OTPを請求できます',
    lt_enter_otp_within_5min: 'システムが電話に送信したコードを5分以内に入力してください',
    lt_send_code_to_phone: 'コード送信先',
    lt_resend_otp: 'OTPを再送信',
    lt_create_account: 'アカウント作成',
    lt_username_label: 'ユーザー名',
    lt_password_label: 'パスワード',
    lt_confirm_password_label: 'パスワード確認',
    lt_confirm_password_ph: 'パスワードを再入力',
    lt_select_known_channel: 'サイトを知ったきっかけを選択',
    lt_add_bank_account: '銀行口座を追加',
    lt_select_bank: '銀行を選択',
    lt_please_select_bank: '銀行を選択してください',
    lt_account_name_label: '口座名義',
    lt_account_name_ph: '通帳の氏名',
    lt_account_no_label: '口座番号',
    lt_numbers_only_ph: '数字のみ',
    lt_confirm_account_no: '口座番号を確認',
    lt_confirm_account_no_ph: '口座番号を再確認',
    lt_add_account: '口座を追加',
    lt_next: '次へ',
    lt_skip_verify: '確認をスキップ',
    lt_confirm_otp: 'OTPを確認',
    lt_already_member: '既に会員です',
    lt_phone_already_used: 'この番号は既に使用されています',
    lt_phone: '番号',
    lt_phone_has_account: 'は既にアカウントがあります',
    lt_please_register_new_phone: '新しい番号で登録するか、',
    lt_reset_password_if_forgot: 'パスワードを忘れた場合はリセットしてください',
    lt_register_new_phone: '新しい番号で登録',
    lt_reset_password: 'パスワードをリセット',
    lt_choose_contact_channel: 'お問い合わせ方法を選択',
    lt_contact_via_line: 'Lineで連絡',
    lt_live_chat_with_staff: 'スタッフとライブチャット',
    lt_unmute: '音声オン',
    lt_mute: '音声オフ',
    lt_rules_title: 'ルールと規約',
    lt_welcome_lotto_online: 'オンライン宝くじへようこそ',
    lt_payout_rate_title: '払戻率',
    lt_i_understand_accept: '理解し同意します',
    lt_account_settings: 'アカウント設定',
    lt_bank_account: '銀行口座',
    lt_how_to_use: '使い方',
    lt_help_center: 'ヘルプセンター',
    lt_lucky_numbers_daily: '本日のラッキーナンバー',
    lt_how_to_register: '登録方法',
    lt_register_steps: '登録手順',
    lt_register_via_admin_alt: '管理者経由で登録',
    lt_admin_help_register: '管理者に登録を手伝ってもらう',
    lt_prize_1: '1等賞',
    lt_two_down: '下2桁',
    lt_three_front: '前3桁',
    lt_three_down: '下3桁',
    lt_three_up: '上3桁',
    lt_foreign_lotto: '海外宝くじ',
    lt_online_lotto: 'オンライン宝くじ',
    lt_foreign_stock_lotto: '海外株宝くじ',
    lt_special_stock_lotto: '特別株宝くじ',
    lt_stock_lotto: '株宝くじ',
    lt_stock_lotto_vip: '株宝くじVIP',
    lt_popular_lotto: '人気宝くじ',
    lt_result_rooms: '結果ルーム',
    lt_showing_result: '結果を表示',
    lt_countdown_hot_lotto: '人気宝くじカウントダウン',
    lt_thai_gov_lotto: 'タイ政府宝くじ',
    lt_live_chat: 'ライブチャット',
    lt_teach_usage: '使い方ガイド',
    lt_install_app: 'APPをインストール',
    lt_lao_tonight: 'ラオストゥナイト宝くじ',
    lt_balance_remaining: '残高',
    lt_lotto_soon: 'まもなくの宝くじ',
    lt_close_at: '締切',
    lt_survey: 'アンケート',
    lt_survey_q: '当サイトをどこで知りましたか？',
    lt_install_app2: 'アプリをインストール',
    lt_boss_gives_luck: 'ボスが幸運をくれる',
    lt_browser_not_support: 'ブラウザが対応していません。次の手順に従ってください',
    lt_play_history: 'プレイ履歴',
    lt_detail: '詳細',
    lt_transaction_time: '取引時間',
    lt_provider: 'プロバイダー',
    lt_ticket_no: 'チケット番号',
    lt_event: 'イベント',
    lt_brought_forward: '繰越額',
    lt_credit: 'クレジット',
    lt_balance: '残高',
    lt_report_credit_deposit: '入金申告',
    lt_customer_bank_account: 'お客様の銀行口座',
    lt_select_transfer_channel: '送金方法を選択',
    lt_transaction_channel: '取引チャネル',
    lt_please_select_channel: '取引チャネルを選択してください',
    lt_payment_gateway: 'Payment Gateway',
    lt_selected: '選択済み',
    lt_amount_to_transfer: '送金する金額（整数）',
    lt_min_max_amount_ph: '最低: 20.00 / 最高: 500,000.00',
    lt_continue: '続ける',
    lt_transfer_to_add_credit: '送金してクレジット追加',
    lt_bank: '銀行',
    lt_use_this_account_only: '***送金にはこの口座のみご利用ください***',
    lt_web_bank_account: 'サイトの銀行口座',
    lt_report_transfer: '送金申告',
    lt_uploading_slip: 'スリップをアップロード中...',
    lt_amount_must_transfer: '送金する金額：',
    lt_check_account_before_transfer: '注意：送金前に必ず口座番号を確認してください',
    lt_transfer_within_5min: '5分以内に送金してください',
    lt_report_withdraw: '出金申告',
    lt_select_your_bank_account: 'あなたの銀行口座を選択',
    lt_select_account_below: '*下の口座からご希望のものを選択してください',
    lt_withdrawable_amount: '出金可能額',
    lt_some_locked_minbet: 'ウォレット残高の一部は最低ベット用にロックされる場合があります',
    lt_withdraw_cond1: '- お客様は入金額の10%のベットが必要で、プロモーションの賭け条件が残っていない場合に全クレジットを出金できます',
    lt_withdraw_cond2: '- 宝くじベットの場合、システムは抽選済みの宝くじのみベット額を計算します',
    lt_withdraw_cond3: '- 最低出金額100バーツ',
    lt_search_product_name: '商品名を検索',
    lt_not_accepting_yet: '受付前',
    lt_time_expired: '締切',
    lt_payout_rate_short: '払戻',
    lt_rules_short: 'ルール',
    lt_open_88_rounds: '88回開催',
    lt_24hr: '24時間',
    lt_draw_date: '抽選日',
    lt_time_left: '残り時間',
    lt_open_betting: '投注受付中',
    lt_lotto_4d: '宝くじ4D',
    lt_yeekee: 'イーキー',
    lt_not_accepting: '受付不可',
    lt_waiting_accept: '受付待ち',
    lt_not_drawn_yet: '抽選前',
    lt_waiting_result: '抽選待ち',
    lt_pays: '払戻',
    lt_min_bet_per_time: '1回の最低ベット',
    lt_max_bet_per_time: '1回の最高ベット',
    lt_history_stats: '過去の統計',
    lt_two_up: '上2桁',
    lt_two_low: '下2桁',
    lt_high: '大',
    lt_low: '小',
    lt_even: '偶数',
    lt_odd: '奇数',
    lt_bet_amount_of_selected_date: '選択日のベット額',
    lt_select_date_range: '期間を選択',
    lt_from_date: '開始日',
    lt_to_date: '終了日',
    lt_start_ph: '開始',
    lt_to_ph: 'まで',
    lt_all: 'すべて',
    lt_today: '今日',
    lt_yesterday: '昨日',
    lt_last_7days: '過去7日間',
    lt_last_30days: '過去30日間',
    lt_date_label: '日付',
    lt_date_colon: '日付 :',
    lt_select_date_ph: '日付を選択',
    lt_today_list2: '本日の一覧',
    lt_bet_amount2: 'ベット額',
    lt_manage_number_set: '番号セット管理',
    lt_show: '表示',
    lt_items: '件',
    lt_number_set_name: '番号セット名',
    lt_created_datetime: '作成日時',
    lt_manage: '管理',
    lt_delete: '削除',
    lt_coupon: 'クーポン',
    lt_refer_friend: '友達紹介',
    lt_income: '収入',
    lt_withdraw_income: '収入を引き出す',
    lt_max_revenue_share: '最大収益シェア：',
    lt_current_income: '現在の収入',
    lt_referred_members: '紹介会員',
    lt_total_bets: '総ベット',
    lt_total_clicks: '総クリック',
    lt_referral_link_banner: '紹介リンクとバナー',
    lt_link_to_promote: '宣伝用リンク',
    lt_copy_referral_link: '紹介リンクをコピー',
    lt_share_to_facebook: 'Facebookでシェア',
    lt_share_to_line: 'Lineでシェア',
    lt_note_excl: '注意！',
    lt_link_banned_text: 'リンクがGoogle、Facebookなどでブロックされた',
    lt_send_referral_to_line: '紹介リンクと問題をLineに送ってください',
    lt_for_new_referral_link: '新しい紹介リンクを受け取るため',
    lt_product: '商品',
    lt_share_percent: 'シェア %',
    lt_all_lotto_paren: 'すべての宝くじ（宝くじ）',
    lt_slot: 'スロット',
    lt_casino: 'カジノ',
    lt_note: '注意',
    lt_share_is_max_per_type: '紹介シェアは各宝くじタイプの最大値です',
    lt_share_help_link: 'シェア・紹介リンク',
    lt_share_help_max: 'シェアリンクで最大',
    lt_just_copy_share_earn: '（リンクをコピーしてシェアするだけで稼げます）',
    lt_more_share_more_earn: 'シェアするほど稼げます',
    lt_aff_desc1: 'この紹介リンクやバナーを、個人サイト、ブログ、Facebook、その他のソーシャルネットワークなど様々なチャネルでシェアできます。あなたのリンク経由でクリックして登録した人は、すぐにあなたのネットワークに加わります。ネットワーク内の顧客がベットすると、すべてのベットで最大8%の紹介シェアを条件なしで即座に受け取れます。',
    lt_aff_note_rate: '紹介シェア率は宝くじの種類ごとに異なる場合があります。',
    lt_aff_example: '例：',
    lt_aff_ex1: '顧客1人が1,000バーツ賭けると、8%を受け取ります',
    lt_aff_ex2: '顧客10人が1,000バーツ賭けると、8%を受け取ります',
    lt_aff_ex3: '顧客100人が1,000バーツ賭けると、8%を受け取ります',
    lt_aff_desc2: '毎月10万バーツの主収入を簡単に得られます。当社は毎日宝くじをベット受付しており、1日200回以上、24時間オンラインベット可能で、あなたの収入は1バーツまで各段階で確認できます。本当に配布、本当に支払い、ここだけが他のどこよりも多くを提供します。今すぐ紹介リンクをコピーしてシェアしましょう。',
    lt_member_referred: '紹介した会員',
    lt_datetime: '日時',
    lt_registered_at: '登録日',
    lt_username: 'ユーザー名',
    lt_play_lotto_amount: '宝くじプレイ額',
    lt_play_slot_amount: 'スロットプレイ額',
    lt_hanoi_lotto: 'ハノイ宝くじ',
    lt_msg_confirm_delete_set: 'この番号セットを削除してもよろしいですか？',
    lt_msg_delete_success: '削除成功',
    lt_msg_item_deleted: '項目を削除しました！',
    lt_msg_cannot_delete: '削除できません',
    lt_msg_error: 'エラーが発生しました！',
    lt_msg_error_title: 'エラー',
    lt_msg_cannot_delete_item: 'この項目を削除できません！',
    lt_msg_confirm_return_poy: 'スリップ取消の確認',
    lt_msg_confirm_return_poy_text: 'このスリップを取り消しますか？金額はすぐに返金されます。',
    lt_msg_confirm_return_poy_btn: 'スリップ取消を確認',
    lt_msg_return_poy_success: 'スリップ取消成功',
    lt_msg_return_poy_refunded: 'スリップを取り消し、返金が完了しました',
    lt_msg_return_poy_partial: 'スリップを取り消しましたが、返金に少し時間がかかる場合があります。後で残高をご確認ください。',
    lt_msg_ok: 'OK',
    lt_msg_cannot_return_poy: 'スリップを取り消せません',
    lt_msg_error_try_again: 'エラーが発生しました。もう一度お試しください。',
    lt_msg_error_generic: 'エラーが発生しました',
    lt_msg_proceed_within_5min: '5分以内に手続きしてください',
    lt_msg_min_withdraw_50: '最低出金額は50バーツです',
    lt_msg_error_try_again2: 'エラーが発生しました。もう一度お試しください。',
    lt_msg_mobile_link_unavailable: 'モバイルリンクが利用できません',
    lt_msg_game_link_unavailable: 'ゲームリンクが利用できません',
    lt_msg_link_unavailable: 'リンクが利用できません',
    lt_msg_enter_coupon: 'クーポンコードを入力してください',
    lt_msg_not_logged_in: 'ログインしていません',
    lt_msg_invalid_token: 'トークンが無効です',
    lt_msg_user_not_found: 'ユーザーデータが見つかりません',
    lt_msg_password_incomplete: 'パスワードが6文字ではありません。確認してください',
    lt_msg_no_phone: '電話番号が入力されていません',
    lt_msg_wrong_phone: '番号が間違っています',
    lt_msg_otp_mismatch: '確認コードが一致しません',
    lt_msg_pass_max15: 'パスワードは15文字以内です',
    lt_msg_pass_min6: 'パスワードは6文字以上です',
    lt_msg_register_error: '登録中にエラーが発生しました',
    lt_msg_phone_in_use: 'この番号は既に使用されています',
    lt_msg_otp_send_error: 'OTP送信中にエラーが発生しました',
    lt_msg_otp_limit: 'これ以上OTPを請求できません。10分後に再度請求できます。',
    lt_msg_otp_wait_5min: '5分後に再度手続きできます',
    lt_lotto_short: '宝くじ',
    lt_slot_casino: 'スロット/カジノ',
    lt_play_casino_amount: 'カジノプレイ額',
    lt_play_sport_amount: 'スポーツプレイ額',
    lt_deposit_amount: '入金額',
    lt_withdraw_amount: '出金額',
    lt_select_month: '月を選択',
    lt_total_month: '合計（月）',
    lt_report_withdraw_income: '収入出金申告',
    lt_income_credit_note: '紹介システムの収入はクレジットとして出金されます',
    lt_contact_agent_note: 'ご不明な点は登録したエージェントにお問い合わせください',
    lt_current_income_remaining: '現在の収入 - 残高',
    lt_no_income: '受取額なし',
    lt_receiving_credit: 'クレジット受取中...',
    lt_receive_credit: 'クレジット受取',
    lt_recent_receive_history: '最近の受取履歴',
    lt_calculated_at: '計算日',
    lt_amount_calculated: '計算金額',
    lt_loss_rebate: '損失リベート',
    lt_loss_rebate_condition: '損失リベート条件',
    lt_loss_rebate_percent: '損失リベート率：',
    lt_loss_rebate_this_month: '今月の累計損失リベート',
    lt_current_withdraw_amount: '現在の出金額',
    lt_loss_rebate_percent_label: '損失リベート率',
    lt_loss_rebate_percent_max: '最大損失リベート率',
    lt_loss_rebate_formula: '条件：入金 - 出金 = パーセント * 計算金額',
    lt_play_loss_get_back: '負けても返金',
    lt_loss_rebate_desc: '損失した場合、規定の割合で返金を受け取り、クレジットとして出金できます',
    lt_final_decision_note: '当社の決定が最終となります',
    lt_report_receive_loss: '損失リベート受取申告',
    lt_loss_credit_note: '損失リベートシステムの金額はクレジットとして出金されます',
    lt_current_amount_remaining: '現在の金額 - 残高',
    lt_recent_loss_history: '最近の損失リベート受取履歴',
    lt_minigame: 'ミニゲーム',
    lt_number_set_detail: '番号セット詳細',
    lt_delete_this_item: 'この項目を削除',
    lt_set_name: 'セット名',
    lt_created_at: '作成日',
    lt_number_set: '番号セット',
    lt_notification_msg: '通知メッセージ',
    lt_confirm_delete_set: 'この番号セットを削除してもよろしいですか？',
    lt_profile: 'プロフィール',
    lt_manage_password: 'パスワード管理',
    lt_password_note: '注意：現在のパスワードを忘れた場合はLineで管理者にご連絡ください',
    lt_old_password: '旧パスワード',
    lt_new_password: '新パスワード',
    lt_confirm_new_password: '新パスワード確認',
    lt_change_password: 'パスワード変更',
    lt_deposit_withdraw_status: '入出金状況',
    lt_report_deposit_withdraw: '入出金トラブル報告',
    lt_deposit_short: '入金',
    lt_withdraw_short: '出金',
    lt_click_item_for_detail: '*項目をクリックして詳細を表示',
    lt_deposit_credit: 'クレジット入金',
    lt_withdraw_credit: 'クレジット出金',
    lt_bonus: 'ボーナス',
    lt_status: 'ステータス',
    lt_processing: '処理中',
    lt_pending: '保留中',
    lt_cancelled_by_player: 'キャンセル（プレイヤーによる）',
    lt_failed_by_system: '失敗（システムによる）',
    lt_success_status: '成功',
    lt_transaction_no: '取引番号',
    lt_remaining: '残高',
    lt_note_colon: '備考：',
    lt_topup_by_user: 'ユーザーによる入金',
    lt_play_game: 'ゲームプレイ',
    lt_bet_lotto2: '宝くじを買う',
    lt_system: 'システム',
    lt_financial_report2: '財務レポート',
    lt_click_item_history_3days: '*項目をクリックして詳細を表示 - 履歴は3日以内',
    lt_prize_result: '当選結果',
    lt_search_lotto_name: '宝くじ名を検索',
    lt_search_lotto_ph: '宝くじ名、コード、または回を入力',
    lt_no_lotto_found: '宝くじが見つかりません',
    lt_foreign_lotto_group: '海外宝くじグループ',
    lt_online_lotto_group: 'オンライン宝くじグループ',
    lt_stock_lotto_group: '株宝くじグループ',
    lt_special_stock_lotto_group: '特別株宝くじグループ',
    lt_past_results: '過去の結果',
    lt_how_to_deposit: '入金方法',
    lt_image: '画像',
    lt_video: '動画',
    lt_how_to_buy_lotto: '宝くじの買い方',
    lt_how_to_change_password: 'パスワード変更方法',
    lt_change_password_short: 'パスワード変更',
    lt_deposit_money: '入金',
    lt_how_to_register2: '登録方法',
    lt_register_member: '会員登録',
    lt_forgot_password_title: 'パスワードを忘れた場合',
    lt_how_to_catch_win: 'ウィン選択方法',
    lt_catch_win: 'ウィン選択',
    lt_how_to_bet_rood: 'ルードベット方法',
    lt_bet_rood: 'ルードベット',
    lt_how_to_deposit_decimal: '小数入金方法',
    lt_boss: 'ボス',
    lt_bank_account_title: '銀行口座',
    lt_usable_bank_account: '利用可能な銀行口座',
    lt_game: 'ゲーム',
    lt_wheel: 'ホイール',
    lt_checkin: 'チェックイン',
    lt_open_card: 'カードめくり',
    lt_search_game_name: 'ゲーム名を検索',
    lt_upload_slip: 'スリップをアップロード',
    lt_upload_slip_only: 'スリップ画像のみアップロード',
    lt_upload: 'アップロード',
    lt_confirm_upload: 'アップロードを確認',
    lt_upload_slip_success: 'スリップのアップロード成功',
    lt_username_account: 'ユーザー名',
    lt_select_transaction_channel: '取引チャネルを選択してください',
    lt_amount_only_numbers_ph: '数字のみ',
    lt_company_pleased: '当社はお客様にお仕えできることを大変光栄に思います',
    lt_terms_intro: '会員特典をご理解いただくため、会員登録およびサービス利用の前に契約を注意深くお読みください',
    lt_terms_accept_intro: '登録後、ウェブサイトは会員が以下を読み、受け入れたものとみなします',
    lt_terms_policy: '「ウェブサイトのサービスポリシーと規約」',
    lt_terms_h_benefit: '利益の保護とオンラインベットの支援',
    lt_terms_b1: '会員がベット中にウェブサイトから切断された場合、お客様のアカウントはベット結果に影響しません',
    lt_terms_b2a: 'ご心配なく。会員がベット中にウェブサイトを退出した場合、しばらくログアウトされ、その後再びログインできます',
    lt_terms_b2b: '通常通り再度',
    lt_terms_h_protect: '保護の提供',
    lt_terms_protect1: '効率的なシステム、迅速で親切なカスタマーサービスを用意しています。ご質問やご提案があれば、遠慮なくカスタマーサービスにお電話ください。24時間年中無休で対応し、できるだけ早くお返事します',
    lt_terms_protect2: 'お客様の個人情報を安全に機密に保つことを保証します',
    lt_terms_h_bet: 'ベット規約',
    lt_terms_bet1: 'ウェブサイト利用中の問題を避けるため、会員は会社の規則を注意深くお読みください。会員がベットページに入ると、会社はお客様が規約を受け入れたものとみなします',
    lt_terms_bet2a: 'ベットは以下の時間内に行う必要があります',
    lt_terms_period: '「指定された時間」',
    lt_terms_bet2b: 'そうでない場合、そのベットは次とみなされます',
    lt_terms_void: '「無効」',
    lt_terms_bet2c: 'ベットが何らかの理由でプレイ前にキャンセルまたは一時停止された場合、そのベットは次とみなされます',
    lt_terms_bet2d: '会社は会員にクレジットを返金します',
    lt_terms_bet3a: '勝敗を表示するウィンドウから結果を確認するのは会員の責任です。会社は以下のデータを基準とします',
    lt_terms_bet_detail: '「ベット詳細」',
    lt_terms_bet3b: '会員が疑問を持ち、そのベットの計算データを確認したい場合',
    lt_terms_bet4: 'ベット中にシステムエラーまたはスタッフの意図しないエラーが発生した場合、会社は結果を訂正する権利を留保し、訂正内容はウェブサイトのスクロールバーに掲載されます。会社は個別に会員に通知しません',
    lt_terms_bet5: 'ウェブサイトのユーザー名とパスワードが正しいことを確認するのは会員の責任です。安全のため少なくとも月1回パスワードを変更してください。他人が許可なくアカウントにアクセスしたと気づいたり疑った場合は、すぐに代理人に通知して個人パスワードを変更してください（パスワード変更前のベットは有効とみなされます）',
    lt_terms_bet6: '各ベットの前に、会員は残高を確認してください。残高に疑問がある場合は、すぐに代理人に通知してください',
    lt_terms_bet7: '予期しない事態、例えばインターネット障害によるデータ損失が発生した場合、会社は原因と解決方法を発表します',
    lt_terms_bet8: 'サービス時間24時間/日、年中無休',
    lt_terms_bet9: '1つ以上のアカウントでマーチンゲールベット、2桁宝くじ50番号超/3桁宝くじ250番号超を1回の抽選につき、伝票を分割または合算に関わらず使用が検出された場合、または会社がベットを異常と判断した場合、会社は事前通知なく利用停止し会員のクレジットを没収する権利があります',
    lt_terms_bet10: '会社の決定が最終となります',
    lt_terms_h_security: 'セキュリティシステム',
    lt_terms_sec1: 'アカウントデータは個人目的のみです。会員が口座開設時に提供したデータは最高機密として保管されます。会社はこのデータを第三者や他の組織に開示しません。メールアカウントや申請書に記入したその他のデータも同様です。これらのデータは、当選者への現金小切手の送付や会員の要求に応じたその他のデータなど、意図された目的のみに使用されます',
    lt_terms_sec2: 'セキュリティのため、会社はお客様のデータの安全を確保する最も効率的な方法を使用します。データの正確性と機密性を維持し、データ漏洩や誤用を防ぐため最善を尽くします。機密保持やデータセキュリティに関する疑問があれば、カスタマーサービスにお問い合わせください。24時間/日、年中無休で喜んで対応します',
  },
  my: {
    lt_bet_lotto: 'ထီထိုးရန်',
    lt_lotto_result: 'ထီရလဒ်',
    lt_poy: 'လောင်းကစားစလစ်',
    lt_fill_code: 'ကုဒ်ထည့်ပါ',
    lt_create_number_set: 'နံပါတ်အစုံ ဖန်တီးပါ',
    lt_check_lotto: 'ထီစစ်ဆေးရန်',
    lt_lucky_numbers_group: 'ကံကောင်းနံပါတ်အဖွဲ့',
    lt_lotto_schedule_soon: 'မကြာမီထီအချိန်ဇယား',
    lt_bet_now: 'ယခုထိုးပါ',
    lt_games: 'ဂိမ်းများ',
    lt_financial_report: 'ငွေကြေးအစီရင်ခံစာ',
    lt_deposit_withdraw_list: 'ငွေသွင်း/ထုတ် စာရင်း',
    lt_report_deposit_withdraw_problem: 'ငွေသွင်း/ထုတ် ပြဿနာတိုင်ကြားရန်',
    lt_sport: 'အားကစား',
    lt_casino_online: 'အွန်လိုင်းကာစီနို',
    lt_wheel_games: 'ဘီးလည်ဂိမ်းများ',
    lt_rules: 'စည်းမျဉ်းများ',
    lt_register_via_admin: 'အက်ဒမင်မှတဆင့် စာရင်းသွင်းရန်',
    lt_forgot_password: 'စကားဝှက်မေ့သွားသည်',
    lt_check_lotto_result: 'ထီရလဒ်စစ်ဆေးရန်',
    lt_latest_lotto_result: 'နောက်ဆုံးထီရလဒ်',
    lt_fill_coupon_code: 'ကူပွန်ကုဒ်ထည့်ပါ',
    lt_how_to_bet_lotto: 'ထီထိုးနည်း',
    lt_report_problem_24hr: 'ပြဿနာ ၂၄ နာရီ တိုင်ကြားရန်',
    lt_today_bet_amount: 'ယနေ့ထိုးငွေ',
    lt_total: 'စုစုပေါင်း',
    lt_result_announced: 'ရလဒ်ထွက်ပြီး',
    lt_result_pending: 'ရလဒ်မထွက်သေး',
    lt_today_list: 'ယနေ့စာရင်း',
    lt_all_lotto: 'ထီအားလုံး',
    lt_all_history: 'မှတ်တမ်းအားလုံး',
    lt_poy_short: 'လောင်းကစားစလစ်',
    lt_not_announced_yet: 'ရလဒ်မထွက်သေး',
    lt_previous: 'ယခင်',
    lt_poy_number: 'စလစ်နံပါတ်',
    lt_stake: 'လောင်းငွေ',
    lt_win_lose: 'အရှုံးအနိုင်',
    lt_no_items: 'စာရင်းမရှိပါ',
    lt_poy_detail: 'စလစ်အသေးစိတ်',
    lt_return_poy: 'စလစ်ပြန်အမ်း',
    lt_round_date: 'အကြိမ်/ရက်စွဲ',
    lt_win_loss_result: 'အရှုံးအမြတ်',
    lt_order_no: 'အစဉ်',
    lt_won: 'ဆုရ',
    lt_not_won: 'ဆုမရ',
    lt_winning_number: 'ထွက်နံပါတ်',
    lt_payout_rate: 'ပေးချေနှုန်း',
    lt_bet_price: 'ထိုးဈေး',
    lt_day: 'ရက်',
    lt_hour: 'နာရီ',
    lt_minute: 'မိနစ်',
    lt_second: 'စက္ကန့်',
    lt_welcome_marquee: 'Salmon168 သို့ အားလုံးကို ကြိုဆိုပါတယ်၊ လက်ရှိ အပူဆုံး အွန်လိုင်းထီဝဘ်ဆိုဒ်',
    lt_thai_lotto: 'ထိုင်းထီ',
    lt_thai_lotto_group: 'ထိုင်းထီအဖွဲ့',
    lt_back_home: 'ပင်မ',
    lt_go_back: 'ပြန်သွားရန်',
    lt_latest_update: 'နောက်ဆုံးအပ်ဒိတ်',
    lt_or: 'သို့မဟုတ်',
    lt_register_via_admin_short: 'အက်ဒမင်မှတဆင့် စာရင်းသွင်းရန်',
    lt_specify_phone: 'ဖုန်းနံပါတ် ထည့်ပါ',
    lt_register_phone: 'ဖုန်းနံပါတ် မှတ်ပုံတင်ပါ',
    lt_enter_phone_ph: 'ဖုန်းနံပါတ် ထည့်ပါ',
    lt_enter_phone_verify: 'အထောက်အထား အတည်ပြုရန် ဖုန်းနံပါတ် ထည့်ပါ',
    lt_enter_captcha: 'ပုံထဲက စာလုံး ၄ လုံး ထည့်ပါ',
    lt_confirm_phone: 'ဖုန်းနံပါတ် အတည်ပြုရန်',
    lt_enter_sms_code: 'SMS မှ ရရှိသော ကုဒ်ကို နေရာလွတ်တွင် ထည့်ပါ',
    lt_request_otp_again_5min: '၅ မိနစ်အကြာတွင် OTP ပြန်တောင်းနိုင်သည်',
    lt_enter_otp_within_5min: 'စနစ်မှ သင့်ဖုန်းသို့ ပို့သော ကုဒ်ကို ၅ မိနစ်အတွင်း ထည့်ပါ',
    lt_send_code_to_phone: 'ကုဒ်ပို့သည့်နံပါတ်',
    lt_resend_otp: 'OTP ပြန်ပို့ရန်',
    lt_create_account: 'အကောင့်ဖန်တီးရန်',
    lt_username_label: 'အသုံးပြုသူအမည်',
    lt_password_label: 'စကားဝှက်',
    lt_confirm_password_label: 'စကားဝှက် အတည်ပြုရန်',
    lt_confirm_password_ph: 'စကားဝှက် ထပ်ထည့်ပါ',
    lt_select_known_channel: 'ဝဘ်ဆိုဒ်ကို သိရှိသည့်နည်းလမ်း ရွေးပါ',
    lt_add_bank_account: 'ဘဏ်အကောင့် ထည့်ရန်',
    lt_select_bank: 'ဘဏ်ရွေးပါ',
    lt_please_select_bank: 'ဘဏ်ရွေးပါ',
    lt_account_name_label: 'အကောင့်အမည်',
    lt_account_name_ph: 'ဘဏ်စာအုပ်ပေါ်ရှိ အမည်',
    lt_account_no_label: 'အကောင့်နံပါတ်',
    lt_numbers_only_ph: 'ဂဏန်းသာ',
    lt_confirm_account_no: 'အကောင့်နံပါတ် အတည်ပြုရန်',
    lt_confirm_account_no_ph: 'အကောင့်နံပါတ် ထပ်အတည်ပြုပါ',
    lt_add_account: 'အကောင့်ထည့်ရန်',
    lt_next: 'ရှေ့သို့',
    lt_skip_verify: 'အတည်ပြုခြင်း ကျော်ရန်',
    lt_confirm_otp: 'OTP အတည်ပြုရန်',
    lt_already_member: 'အသင်းဝင်ဖြစ်ပြီးသား',
    lt_phone_already_used: 'ဤနံပါတ်ကို အသုံးပြုပြီးသား',
    lt_phone: 'နံပါတ်',
    lt_phone_has_account: 'အကောင့်ရှိပြီးသား',
    lt_please_register_new_phone: 'နံပါတ်အသစ်ဖြင့် စာရင်းသွင်းပါ သို့မဟုတ်',
    lt_reset_password_if_forgot: 'စကားဝှက်မေ့ပါက ပြန်လည်သတ်မှတ်ပါ',
    lt_register_new_phone: 'နံပါတ်အသစ်ဖြင့် စာရင်းသွင်းရန်',
    lt_reset_password: 'စကားဝှက် ပြန်သတ်မှတ်ရန်',
    lt_choose_contact_channel: 'ဆက်သွယ်ရန်နည်းလမ်း ရွေးပါ',
    lt_contact_via_line: 'Line မှ ဆက်သွယ်ရန်',
    lt_live_chat_with_staff: 'ဝန်ထမ်းနှင့် တိုက်ရိုက်ချတ်',
    lt_unmute: 'အသံဖွင့်',
    lt_mute: 'အသံပိတ်',
    lt_rules_title: 'စည်းမျဉ်းနှင့် စည်းကမ်း',
    lt_welcome_lotto_online: 'အွန်လိုင်းထီသို့ ကြိုဆိုပါသည်',
    lt_payout_rate_title: 'ပေးချေနှုန်း',
    lt_i_understand_accept: 'ကျွန်ုပ်နားလည်ပြီး လက်ခံပါသည်',
    lt_account_settings: 'အကောင့်ဆက်တင်',
    lt_bank_account: 'ဘဏ်အကောင့်',
    lt_how_to_use: 'အသုံးပြုနည်း',
    lt_help_center: 'အကူအညီစင်တာ',
    lt_lucky_numbers_daily: 'ယနေ့ ကံကောင်းနံပါတ်',
    lt_how_to_register: 'စာရင်းသွင်းနည်း',
    lt_register_steps: 'စာရင်းသွင်းခြင်း အဆင့်များ',
    lt_register_via_admin_alt: 'အက်ဒမင်မှတဆင့် စာရင်းသွင်းရန်',
    lt_admin_help_register: 'အက်ဒမင်က စာရင်းသွင်းပေးရန်',
    lt_prize_1: 'ပထမဆု',
    lt_two_down: 'အောက် ၂ လုံး',
    lt_three_front: 'ရှေ့ ၃ လုံး',
    lt_three_down: 'အောက် ၃ လုံး',
    lt_three_up: 'အပေါ် ၃ လုံး',
    lt_foreign_lotto: 'နိုင်ငံခြားထီ',
    lt_online_lotto: 'အွန်လိုင်းထီ',
    lt_foreign_stock_lotto: 'နိုင်ငံခြားစတော့ထီ',
    lt_special_stock_lotto: 'အထူးစတော့ထီ',
    lt_stock_lotto: 'စတော့ထီ',
    lt_stock_lotto_vip: 'စတော့ထီ VIP',
    lt_popular_lotto: 'လူကြိုက်များထီ',
    lt_result_rooms: 'ရလဒ်ခန်းများ',
    lt_showing_result: 'ရလဒ်ပြသခြင်း',
    lt_countdown_hot_lotto: 'လူကြိုက်များထီ ရေတွက်ချိန်',
    lt_thai_gov_lotto: 'ထိုင်းအစိုးရထီ',
    lt_live_chat: 'တိုက်ရိုက်ချတ်',
    lt_teach_usage: 'အသုံးပြုနည်းသင်ခန်းစာ',
    lt_install_app: 'APP ထည့်သွင်းရန်',
    lt_lao_tonight: 'လာအိုထီ ဒီည',
    lt_balance_remaining: 'လက်ကျန်ငွေ',
    lt_lotto_soon: 'မကြာမီထီ',
    lt_close_at: 'ပိတ်ချိန်',
    lt_survey: 'စစ်တမ်း',
    lt_survey_q: 'ကျွန်ုပ်တို့ဝဘ်ဆိုဒ်ကို ဘယ်နည်းလမ်းကနေ သိခဲ့သလဲ?',
    lt_install_app2: 'အက်ပ် ထည့်သွင်းရန်',
    lt_boss_gives_luck: 'သူဌေးက ကံပေး',
    lt_browser_not_support: 'ဘရောက်ဇာ မပံ့ပိုးပါ။ အောက်ပါအဆင့်များ လုပ်ဆောင်ပါ',
    lt_play_history: 'ကစားမှတ်တမ်း',
    lt_detail: 'အသေးစိတ်',
    lt_transaction_time: 'ငွေလွှဲချိန်',
    lt_provider: 'ဝန်ဆောင်မှုပေးသူ',
    lt_ticket_no: 'လက်မှတ်နံပါတ်',
    lt_event: 'ပွဲ',
    lt_brought_forward: 'လက်ကျန်ယူဆောင်',
    lt_credit: 'ခရက်ဒစ်',
    lt_balance: 'လက်ကျန်',
    lt_report_credit_deposit: 'ခရက်ဒစ်ဖြည့် တိုင်ကြားရန်',
    lt_customer_bank_account: 'ဖောက်သည်ဘဏ်အကောင့်',
    lt_select_transfer_channel: 'ငွေလွှဲနည်းလမ်း ရွေးပါ',
    lt_transaction_channel: 'ငွေလွှဲချန်နယ်',
    lt_please_select_channel: 'ငွေလွှဲချန်နယ် ရွေးပါ',
    lt_payment_gateway: 'Payment Gateway',
    lt_selected: 'ရွေးပြီး',
    lt_amount_to_transfer: 'လွှဲမည့်ငွေ (ဂဏန်းပြည့်)',
    lt_min_max_amount_ph: 'အနည်းဆုံး: 20.00 / အများဆုံး: 500,000.00',
    lt_continue: 'ဆက်လုပ်ရန်',
    lt_transfer_to_add_credit: 'ခရက်ဒစ်ဖြည့်ရန် ငွေလွှဲပါ',
    lt_bank: 'ဘဏ်',
    lt_use_this_account_only: '***ငွေလွှဲရန် ဤအကောင့်ကိုသာ အသုံးပြုပါ***',
    lt_web_bank_account: 'ဝဘ်ဆိုဒ်ဘဏ်အကောင့်',
    lt_report_transfer: 'ငွေလွှဲ တိုင်ကြားရန်',
    lt_uploading_slip: 'စလစ် တင်နေသည်...',
    lt_amount_must_transfer: 'လွှဲရမည့်ငွေ:',
    lt_check_account_before_transfer: 'မှတ်ချက်: ငွေလွှဲတိုင်း အကောင့်နံပါတ် စစ်ဆေးပါ',
    lt_transfer_within_5min: '၅ မိနစ်အတွင်း ငွေလွှဲပါ',
    lt_report_withdraw: 'ငွေထုတ် တိုင်ကြားရန်',
    lt_select_your_bank_account: 'သင့်ဘဏ်အကောင့် ရွေးပါ',
    lt_select_account_below: '*အောက်ပါအကောင့်များမှ လိုချင်သည်ကို ရွေးပါ',
    lt_withdrawable_amount: 'ထုတ်ယူနိုင်သောငွေ',
    lt_some_locked_minbet: 'ပိုက်ဆံအိတ်လက်ကျန်အချို့ အနည်းဆုံးထိုးခြင်းအတွက် လော့ခ်ချထားနိုင်သည်',
    lt_withdraw_cond1: '- ဖောက်သည်သည် ငွေသွင်းငွေ၏ ၁၀% ထိုးရမည်ဖြစ်ပြီး ပရိုမိုးရှင်းထိုးငွေ မကျန်မှသာ ခရက်ဒစ်အားလုံး ထုတ်ယူနိုင်သည်',
    lt_withdraw_cond2: '- ထီထိုးခြင်းအတွက် စနစ်သည် ရလဒ်ထွက်ပြီးထီကိုသာ ထိုးငွေအဖြစ် တွက်ချက်သည်',
    lt_withdraw_cond3: '- အနည်းဆုံးထုတ်ငွေ ၁၀၀ ဘတ်',
    lt_search_product_name: 'ကုန်ပစ္စည်းအမည် ရှာရန်',
    lt_not_accepting_yet: 'မထိုးရသေး',
    lt_time_expired: 'အချိန်ကုန်',
    lt_payout_rate_short: 'ပေးနှုန်း',
    lt_rules_short: 'စည်းကမ်း',
    lt_open_88_rounds: '၈၈ ကြိမ်ဖွင့်',
    lt_24hr: '၂၄ နာရီ',
    lt_draw_date: 'ထီထွက်ရက်',
    lt_time_left: 'ကျန်ချိန်',
    lt_open_betting: 'ထိုးခွင့်ဖွင့်',
    lt_lotto_4d: 'ထီ 4D',
    lt_yeekee: 'ယီကီ',
    lt_not_accepting: 'လက်မခံ',
    lt_waiting_accept: 'လက်ခံရန်စောင့်',
    lt_not_drawn_yet: 'ဆုမထွက်သေး',
    lt_waiting_result: 'ရလဒ်စောင့်',
    lt_pays: 'ပေး',
    lt_min_bet_per_time: 'တစ်ကြိမ်အနည်းဆုံးထိုး',
    lt_max_bet_per_time: 'တစ်ကြိမ်အများဆုံးထိုး',
    lt_history_stats: 'အတိတ်စာရင်းဇယား',
    lt_two_up: 'အပေါ် ၂ လုံး',
    lt_two_low: 'အောက် ၂ လုံး',
    lt_high: 'ကြီး',
    lt_low: 'ငယ်',
    lt_even: 'စုံ',
    lt_odd: 'မ',
    lt_bet_amount_of_selected_date: 'ရွေးချယ်သည့်ရက်၏ ထိုးငွေ',
    lt_select_date_range: 'ရက်အပိုင်းအခြား ရွေးပါ',
    lt_from_date: 'စတင်ရက်',
    lt_to_date: 'ပြီးဆုံးရက်',
    lt_start_ph: 'စတင်',
    lt_to_ph: 'အထိ',
    lt_all: 'အားလုံး',
    lt_today: 'ယနေ့',
    lt_yesterday: 'မနေ့က',
    lt_last_7days: 'နောက်ဆုံး ၇ ရက်',
    lt_last_30days: 'နောက်ဆုံး ၃၀ ရက်',
    lt_date_label: 'ရက်စွဲ',
    lt_date_colon: 'ရက်စွဲ :',
    lt_select_date_ph: 'ရက်စွဲ ရွေးပါ',
    lt_today_list2: 'ယနေ့စာရင်း',
    lt_bet_amount2: 'ထိုးငွေ',
    lt_manage_number_set: 'နံပါတ်အစုံ စီမံရန်',
    lt_show: 'ပြသ',
    lt_items: 'ခု',
    lt_number_set_name: 'နံပါတ်အစုံအမည်',
    lt_created_datetime: 'ဖန်တီးရက်/အချိန်',
    lt_manage: 'စီမံ',
    lt_delete: 'ဖျက်',
    lt_coupon: 'ကူပွန်',
    lt_refer_friend: 'သူငယ်ချင်းမိတ်ဆက်',
    lt_income: 'ဝင်ငွေ',
    lt_withdraw_income: 'ဝင်ငွေထုတ်ရန်',
    lt_max_revenue_share: 'အများဆုံးဝင်ငွေဝေစု:',
    lt_current_income: 'လက်ရှိဝင်ငွေ',
    lt_referred_members: 'မိတ်ဆက်အသင်းဝင်',
    lt_total_bets: 'ထိုးငွေစုစုပေါင်း',
    lt_total_clicks: 'ကလစ်စုစုပေါင်း',
    lt_referral_link_banner: 'မိတ်ဆက်လင့်နှင့် ဘန်နာ',
    lt_link_to_promote: 'ပရိုမိုးရန်လင့်',
    lt_copy_referral_link: 'မိတ်ဆက်လင့် ကူးယူရန်',
    lt_share_to_facebook: 'Facebook သို့ မျှဝေ',
    lt_share_to_line: 'Line သို့ မျှဝေ',
    lt_note_excl: 'မှတ်ချက်!',
    lt_link_banned_text: 'လင့်ကို Google, Facebook သို့မဟုတ် အခြားနည်းလမ်းမှ ပိတ်ဆို့',
    lt_send_referral_to_line: 'သင့်မိတ်ဆက်လင့်ကို ပြဿနာဖော်ပြ၍ Line သို့ ပို့ပါ',
    lt_for_new_referral_link: 'မိတ်ဆက်လင့်အသစ် ရရှိရန်',
    lt_product: 'ကုန်ပစ္စည်း',
    lt_share_percent: 'ဝေစု %',
    lt_all_lotto_paren: 'ထီအားလုံး (ထီ)',
    lt_slot: 'စလော့',
    lt_casino: 'ကာစီနို',
    lt_note: 'မှတ်ချက်',
    lt_share_is_max_per_type: 'မိတ်ဆက်ဝေစုသည် ထီအမျိုးအစားတစ်ခုစီ၏ အများဆုံးတန်ဖိုးဖြစ်သည်',
    lt_share_help_link: 'မျှဝေ/မိတ်ဆက်လင့်',
    lt_share_help_max: 'မျှဝေလင့်ဖြင့် အများဆုံး',
    lt_just_copy_share_earn: '(လင့်ကူး၍ မျှဝေရုံဖြင့် ငွေရသည်)',
    lt_more_share_more_earn: 'မျှဝေများလေ ရများလေ',
    lt_aff_desc1: 'ဤမိတ်ဆက်လင့် သို့မဟုတ် ဘန်နာကို ကိုယ်ပိုင်ဝဘ်ဆိုဒ်၊ ဘလော့ဂ်၊ Facebook သို့မဟုတ် အခြားဆိုရှယ်ကွန်ရက်များ စသည့် နည်းလမ်းအမျိုးမျိုးတွင် မျှဝေနိုင်သည်။ သင့်လင့်မှတဆင့် ကလစ်နှိပ်၍ စာရင်းသွင်းပါက ထိုဖောက်သည်သည် သင့်ကွန်ရက်အတွင်း ချက်ချင်းပါဝင်လာမည်။ သင့်ကွန်ရက်အတွင်းရှိ ဖောက်သည်များ လောင်းကစားပါက လောင်းကစားတိုင်းတွင် အများဆုံး ၈% မိတ်ဆက်ဝေစုကို ချက်ချင်း အခြေအနေမရှိ ရရှိမည်။',
    lt_aff_note_rate: 'မိတ်ဆက်ဝေစုနှုန်းသည် ထီအမျိုးအစားတစ်ခုစီအလိုက် ကွဲပြားနိုင်သည်။',
    lt_aff_example: 'ဥပမာ -',
    lt_aff_ex1: 'ဖောက်သည် ၁ ဦး ၁,၀၀၀ ဘတ်ထိုးပါက သင် ၈% ရမည်',
    lt_aff_ex2: 'ဖောက်သည် ၁၀ ဦး ၁,၀၀၀ ဘတ်ထိုးပါက သင် ၈% ရမည်',
    lt_aff_ex3: 'ဖောက်သည် ၁၀၀ ဦး ၁,၀၀၀ ဘတ်ထိုးပါက သင် ၈% ရမည်',
    lt_aff_desc2: 'တစ်လလျှင် အဓိကဝင်ငွေ ၁၀၀,၀၀၀ ဘတ်ကို လွယ်ကူစွာ ရှာနိုင်သည်။ ကျွန်ုပ်တို့တွင် နေ့စဉ် ထီထိုးခွင့်ဖွင့်ထားပြီး တစ်နေ့လျှင် ၂၀၀ ကြိမ်ကျော်၊ ၂၄ နာရီ အွန်လိုင်းထိုးခွင့်ရှိပြီး သင့်ဝင်ငွေ တစ်ဘတ်တိုင်းကို အဆင့်တိုင်းတွင် စစ်ဆေးနိုင်သည်။ တကယ်ဝေငှ၊ တကယ်ပေးချေ၊ ဤနေရာတစ်ခုတည်းသာ သင့်အား အခြားသူများထက် ပိုပေးသည်။ ယခုပင် မိတ်ဆက်လင့် ကူး၍ မျှဝေလိုက်ပါ။',
    lt_member_referred: 'မိတ်ဆက်ထားသောအသင်းဝင်',
    lt_datetime: 'ရက်/အချိန်',
    lt_registered_at: 'စာရင်းသွင်းချိန်',
    lt_username: 'အသုံးပြုသူအမည်',
    lt_play_lotto_amount: 'ထီထိုးငွေ',
    lt_play_slot_amount: 'စလော့ထိုးငွေ',
    lt_hanoi_lotto: 'ဟနွိုင်းထီ',
    lt_msg_confirm_delete_set: 'ဤနံပါတ်အစုံ ဖျက်ရန် သေချာပါသလား?',
    lt_msg_delete_success: 'ဖျက်ခြင်းအောင်မြင်',
    lt_msg_item_deleted: 'အရာကို ဖျက်ပြီးပါပြီ!',
    lt_msg_cannot_delete: 'ဖျက်၍မရပါ',
    lt_msg_error: 'အမှားဖြစ်ပွားသည်!',
    lt_msg_error_title: 'အမှား',
    lt_msg_cannot_delete_item: 'ဤအရာကို ဖျက်၍မရပါ!',
    lt_msg_confirm_return_poy: 'စလစ်ပြန်အမ်းခြင်း အတည်ပြုပါ',
    lt_msg_confirm_return_poy_text: 'ဤစလစ်ကို ပယ်ဖျက်လိုပါသလား? ငွေကို ချက်ချင်းပြန်အမ်းမည်။',
    lt_msg_confirm_return_poy_btn: 'စလစ်ပြန်အမ်း အတည်ပြုရန်',
    lt_msg_return_poy_success: 'စလစ်ပြန်အမ်းခြင်း အောင်မြင်',
    lt_msg_return_poy_refunded: 'စလစ်ပယ်ဖျက်ပြီး ငွေပြန်အမ်းပြီးပါပြီ',
    lt_msg_return_poy_partial: 'စလစ်ပယ်ဖျက်ပြီးပါပြီ၊ သို့သော် ငွေပြန်အမ်းရန် အချိန်အနည်းငယ်ကြာနိုင်သည်။ နောက်မှ လက်ကျန်ကို စစ်ဆေးပါ။',
    lt_msg_ok: 'အိုကေ',
    lt_msg_cannot_return_poy: 'စလစ်ပြန်အမ်း၍မရပါ',
    lt_msg_error_try_again: 'အမှားဖြစ်ပွားသည်။ ထပ်ကြိုးစားပါ။',
    lt_msg_error_generic: 'အမှားဖြစ်ပွားသည်',
    lt_msg_proceed_within_5min: '၅ မိနစ်အတွင်း ဆောင်ရွက်ပါ',
    lt_msg_min_withdraw_50: 'အနည်းဆုံးထုတ်ငွေ ၅၀ ဘတ်',
    lt_msg_error_try_again2: 'အမှားဖြစ်ပွားသည်။ ထပ်ကြိုးစားပါ။',
    lt_msg_mobile_link_unavailable: 'မိုဘိုင်းလင့် မရရှိနိုင်ပါ',
    lt_msg_game_link_unavailable: 'ဂိမ်းလင့် မရရှိနိုင်ပါ',
    lt_msg_link_unavailable: 'လင့် မရရှိနိုင်ပါ',
    lt_msg_enter_coupon: 'ကူပွန်ကုဒ် ထည့်ပါ',
    lt_msg_not_logged_in: 'သင် လော့ဂ်အင်မဝင်ရသေးပါ',
    lt_msg_invalid_token: 'တိုကင် မမှန်ကန်ပါ',
    lt_msg_user_not_found: 'အသုံးပြုသူဒေတာ မတွေ့ပါ',
    lt_msg_password_incomplete: 'သင့်စကားဝှက် ၆ လုံးမပြည့်ပါ၊ စစ်ဆေးပါ',
    lt_msg_no_phone: 'ဖုန်းနံပါတ် ထည့်မထားပါ',
    lt_msg_wrong_phone: 'နံပါတ်မှားနေသည်',
    lt_msg_otp_mismatch: 'အတည်ပြုကုဒ် မကိုက်ညီပါ',
    lt_msg_pass_max15: 'စကားဝှက် ၁၅ လုံးထက်မပိုရပါ',
    lt_msg_pass_min6: 'စကားဝှက် အနည်းဆုံး ၆ လုံးဖြစ်ရမည်',
    lt_msg_register_error: 'စာရင်းသွင်းရာတွင် အမှားဖြစ်ပွားသည်',
    lt_msg_phone_in_use: 'ဤနံပါတ်ကို အသုံးပြုပြီးသား',
    lt_msg_otp_send_error: 'OTP ပို့ရာတွင် အမှားဖြစ်ပွားသည်',
    lt_msg_otp_limit: 'OTP ထပ်တောင်း၍မရတော့ပါ။ ၁၀ မိနစ်အကြာတွင် ထပ်တောင်းနိုင်သည်။',
    lt_msg_otp_wait_5min: '၅ မိနစ်အကြာတွင် ထပ်ဆောင်ရွက်နိုင်သည်',
    lt_lotto_short: 'ထီ',
    lt_slot_casino: 'စလော့/ကာစီနို',
    lt_play_casino_amount: 'ကာစီနိုထိုးငွေ',
    lt_play_sport_amount: 'အားကစားထိုးငွေ',
    lt_deposit_amount: 'ဖြည့်ငွေ',
    lt_withdraw_amount: 'ထုတ်ငွေ',
    lt_select_month: 'လ ရွေးပါ',
    lt_total_month: 'စုစုပေါင်း (လ)',
    lt_report_withdraw_income: 'ဝင်ငွေထုတ် တိုင်ကြားရန်',
    lt_income_credit_note: 'မိတ်ဆက်စနစ်ဝင်ငွေကို ခရက်ဒစ်အဖြစ် ထုတ်ယူမည်',
    lt_contact_agent_note: 'သံသယရှိပါက သင်စာရင်းသွင်းသော အေးဂျင့်ကို ဆက်သွယ်ပါ',
    lt_current_income_remaining: 'လက်ရှိဝင်ငွေ - လက်ကျန်',
    lt_no_income: 'ရရန်ငွေမရှိ',
    lt_receiving_credit: 'ခရက်ဒစ်ရယူနေသည်...',
    lt_receive_credit: 'ခရက်ဒစ်ရယူ',
    lt_recent_receive_history: 'မကြာသေးမီရယူမှုမှတ်တမ်း',
    lt_calculated_at: 'တွက်ချက်ချိန်',
    lt_amount_calculated: 'တွက်ချက်ငွေ',
    lt_loss_rebate: 'ရှုံးငွေပြန်အမ်း',
    lt_loss_rebate_condition: 'ရှုံးငွေပြန်အမ်းစည်းကမ်း',
    lt_loss_rebate_percent: 'ရှုံးငွေပြန်အမ်းရာခိုင်နှုန်း:',
    lt_loss_rebate_this_month: 'ဤလ စုဆောင်းရှုံးငွေပြန်အမ်း',
    lt_current_withdraw_amount: 'လက်ရှိထုတ်ငွေ',
    lt_loss_rebate_percent_label: 'ရှုံးငွေပြန်အမ်းရာခိုင်နှုန်း',
    lt_loss_rebate_percent_max: 'အများဆုံးရှုံးငွေပြန်အမ်းရာခိုင်နှုန်း',
    lt_loss_rebate_formula: 'အခြေအနေ: သွင်းငွေ - ထုတ်ငွေ = ရာခိုင်နှုန်း * တွက်ချက်ငွေ',
    lt_play_loss_get_back: 'ရှုံးလျှင် ပြန်ရ',
    lt_loss_rebate_desc: 'ရှုံးပါက သတ်မှတ်ရာခိုင်နှုန်းအတိုင်း ပြန်အမ်းငွေရရှိပြီး ခရက်ဒစ်အဖြစ် ထုတ်ယူနိုင်သည်',
    lt_final_decision_note: 'ကုမ္ပဏီ၏ဆုံးဖြတ်ချက်သည် အပြီးအပြတ်ဖြစ်သည်',
    lt_report_receive_loss: 'ရှုံးငွေရယူ တိုင်ကြားရန်',
    lt_loss_credit_note: 'ရှုံးငွေပြန်အမ်းစနစ်ငွေကို ခရက်ဒစ်အဖြစ် ထုတ်ယူမည်',
    lt_current_amount_remaining: 'လက်ရှိငွေ - လက်ကျန်',
    lt_recent_loss_history: 'မကြာသေးမီရှုံးငွေရယူမှတ်တမ်း',
    lt_minigame: 'မီနီဂိမ်း',
    lt_number_set_detail: 'နံပါတ်အစုံ အသေးစိတ်',
    lt_delete_this_item: 'ဤအရာ ဖျက်ရန်',
    lt_set_name: 'အစုံအမည်',
    lt_created_at: 'ဖန်တီးချိန်',
    lt_number_set: 'နံပါတ်အစုံ',
    lt_notification_msg: 'အသိပေးချက်',
    lt_confirm_delete_set: 'ဤနံပါတ်အစုံ ဖျက်ရန် သေချာပါသလား?',
    lt_profile: 'ပရိုဖိုင်',
    lt_manage_password: 'စကားဝှက်စီမံ',
    lt_password_note: 'မှတ်ချက်: လက်ရှိစကားဝှက်မေ့ပါက Line မှ အက်ဒမင်ကို ဆက်သွယ်ပါ',
    lt_old_password: 'စကားဝှက်အဟောင်း',
    lt_new_password: 'စကားဝှက်အသစ်',
    lt_confirm_new_password: 'စကားဝှက်အသစ် အတည်ပြုရန်',
    lt_change_password: 'စကားဝှက်ပြောင်းရန်',
    lt_deposit_withdraw_status: 'ငွေသွင်း-ထုတ် အခြေအနေ',
    lt_report_deposit_withdraw: 'ငွေသွင်း/ထုတ် ပြဿနာတိုင်ကြားရန်',
    lt_deposit_short: 'သွင်း',
    lt_withdraw_short: 'ထုတ်',
    lt_click_item_for_detail: '*အသေးစိတ်ကြည့်ရန် စာရင်းကိုနှိပ်ပါ',
    lt_deposit_credit: 'ခရက်ဒစ်သွင်း',
    lt_withdraw_credit: 'ခရက်ဒစ်ထုတ်',
    lt_bonus: 'ဘောနပ်စ်',
    lt_status: 'အခြေအနေ',
    lt_processing: 'ဆောင်ရွက်နေသည်',
    lt_pending: 'စောင့်ဆိုင်းနေသည်',
    lt_cancelled_by_player: 'ပယ်ဖျက် (ကစားသမားမှ)',
    lt_failed_by_system: 'မအောင်မြင် (စနစ်မှ)',
    lt_success_status: 'အောင်မြင်',
    lt_transaction_no: 'ငွေလွှဲနံပါတ်',
    lt_remaining: 'လက်ကျန်',
    lt_note_colon: 'မှတ်ချက်:',
    lt_topup_by_user: 'အသုံးပြုသူမှ ငွေဖြည့်',
    lt_play_game: 'ဂိမ်းကစား',
    lt_bet_lotto2: 'ထီထိုး',
    lt_system: 'စနစ်',
    lt_financial_report2: 'ငွေကြေးအစီရင်ခံစာ',
    lt_click_item_history_3days: '*အသေးစိတ်ကြည့်ရန် စာရင်းကိုနှိပ်ပါ - မှတ်တမ်း ၃ ရက်အထိ',
    lt_prize_result: 'ဆုရလဒ်',
    lt_search_lotto_name: 'ထီအမည် ရှာရန်',
    lt_search_lotto_ph: 'ထီအမည်၊ ကုဒ် သို့မဟုတ် အကြိမ်ထည့်ပါ',
    lt_no_lotto_found: 'ထီ မတွေ့ပါ',
    lt_foreign_lotto_group: 'နိုင်ငံခြားထီအဖွဲ့',
    lt_online_lotto_group: 'အွန်လိုင်းထီအဖွဲ့',
    lt_stock_lotto_group: 'စတော့ထီအဖွဲ့',
    lt_special_stock_lotto_group: 'အထူးစတော့ထီအဖွဲ့',
    lt_past_results: 'အတိတ်ရလဒ်',
    lt_how_to_deposit: 'ငွေဖြည့်နည်း',
    lt_image: 'ပုံ',
    lt_video: 'ဗီဒီယို',
    lt_how_to_buy_lotto: 'ထီဝယ်နည်း',
    lt_how_to_change_password: 'စကားဝှက်ပြောင်းနည်း',
    lt_change_password_short: 'စကားဝှက်ပြောင်း',
    lt_deposit_money: 'ငွေဖြည့်',
    lt_how_to_register2: 'စာရင်းသွင်းနည်း',
    lt_register_member: 'စာရင်းသွင်းရန်',
    lt_forgot_password_title: 'စကားဝှက်မေ့သွားလျှင်',
    lt_how_to_catch_win: 'ဝင်းရွေးနည်း',
    lt_catch_win: 'ဝင်းရွေး',
    lt_how_to_bet_rood: 'ရုဒ်ထိုးနည်း',
    lt_bet_rood: 'ရုဒ်ထိုး',
    lt_how_to_deposit_decimal: 'ဒဿမ ငွေဖြည့်နည်း',
    lt_boss: 'သူဌေး',
    lt_bank_account_title: 'ဘဏ်အကောင့်',
    lt_usable_bank_account: 'အသုံးပြုနိုင်သောဘဏ်အကောင့်',
    lt_game: 'ဂိမ်း',
    lt_wheel: 'ဘီးလည်',
    lt_checkin: 'ချက်အင်',
    lt_open_card: 'ကတ်ဖွင့်',
    lt_search_game_name: 'ဂိမ်းအမည် ရှာရန်',
    lt_upload_slip: 'စလစ် တင်ရန်',
    lt_upload_slip_only: 'စလစ်ပုံသာ တင်ပါ',
    lt_upload: 'တင်ရန်',
    lt_confirm_upload: 'တင်ခြင်း အတည်ပြုရန်',
    lt_upload_slip_success: 'စလစ်တင်ခြင်း အောင်မြင်',
    lt_username_account: 'အသုံးပြုသူအမည်',
    lt_select_transaction_channel: 'ငွေလွှဲချန်နယ် ရွေးပါ',
    lt_amount_only_numbers_ph: 'ဂဏန်းသာ',
    lt_company_pleased: 'ကုမ္ပဏီသည် သင့်အား ဝန်ဆောင်မှုပေးရခြင်းကို အလွန်ဝမ်းမြောက်ပါသည်',
    lt_terms_intro: 'အသင်းဝင်အခွင့်အရေးများကို သိရှိစေရန် အသင်းဝင်စာရင်းသွင်းပြီး ဝန်ဆောင်မှုအသုံးမပြုမီ သဘောတူညီချက်ကို သေချာဖတ်ပါ',
    lt_terms_accept_intro: 'စာရင်းသွင်းပြီးနောက် ဝဘ်ဆိုဒ်သည် အသင်းဝင်က အောက်ပါတို့ကို ဖတ်၍ လက်ခံပြီးဟု သတ်မှတ်မည်',
    lt_terms_policy: '"ဝဘ်ဆိုဒ်၏ ဝန်ဆောင်မှုမူဝါဒနှင့် စည်းကမ်းချက်များ"',
    lt_terms_h_benefit: 'အကျိုးစီးပွားကာကွယ်ခြင်းနှင့် အွန်လိုင်းလောင်းကစားကူညီခြင်း',
    lt_terms_b1: 'အသင်းဝင်သည် လောင်းနေစဉ် ဝဘ်ဆိုဒ်မှ ပြတ်တောက်သွားပါက သင့်အကောင့်သည် လောင်းကစားရလဒ်ကို မထိခိုက်ပါ',
    lt_terms_b2a: 'စိတ်မပူပါနှင့်။ အသင်းဝင်သည် လောင်းနေစဉ် ဝဘ်ဆိုဒ်မှ ထွက်သွားပါက ခဏ ထွက်ခွာစေပြီး၊ ထို့နောက် အသင်းဝင်သည် ပြန်ဝင်နိုင်သည်',
    lt_terms_b2b: 'ပုံမှန်အတိုင်း ထပ်မံ',
    lt_terms_h_protect: 'အကာအကွယ်ပေးခြင်း',
    lt_terms_protect1: 'ထိရောက်သောစနစ်၊ မြန်ဆန်ပြီး ဖော်ရွေသော ဖောက်သည်ဝန်ဆောင်မှုကို ပြင်ဆင်ထားသည်။ မေးခွန်း သို့မဟုတ် အကြံပြုချက်ရှိပါက ဖောက်သည်ဝန်ဆောင်မှုသို့ ဖုန်းခေါ်ရန် မတွန့်ဆုတ်ပါနှင့်။ နေ့စဉ် ၂၄ နာရီ ပိတ်ရက်မရှိ ဝန်ဆောင်မှုပေးပြီး အမြန်ဆုံး ပြန်ကြားပေးမည်',
    lt_terms_protect2: 'သင့်ကိုယ်ရေးအချက်အလက်ကို လုံခြုံစွာ လျှို့ဝှက်ထားမည်ဟု အာမခံသည်',
    lt_terms_h_bet: 'လောင်းကစားသဘောတူညီချက်',
    lt_terms_bet1: 'ဝဘ်ဆိုဒ်အသုံးပြုစဉ် ပြဿနာများ ရှောင်ရှားရန် အသင်းဝင်များ ကုမ္ပဏီစည်းကမ်းကို သေချာဖတ်ပါ။ အသင်းဝင်သည် လောင်းကစားစာမျက်နှာသို့ ဝင်ရောက်သောအခါ ကုမ္ပဏီသည် သင်က သဘောတူညီချက်ကို လက်ခံပြီးဟု သတ်မှတ်မည်',
    lt_terms_bet2a: 'လောင်းကစားသည် အောက်ပါအချိန်အတွင်း ဖြစ်ရမည်',
    lt_terms_period: '"သတ်မှတ်ထားသောအချိန်"',
    lt_terms_bet2b: 'သို့မဟုတ်ပါက ထိုလောင်းကစားကို အောက်ပါအတိုင်း သတ်မှတ်မည်',
    lt_terms_void: '"ပျက်ပြယ်"',
    lt_terms_bet2c: 'လောင်းကစားကို မည်သည့်အကြောင်းကြောင့်မဆို ကစားမှုမတိုင်မီ ပယ်ဖျက် သို့မဟုတ် ယာယီရပ်ဆိုင်းပါက ထိုလောင်းကစားကို အောက်ပါအတိုင်း သတ်မှတ်မည်',
    lt_terms_bet2d: 'ကုမ္ပဏီသည် အသင်းဝင်ကို ခရက်ဒစ်ပြန်အမ်းမည်',
    lt_terms_bet3a: 'အရှုံးအနိုင်ပြသသော ဝင်းဒိုးမှ ရလဒ်ကို ကြည့်ရှုခြင်းသည် အသင်းဝင်၏တာဝန်ဖြစ်သည်။ ကုမ္ပဏီသည် အောက်ပါအချက်အလက်ကို အခြေခံမည်',
    lt_terms_bet_detail: '"လောင်းကစားအသေးစိတ်"',
    lt_terms_bet3b: 'အသင်းဝင်တွင် သံသယရှိပြီး ထိုလောင်းကစား၏ တွက်ချက်မှုအချက်အလက်ကို စစ်ဆေးလိုပါက',
    lt_terms_bet4: 'လောင်းကစားစဉ် စနစ်ချို့ယွင်းမှု သို့မဟုတ် ဝန်ထမ်း၏ မရည်ရွယ်သောအမှားဖြစ်ပါက ကုမ္ပဏီသည် ရလဒ်ကို ပြင်ဆင်ပိုင်ခွင့်ရှိပြီး၊ ပြင်ဆင်ထားသောစာကို ဝဘ်ဆိုဒ်ပြေးနေသောဘားတွင် ဖော်ပြမည်။ ကုမ္ပဏီသည် အသင်းဝင်ကို တစ်ဦးချင်း အသိမပေးပါ',
    lt_terms_bet5: 'ဝဘ်ဆိုဒ်ဝင်ရန် အသုံးပြုသူအမည်နှင့် စကားဝှက် မှန်ကန်ကြောင်း သေချာစေရန် အသင်းဝင်၏တာဝန်ဖြစ်သည်။ လုံခြုံရေးအတွက် လတိုင်း အနည်းဆုံးတစ်ကြိမ် စကားဝှက်ပြောင်းပါ။ အခြားသူက ခွင့်ပြုချက်မရှိဘဲ သင့်အကောင့်သို့ ဝင်ရောက်သည်ဟု တွေ့ရှိ သို့မဟုတ် သံသယရှိပါက ကိုယ်ရေးစကားဝှက်ပြောင်းရန် သင့်ကိုယ်စားလှယ်ကို ချက်ချင်းအသိပေးပါ (စကားဝှက်မပြောင်းမီ လောင်းကစားပါက ထိုလောင်းကစားကို တရားဝင်ဟု သတ်မှတ်မည်)',
    lt_terms_bet6: 'လောင်းကစားတိုင်းမတိုင်မီ အသင်းဝင်သည် လက်ကျန်ငွေကို ဦးစွာစစ်ဆေးသင့်သည်။ လက်ကျန်ငွေနှင့်ပတ်သက်၍ သံသယရှိပါက သင့်ကိုယ်စားလှယ်ကို ချက်ချင်းအသိပေးပါ',
    lt_terms_bet7: 'အင်တာနက်ချို့ယွင်းမှုကြောင့် အချက်အလက်ဆုံးရှုံးခြင်းကဲ့သို့ မမျှော်လင့်သောအဖြစ်အပျက်များ ဖြစ်ပေါ်ပါက ကုမ္ပဏီသည် အကြောင်းရင်းနှင့် ဖြေရှင်းနည်းကို ကြေညာမည်',
    lt_terms_bet8: 'ဝန်ဆောင်မှုအချိန် တစ်ရက် ၂၄ နာရီ၊ ပိတ်ရက်မရှိ',
    lt_terms_bet9: 'ယူဇာ ၁ ခု သို့မဟုတ် ထို့ထက်ပိုသုံး၍ ထပ်လောင်းခြင်း၊ ၂ လုံးထီ ၅၀ နံပါတ်ကျော်/၃ လုံးထီ ၂၅၀ နံပါတ်ကျော် တစ်ကြိမ်လျှင် ဘီလ်ခွဲ သို့မဟုတ် ပေါင်းသည်ဖြစ်စေ၊ သို့မဟုတ် ကုမ္ပဏီက လောင်းကစားမမှန်ကန်ဟု ဆုံးဖြတ်ပါက ကုမ္ပဏီသည် ကြိုတင်အသိမပေးဘဲ အသုံးပြုမှုရပ်ဆိုင်းပြီး အသင်းဝင်၏ ခရက်ဒစ်ကို သိမ်းပိုင်ခွင့်ရှိသည်',
    lt_terms_bet10: 'ကုမ္ပဏီ၏ဆုံးဖြတ်ချက်သည် အပြီးအပြတ်ဖြစ်သည်',
    lt_terms_h_security: 'လုံခြုံရေးစနစ်',
    lt_terms_sec1: 'အကောင့်အချက်အလက်သည် တစ်ဦးချင်းရည်ရွယ်ချက်အတွက်သာ ဖြစ်သည်။ အကောင့်ဖွင့်စဉ် အသင်းဝင်ပေးသော အချက်အလက်ကို အမြင့်ဆုံးလျှို့ဝှက်ထားမည်။ ကုမ္ပဏီသည် ဤအချက်အလက်ကို တတိယပါတီ သို့မဟုတ် အခြားအဖွဲ့အစည်းများသို့ ထုတ်ဖော်မည်မဟုတ်။ အီးမေးလ်အကောင့် သို့မဟုတ် လျှောက်လွှာတွင် ဖြည့်သွင်းသော အခြားအချက်အလက်ဖြစ်စေ။ ဤအချက်အလက်ကို ဆုရှင်များအတွက် ငွေချက်လက်မှတ်ပို့ခြင်း သို့မဟုတ် အသင်းဝင်တောင်းဆိုသော အခြားအချက်အလက်ကဲ့သို့ ရည်ရွယ်ထားသောရည်ရွယ်ချက်အတွက်သာ အသုံးပြုမည်',
    lt_terms_sec2: 'လုံခြုံရေးအတွက် ကုမ္ပဏီသည် သင့်အချက်အလက်လုံခြုံမှု သေချာစေရန် အထိရောက်ဆုံးနည်းလမ်းများ အသုံးပြုသည်။ အချက်အလက်တိကျမှုနှင့် လျှို့ဝှက်မှု ထိန်းသိမ်းရန်၊ အချက်အလက်ပေါက်ကြားခြင်း သို့မဟုတ် မှားယွင်းအသုံးပြုခြင်းမှ ကာကွယ်ရန် အကောင်းဆုံးကြိုးစားမည်။ လျှို့ဝှက်မှုနှင့် အချက်အလက်လုံခြုံရေးနှင့်ပတ်သက်၍ သံသယရှိပါက ဖောက်သည်ဝန်ဆောင်မှုကို ဆက်သွယ်ပါ။ နေ့စဉ် ၂၄ နာရီ ပိတ်ရက်မရှိ ဝမ်းမြောက်စွာ ဝန်ဆောင်မှုပေးပါသည်',
  },
  lo: {
    lt_bet_lotto: 'ແທງຫວຍ',
    lt_lotto_result: 'ຜົນຫວຍ',
    lt_poy: 'ໂພຍຫວຍ',
    lt_fill_code: 'ປ້ອນໂຄ້ດ',
    lt_create_number_set: 'ສ້າງເລກຊຸດ',
    lt_check_lotto: 'ກວດຫວຍ',
    lt_lucky_numbers_group: 'ກຸ່ມເລກເດັ່ນ',
    lt_lotto_schedule_soon: 'ຕາຕະລາງຫວຍໄວໆນີ້',
    lt_bet_now: 'ແທງເລີຍ',
    lt_games: 'ເກມ',
    lt_financial_report: 'ລາຍງານການເງິນ',
    lt_deposit_withdraw_list: 'ລາຍການຝາກ/ຖອນ',
    lt_report_deposit_withdraw_problem: 'ແຈ້ງບັນຫາຝາກ/ຖອນ',
    lt_sport: 'ກີລາ',
    lt_casino_online: 'ຄາສິໂນອອນລາຍ',
    lt_wheel_games: 'ເກມກົງລໍ້',
    lt_rules: 'ກົດກະຕິກາ',
    lt_register_via_admin: 'ສະໝັກສະມາชิກຜ່ານແອັດມິນ',
    lt_forgot_password: 'ລືມລະຫັດຜ່ານ',
    lt_check_lotto_result: 'ກວດຜົນຫວຍ',
    lt_latest_lotto_result: 'ຜົນຫວຍລ່າສຸດ',
    lt_fill_coupon_code: 'ປ້ອນໂຄ້ດຄູປອງ',
    lt_how_to_bet_lotto: 'ວິທີການແທງຫວຍ',
    lt_report_problem_24hr: 'ແຈ້ງບັນຫາ 24 ຊມ.',
    lt_today_bet_amount: 'ຍອດແທງມື້ນີ້',
    lt_total: 'ຍອດລວມ',
    lt_result_announced: 'ອອກຜົນແລ້ວ',
    lt_result_pending: 'ຍັງບໍ່ອອກຜົນ',
    lt_today_list: 'ລາຍການມື້ນີ້',
    lt_all_lotto: 'ຫວຍທັງໝົດ',
    lt_all_history: 'ຍ້ອນຫຼັງທັງໝົດ',
    lt_poy_short: 'ໂພຍ',
    lt_not_announced_yet: 'ທີ່ຍັງບໍ່ອອກຜົນ',
    lt_previous: 'ກ່ອນໜ້າ',
    lt_poy_number: 'ໂພຍເລກທີ',
    lt_stake: 'ເງິນເດີມພັນ',
    lt_win_lose: 'ຜົນແພ້/ຊະນະ',
    lt_no_items: 'ບໍ່ມີລາຍການ',
    lt_poy_detail: 'ລາຍລະອຽດໂພຍ',
    lt_return_poy: 'ຄືນໂພຍ',
    lt_round_date: 'ຮອບ/ວັນທີ',
    lt_win_loss_result: 'ຜົນໄດ້ເສຍ',
    lt_order_no: 'ລຳດັບ',
    lt_won: 'ຖືກລາງວັນ',
    lt_not_won: 'ບໍ່ຖືກລາງວັນ',
    lt_winning_number: 'ເລກທີ່ອອກ',
    lt_payout_rate: 'ລາຄາຈ່າຍ',
    lt_bet_price: 'ລາຄາແທງ',
    lt_day: 'ວັນ',
    lt_hour: 'ຊົ່ວໂມງ',
    lt_minute: 'ນາທີ',
    lt_second: 'ວິນາທີ',
    lt_welcome_marquee: 'ຍິນດີຕ້ອນຮັບທຸກທ່ານສູ່ Salmon168 ເວັບຫວຍອອນລາຍທີ່ມາແຮງທີ່ສຸດໃນຂະນະນີ້',
    lt_thai_lotto: 'ຫວຍໄທ',
    lt_thai_lotto_group: 'ກຸ່ມຫວຍໄທ',
    lt_back_home: 'ໜ້າຫຼັກ',
    lt_go_back: 'ກັບຄືນ',
    lt_latest_update: 'ອັບເດດລ່າສຸດ',
    lt_or: 'ຫຼື',
    lt_register_via_admin_short: 'ສະໝັກຜ່ານແອັດມິນ',
    lt_specify_phone: 'ໃສ່ເບີໂທລະສັບ',
    lt_register_phone: 'ລົງທະບຽນເບີໂທລະສັບ',
    lt_enter_phone_ph: 'ໃສ່ເບີໂທລະສັບ',
    lt_enter_phone_verify: 'ກະລຸນາໃສ່ໝາຍເລກໂທລະສັບເພື່ອຢືນຢັນຕົວຕົນ',
    lt_enter_captcha: 'ກະລຸນາໃສ່ອັກສອນ 4 ໂຕໃນຮູບ',
    lt_confirm_phone: 'ຢືນຢັນເບີໂທລະສັບ',
    lt_enter_sms_code: 'ກະລຸນານຳເລກ ທີ່ໄດ້ຮັບຈາກ sms ມາໃສ່ໃນຊ່ອງຫວ່າງ',
    lt_request_otp_again_5min: 'ຂໍລະຫັດ OTP ໄດ້ອີກຄັ້ງໃນ 5 ນາທີ',
    lt_enter_otp_within_5min: 'ກະລຸນາໃສ່ໝາຍເລກທີ່ລະບົບໄດ້ສົ່ງໄປຫາເບີໂທລະສັບຂອງທ່ານພາຍໃນ 5 ນາທີ',
    lt_send_code_to_phone: 'ສົ່ງລະຫັດໄປຫາເບີ',
    lt_resend_otp: 'ສົ່ງລະຫັດ OTP',
    lt_create_account: 'ສ້າງບັນຊີ',
    lt_username_label: 'ຊື່ຜູ້ໃຊ້ງານ',
    lt_password_label: 'ລະຫັດຜ່ານ',
    lt_confirm_password_label: 'ຢືນຢັນລະຫັດຜ່ານ',
    lt_confirm_password_ph: 'ໃສ່ password ອີກຄັ້ງ',
    lt_select_known_channel: 'ເລືອກຊ່ອງທາງທີ່ຮູ້ຈັກເວັບ',
    lt_add_bank_account: 'ເພີ່ມບັນຊີທະນາຄານ',
    lt_select_bank: 'ເລືອກທະນາຄານ',
    lt_please_select_bank: 'ກະລຸນາເລືອກທະນາຄານ',
    lt_account_name_label: 'ຊື່ບັນຊີ',
    lt_account_name_ph: 'ຊື່ ນາມສະກຸນ ໜ້າປຶ້ມບັນຊີ',
    lt_account_no_label: 'ເລກບັນຊີ',
    lt_numbers_only_ph: 'ລະບຸສະເພາະຕົວເລກ',
    lt_confirm_account_no: 'ຢືນຢັນເລກບັນຊີ',
    lt_confirm_account_no_ph: 'ຢືນຢັນເລກບັນຊີອີກຄັ້ງ',
    lt_add_account: 'ເພີ່ມບັນຊີ',
    lt_next: 'ຕໍ່ໄປ',
    lt_skip_verify: 'ຂ້າມການຢືນຢັນ',
    lt_confirm_otp: 'ຢືນຢັນ OTP',
    lt_already_member: 'ມີສະມາชิກຢູ່ແລ້ວ',
    lt_phone_already_used: 'ເບີນີ້ມີຜູ້ໃຊ້ງານແລ້ວ',
    lt_phone: 'ເບີ',
    lt_phone_has_account: 'ມີລະຫັດຜູ້ໃຊ້ງານແລ້ວ',
    lt_please_register_new_phone: 'ກະລຸນາສະໝັກດ້ວຍເບີໃໝ່ ຫຼື',
    lt_reset_password_if_forgot: 'ຣີເຊັດລະຫັດຜ່ານໃນກໍລະນີລືມລະຫັດຜ່ານ',
    lt_register_new_phone: 'ສະໝັກດ້ວຍເບີໃໝ່',
    lt_reset_password: 'ຣີເຊັດລະຫັດຜ່ານ',
    lt_choose_contact_channel: 'ເລືອກຊ່ອງທາງການຕິດຕໍ່ເຮົາ',
    lt_contact_via_line: 'ຕິດຕໍ່ຜ່ານໄລນ໌',
    lt_live_chat_with_staff: 'ແຊັດສົດກັບພະນັກງານ',
    lt_unmute: 'ເປີດສຽງ',
    lt_mute: 'ປິດສຽງ',
    lt_rules_title: 'ກົດແລະກະຕິກາ',
    lt_welcome_lotto_online: 'ຍິນດີຕ້ອນຮັບສູ່ຫວຍອອນລາຍ',
    lt_payout_rate_title: 'ອັດຕາການຈ່າຍ',
    lt_i_understand_accept: 'ຂ້ອຍເຂົ້າໃຈແລະຍອມຮັບ',
    lt_account_settings: 'ຕັ້ງຄ່າບັນຊີຜູ້ໃຊ້',
    lt_bank_account: 'ບັນຊີທະນາຄານ',
    lt_how_to_use: 'ວິທີໃຊ້ງານ',
    lt_help_center: 'ສູນຊ່ວຍເຫຼືອ',
    lt_lucky_numbers_daily: 'ເລກເດັ່ນເລກດັງປະຈຳວັນ',
    lt_how_to_register: 'ວິທີສະໝັກສະມາຊິກ',
    lt_register_steps: 'ຂັ້ນຕອນການສະໝັກສະມາຊິກ',
    lt_register_via_admin_alt: 'ສະໝັກຜ່ານແອັດມິນ',
    lt_admin_help_register: 'ໃຫ້ແອັດມິນຊ່ວຍສະໝັກສະມາຊິກ',
    lt_prize_1: 'ລາງວັນທີ 1',
    lt_two_down: '2 ໂຕລຸ່ມ',
    lt_three_front: '3 ໂຕໜ້າ',
    lt_three_down: '3 ໂຕລຸ່ມ',
    lt_three_up: '3 ໂຕເທິງ',
    lt_foreign_lotto: 'ຫວຍຕ່າງປະເທດ',
    lt_online_lotto: 'ຫວຍອອນລາຍ',
    lt_foreign_stock_lotto: 'ຫວຍຫຸ້ນຕ່າງປະເທດ',
    lt_special_stock_lotto: 'ຫວຍຫຸ້ນພິເສດ',
    lt_stock_lotto: 'ຫວຍຫຸ້ນ',
    lt_stock_lotto_vip: 'ຫວຍຫຸ້ນ VIP',
    lt_popular_lotto: 'ຫວຍເດັ່ນຍອດນິຍົມ',
    lt_result_rooms: 'ຫ້ອງໂຊວ໌ຜົນລາງວັນ',
    lt_showing_result: 'ໂຊວ໌ຜົນລາງວັນ',
    lt_countdown_hot_lotto: 'ນັບຖອຍຫຼັງຫວຍດັງ',
    lt_thai_gov_lotto: 'ຫວຍລັດຖະບານໄທ',
    lt_live_chat: 'ແຊັດສົດ',
    lt_teach_usage: 'ສອນໃຊ້ງານ',
    lt_install_app: 'ຕິດຕັ້ງ APP',
    lt_lao_tonight: 'ຫວຍລາວທູໄນທ໌',
    lt_balance_remaining: 'ຍອດເງິນຄົງເຫຼືອ',
    lt_lotto_soon: 'ຫວຍໄວໆນີ້',
    lt_close_at: 'ປິດຮັບ',
    lt_survey: 'ແບບສຳຫຼວດ',
    lt_survey_q: 'ທ່ານຮູ້ຈັກເວັບໄຊທ໌ຂອງເຮົາມາຈາກຊ່ອງທາງໃດ?',
    lt_install_app2: 'ຕິດຕັ້ງແອັບ',
    lt_boss_gives_luck: 'ເຖົ້າແກ່ ໃຫ້ໂຊກ',
    lt_browser_not_support: 'ເບຣົາເຊີບໍ່ຮອງຮັບ ກະລຸນາເຮັດຕາມຂັ້ນຕອນຕໍ່ໄປນີ້',
    lt_play_history: 'ປະຫວັດການຫຼິ້ນ',
    lt_detail: 'ລາຍລະອຽດ',
    lt_transaction_time: 'ເວລາທີ່ເຮັດລາຍການ',
    lt_provider: 'ຜູ້ໃຫ້ບໍລິການ',
    lt_ticket_no: 'ເລກທີ່ປີ້',
    lt_event: 'ອີເວັນ',
    lt_brought_forward: 'ຍອດຍົກມາ',
    lt_credit: 'ເຄຣດິດ',
    lt_balance: 'ຍອດຄົງເຫຼືອ',
    lt_report_credit_deposit: 'ແຈ້ງເຕີມເຄຣດິດ',
    lt_customer_bank_account: 'ບັນຊີທະນາຄານຂອງລູກຄ້າ',
    lt_select_transfer_channel: 'ເລືອກຊ່ອງທາງການໂອນເງິນ',
    lt_transaction_channel: 'ຊ່ອງທາງທຸລະກຳ',
    lt_please_select_channel: 'ກະລຸນາເລືອກຊ່ອງທາງທຸລະກຳ',
    lt_payment_gateway: 'Payment Gateway',
    lt_selected: 'ເລືອກແລ້ວ',
    lt_amount_to_transfer: 'ຈຳນວນເງິນທີ່ຕ້ອງການໂອນ (ຈຳນວນເຕັມ)',
    lt_min_max_amount_ph: 'ຂັ້ນຕ່ຳ: 20.00 / ສູງສຸດ: 500,000.00',
    lt_continue: 'ດຳເນີນການຕໍ່',
    lt_transfer_to_add_credit: 'ໂອນເງິນເພື່ອເຕີມເຄຣດິດ',
    lt_bank: 'ທະນາຄານ',
    lt_use_this_account_only: '***ກະລຸນາໃຊ້ບັນຊີນີ້ໃນການໂອນເທົ່ານັ້ນ***',
    lt_web_bank_account: 'ບັນຊີທະນາຄານຂອງເວັບ',
    lt_report_transfer: 'ແຈ້ງໂອນເງິນ',
    lt_uploading_slip: 'ກຳລັງອັບໂຫຼດສະລິບ...',
    lt_amount_must_transfer: 'ຈຳນວນເງິນທີ່ຕ້ອງໂອນ:',
    lt_check_account_before_transfer: 'ໝາຍເຫດ: ກະລຸນາກວດສອບເລກບັນຊີກ່ອນໂອນເງິນທຸກຄັ້ງ',
    lt_transfer_within_5min: 'ກະລຸນາໂອນເງິນພາຍໃນເວລາ: 5 ນາທີ',
    lt_report_withdraw: 'ແຈ້ງຖອນເງິນ',
    lt_select_your_bank_account: 'ເລືອກບັນຊີທະນາຄານຂອງທ່ານ',
    lt_select_account_below: '*ກະລຸນາເລືອກບັນຊີດ້ານລຸ່ມຕາມທີ່ທ່ານຕ້ອງການ',
    lt_withdrawable_amount: 'ຈຳນວນເງິນທີ່ຖອນໄດ້',
    lt_some_locked_minbet: 'ຈຳນວນເງິນໃນກະເປົາອາດຈະມີບາງສ່ວນຖືກລັອກສຳລັບການແທງຂັ້ນຕ່ຳ',
    lt_withdraw_cond1: '- ລູກຄ້າຕ້ອງມີຍອດເດີມພັນ 10% ຂອງຍອດຝາກ ແລະບໍ່ຕິດຍອດເດີມພັນໂປຣໂມຊັນ ຈຶ່ງຈະສາມາດຖອນເຄຣດິດໄດ້ທັງໝົດ',
    lt_withdraw_cond2: '- ກໍລະນີແທງຫວຍ ລະບົບຈະນັບຍອດເດີມພັນ ສະເພາະຫວຍທີ່ອອກຜົນແລ້ວເທົ່ານັ້ນ',
    lt_withdraw_cond3: '- ຍອດຖອນຂັ້ນຕ່ຳ 100 ບາດ',
    lt_search_product_name: 'ຄົ້ນຫາລາຍชื่ສິນຄ້າ',
    lt_not_accepting_yet: 'ຍັງບໍ່ຮັບແທງ',
    lt_time_expired: 'ໝົດເວລາ',
    lt_payout_rate_short: 'ອັດຕາຈ່າຍ',
    lt_rules_short: 'ກະຕິກາ',
    lt_open_88_rounds: 'ເປີດ 88 ຮອບ',
    lt_24hr: '24 ຊມ.',
    lt_draw_date: 'ງວດວັນທີ',
    lt_time_left: 'ເຫຼືອເວລາ',
    lt_open_betting: 'ເປີດຮັບແທງ',
    lt_lotto_4d: 'ຫວຍ 4D',
    lt_yeekee: 'ຫວຍຍີ່ກີ',
    lt_not_accepting: 'ບໍ່ຮັບແທງ',
    lt_waiting_accept: 'ລໍຖ້າຮັບແທງ',
    lt_not_drawn_yet: 'ຍັງບໍ່ອອກລາງວັນ',
    lt_waiting_result: 'ລໍຖ້າອອກຜົນ',
    lt_pays: 'ຈ່າຍ',
    lt_min_bet_per_time: 'ແທງຂັ້ນຕ່ຳຕໍ່ຄັ້ງ',
    lt_max_bet_per_time: 'ແທງສູງສຸດຕໍ່ຄັ້ງ',
    lt_history_stats: 'ສະຖິຕິຍ້ອນຫຼັງ',
    lt_two_up: '2 ເທິງ',
    lt_two_low: '2 ລຸ່ມ',
    lt_high: 'ສູງ',
    lt_low: 'ຕ່ຳ',
    lt_even: 'ຄູ່',
    lt_odd: 'ຄີ່',
    lt_bet_amount_of_selected_date: 'ຍອດແທງຂອງວັນທີ່ເລືອກ',
    lt_select_date_range: 'ເລືອກຊ່ວງວັນທີ',
    lt_from_date: 'ຕັ້ງແຕ່ວັນທີ',
    lt_to_date: 'ຮອດວັນທີ',
    lt_start_ph: 'ເລີ່ມ',
    lt_to_ph: 'ຮອດ',
    lt_all: 'ທັງໝົດ',
    lt_today: 'ມື້ນີ້',
    lt_yesterday: 'ມື້ວານ',
    lt_last_7days: '7 ວັນລ່າສຸດ',
    lt_last_30days: '30 ວັນລ່າສຸດ',
    lt_date_label: 'ວັນທີ',
    lt_date_colon: 'ວັນທີ :',
    lt_select_date_ph: 'ເລືອກວັນທີ',
    lt_today_list2: 'ລາຍການມື້ນີ້',
    lt_bet_amount2: 'ຍອດແທງ',
    lt_manage_number_set: 'ຈັດການເລກຊຸດ',
    lt_show: 'ສະແດງ',
    lt_items: 'ລາຍການ',
    lt_number_set_name: 'ຊື່ເລກຊຸດ',
    lt_created_datetime: 'ວັນ-ເວລາ ທີ່ສ້າງ',
    lt_manage: 'ຈັດການ',
    lt_delete: 'ລຶບ',
    lt_coupon: 'ຄູປອງ',
    lt_refer_friend: 'ແນະນຳໝູ່',
    lt_income: 'ລາຍໄດ້',
    lt_withdraw_income: 'ຖອນລາຍໄດ້',
    lt_max_revenue_share: 'ສ່ວນແບ່ງລາຍໄດ້ສູງສຸດ:',
    lt_current_income: 'ລາຍໄດ້ປັດຈຸບັນ',
    lt_referred_members: 'ສະມາຊິກແນະນຳ',
    lt_total_bets: 'ແທງທັງໝົດ',
    lt_total_clicks: 'ຄລິກທັງໝົດ',
    lt_referral_link_banner: 'ລິ້ງແນະນຳ ແລະແບນເນີ',
    lt_link_to_promote: 'ລິ້ງສຳລັບໂປຣໂມດ',
    lt_copy_referral_link: 'ຄັດລອກລິ້ງແນະນຳ',
    lt_share_to_facebook: 'ແຊร์ໄປເຟສບຸກ',
    lt_share_to_line: 'ແຊร์ໄປໄລນ໌',
    lt_note_excl: 'ໝາຍເຫດ!',
    lt_link_banned_text: 'ລິ້ງຖືກແບນຈາກ google, facebook ຫຼືຊ່ອງທາງອື່ນໆ',
    lt_send_referral_to_line: 'ໃຫ້ສົ່ງລິ້ງແນະນຳໝູ່ຂອງທ່ານມາຫາທາງໄລນ໌ ພ້ອມລະບຸບັນຫາ',
    lt_for_new_referral_link: 'ສຳລັບຮັບລິ້ງໃໝ່ໃນການແນະນຳໝູ່',
    lt_product: 'ສິນຄ້າ',
    lt_share_percent: 'ສ່ວນແບ່ງ %',
    lt_all_lotto_paren: 'ຫວຍທັງໝົດ (ຫວຍ)',
    lt_slot: 'ສະລັອດ',
    lt_casino: 'ຄາສິໂນ',
    lt_note: 'ໝາຍເຫດ',
    lt_share_is_max_per_type: 'ສ່ວນແບ່ງໃນການແນະນຳຈະເປັນຄ່າສູງສຸດຂອງແຕ່ລະປະເພດຫວຍ',
    lt_share_help_link: 'ລິ້ງຊ່ວຍແຊร์ ຊ່ວຍແນະນຳ',
    lt_share_help_max: 'ລິ້ງຊ່ວຍແຊร์ຮັບສູງສຸດ',
    lt_just_copy_share_earn: '(ພຽງກັອບປີ້ລິ້ງໄປແຊร์ກໍ່ໄດ້ເງິນແລ້ວ)',
    lt_more_share_more_earn: 'ຍິ່ງແຊร์ຫຼາຍຍິ່ງໄດ້ຫຼາຍ',
    lt_aff_desc1: 'ທ່ານສາມາດນຳລິ້ງແນະນຳນີ້ຫຼືນຳປ້າຍແບນເນີ ໄປແຊร์ໃນຊ່ອງທາງຕ່າງໆ ບໍ່ວ່າจะເປັນ ເວັບໄຊທ໌ສ່ວນຕົວ, Blog, Facebook ຫຼື Social Network ອື່ນໆ ຫາກມີการสมัครສະมาชิກໂดยคลิกຜ່ານລິ້ງຂອງທ່ານເຂົ້າມາ ລູກຄ້າที่สมัครเข้ามาก็จะຢູ່ພາຍໃຕ້ເຄືອข่ายของท่านທັນທີ ແລະຫากลูกค้าພາຍໃຕ້ເຄືອข่ายของท่านມีการเดิมพันเข้ามา ทุกຍอดการเดิมพัน ທ່ານจะໄດ້ຮັບສ່ວນແບ່ງໃນการแนะนำສູງສຸด 8% ທັນທີໂดยไม่มีเงื่อนไข',
    lt_aff_note_rate: 'ສ່ວນແບ່ງໃນการแนะนำອາจจะมีอัตราແตกต่างกันไปในຫวยแต่ละประเภท',
    lt_aff_example: 'ຕົວຢ່າງດັ່ງນີ້',
    lt_aff_ex1: 'ລູກຄ້າທ່ານ 1 ຄົນ ແທງ 1,000 ບາດ ທ່ານຈะໄດ້ 8%',
    lt_aff_ex2: 'ລູກຄ້າທ່ານ 10 ຄົນ ແທງ 1,000 ບາດ ທ່ານຈะໄດ້ຮັບ 8%',
    lt_aff_ex3: 'ລູກຄ້າທ່ານ 100 ຄົນ ແທງ 1,000 ບາດ ທ່ານຈะໄດ້ຮັບ 8%',
    lt_aff_desc2: 'ສາມາດທຳລາຍໄດ້ຫຼັກ 100,000 ບາດຕໍ່ເດືອນໄດ້ງ່າຍໆ ເພາะทางเฮົາมีຫวยเปิดรับທายผลทุกวัน มีมากกว่าวันละ 200 ຮอบ เปิดรับແທງออนไลน์ตลอด 24 ຊມ. ແລะລາຍໄດ້ທຸກບາດທຸກສະຕາງຂອງທ່ານສາມາດກວດສອບໄດ້ທຸກຂັ້ນຕອນ ງານນີ້ແຈກຈິງ ຈ່າຍຈິງ ທີ່ນີ້ບ່ອນດຽວທີ່ໃຫ້ທ່ານຫຼາຍກວ່າໃຜ ຄັດລອກລິ້ງແນະນຳໄປແຊร์ໄດ້ເລີຍ',
    lt_member_referred: 'ສະມາຊິກທີ່ແນະນຳ',
    lt_datetime: 'ວັນ-ເວລາ',
    lt_registered_at: 'ທີ່ສະໝັກ',
    lt_username: 'ຍູສເຊີເນມ',
    lt_play_lotto_amount: 'ຍອດຫຼິ້ນ ຫວຍ',
    lt_play_slot_amount: 'ຍອດຫຼິ້ນ Slot',
    lt_hanoi_lotto: 'ຫວຍຮ່າໂນ້ຍ',
    lt_msg_confirm_delete_set: 'ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບ ເລກຊຸດນີ້?',
    lt_msg_delete_success: 'ລຶບສຳເລັດ',
    lt_msg_item_deleted: 'ລາຍການຖືກລຶບແລ້ວ!',
    lt_msg_cannot_delete: 'ບໍ່ສາມາດລຶບໄດ້',
    lt_msg_error: 'ເກີດຂໍ້ຜິດພາດ!',
    lt_msg_error_title: 'ຂໍ້ຜິດພາດ',
    lt_msg_cannot_delete_item: 'ບໍ່ສາມາດລຶບລາຍການນີ້ໄດ້!',
    lt_msg_confirm_return_poy: 'ຢືນຢັນການຄືນໂພຍ',
    lt_msg_confirm_return_poy_text: 'ທ່ານຕ້ອງການຄືນໂພຍນີ້ບໍ່? ຍອດເງິນຈະຖືກคืນໃຫ້ທັນທີ',
    lt_msg_confirm_return_poy_btn: 'ຢືນຢັນ ຄືນໂພຍ',
    lt_msg_return_poy_success: 'ຄືນໂພຍສຳເລັດ',
    lt_msg_return_poy_refunded: 'ຍົກເລີກໂພຍແລະຄືນເງິນຮຽບร້ອຍແລ້ວ',
    lt_msg_return_poy_partial: 'ຍົກເລີກໂພຍຮຽບร້ອຍແລ້ວ ແຕ່ການຄືນເງິນອາດໃຊ້ເວລາเล็กໜ້ອຍ ກະລຸນາກວດສອບຍອດເງິນພາຍຫຼັງ',
    lt_msg_ok: 'ຕົກລົງ',
    lt_msg_cannot_return_poy: 'ບໍ່ສາມາດຄືນໂພຍໄດ້',
    lt_msg_error_try_again: 'ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່ອີກຄັ້ງ',
    lt_msg_error_generic: 'ເກີດຂໍ້ຜິດພາດ',
    lt_msg_proceed_within_5min: 'ກະລຸນາดำเนินการພາຍໃນ 5 ນາທີ',
    lt_msg_min_withdraw_50: 'ຂັ້ນຕ່ຳໃນການຖອນ 50 ບາດ',
    lt_msg_error_try_again2: 'ເກີດຂໍ້ຜິດພາດ ກະລຸນາລອງໃໝ່',
    lt_msg_mobile_link_unavailable: 'ລິ້ງມືຖືບໍ່ພร້ອມໃຊ້ງານ',
    lt_msg_game_link_unavailable: 'ລິ້ງເກມບໍ່ພร້ອມໃຊ້ງານ',
    lt_msg_link_unavailable: 'ລິ້ງບໍ່ພร້ອມໃຊ້ງານ',
    lt_msg_enter_coupon: 'ກະລຸນາกรอก Code Coupon',
    lt_msg_not_logged_in: 'ທ່ານຍັງບໍ່ໄດ້ລັອກອິນ',
    lt_msg_invalid_token: 'Token ບໍ່ຖືກต้อง',
    lt_msg_user_not_found: 'ບໍ່ພບຂໍ້ມູນຜູ້ໃຊ້',
    lt_msg_password_incomplete: 'Password ຂອງທ່ານบໍ່ครบ 6 ໂຕ ກະລຸນາກວດສອບ',
    lt_msg_no_phone: 'ທ່ານบໍ່ໄດ້ໃສ່ ເບີໂທລະສັບ',
    lt_msg_wrong_phone: 'ທ່ານໃສ່ເບີผิดพลาด',
    lt_msg_otp_mismatch: 'ລະຫັດຢືນຢັນບໍ່ตรงกัน',
    lt_msg_pass_max15: 'ລະຫັດຜ່ານສູງສຸດบໍ່ເກີນ 15 ໂຕ',
    lt_msg_pass_min6: 'ລະຫັດຜ່ານບໍ່ໜ້ອຍກວ່າ 6 ໂຕ',
    lt_msg_register_error: 'ເກີດຂໍ້ຜິດພາດໃນການລົງທະບຽນ',
    lt_msg_phone_in_use: 'ເບີນີ້ມີຄົນໃຊ້ແລ້ວ',
    lt_msg_otp_send_error: 'ເກີດຂໍ້ຜິດພາດໃນການສົ່ງ OTP',
    lt_msg_otp_limit: 'ບໍ່ສາມາດຂໍ OTP ໄດ້ແລ້ວ ທ່ານສາມາດຂໍໃໝ່ໄດ້ຫຼັງຈາກ 10 ນາທີ',
    lt_msg_otp_wait_5min: 'ອີກ 5 ນາທີสามารถทำรายการໃໝ່ໄດ້',
    lt_lotto_short: 'ຫວຍ',
    lt_slot_casino: 'ສະລັອດ/ຄາສິໂນ',
    lt_play_casino_amount: 'ຍອດຫຼິ້ນ Casino',
    lt_play_sport_amount: 'ຍອດຫຼິ້ນ Sport',
    lt_deposit_amount: 'ຍອດເຕີມ',
    lt_withdraw_amount: 'ຍອດຖອນ',
    lt_select_month: 'ເລືອກເດືອນ',
    lt_total_month: 'ຍອດລວມ (ເດືອນ)',
    lt_report_withdraw_income: 'ແຈ້ງຖອນລາຍໄດ້',
    lt_income_credit_note: 'ລາຍໄດ້ ລະບົບແນະນຳ ຈະຖອນເຂົ້າເປັນເງິນເຄຣດິດ',
    lt_contact_agent_note: 'ຫາກສົງໄສໂປຣດຕິດຕໍ່ເອເຢ່ນທີ່ທ່ານສະໝັກສະມາຊິກ',
    lt_current_income_remaining: 'ລາຍໄດ້ປັດຈຸບັນ - ຄົງເຫຼືອ',
    lt_no_income: 'ບໍ່ມີຍອດຮັບ',
    lt_receiving_credit: 'ກຳລັງຮັບເຄຣດິດ...',
    lt_receive_credit: 'ຮັບເຄຣດິດ',
    lt_recent_receive_history: 'ປະຫວັດການຮັບລ່າສຸດ',
    lt_calculated_at: 'ທີ່ຄຳນວນ',
    lt_amount_calculated: 'ຈຳນວນທີ່ຄຳນວນ',
    lt_loss_rebate: 'ຄືນຍອດເສຍ',
    lt_loss_rebate_condition: 'ເງື່ອນໄຂຄືນຍອດເສຍ',
    lt_loss_rebate_percent: 'ເປີເຊັນຍອດເສຍທີ່ຄືນ:',
    lt_loss_rebate_this_month: 'ຄືນຍອດເສຍສະສົມເດືອນນີ້',
    lt_current_withdraw_amount: 'ຍອດຖອນປັດຈຸບັນ',
    lt_loss_rebate_percent_label: 'ເປີເຊັນຍອດເສຍທີ່ຄືນ',
    lt_loss_rebate_percent_max: 'ເປີເຊັນຍອດເສຍທີ່ຄືນສູງສຸດ',
    lt_loss_rebate_formula: 'ເງື່ອນໄຂ ຝາກ - ຖອນ = ເປີເຊັນ * ຍອດຄຳນວນ',
    lt_play_loss_get_back: 'ຫຼິ້ນເສຍໄດ້ຄືນ',
    lt_loss_rebate_desc: 'ຫາກທ່ານຫຼິ້ນເສຍ ທ່ານຈະໄດ້ຮັບເງິນຄືນຕາມເປີເຊັນທີ່ກຳນົດ ແລະສາມາດຖອນອອກເປັນເຄຣດິດໄດ້',
    lt_final_decision_note: 'ຄຳຕັດສິນຂອງບໍລິສັດຖືເປັນທີ່ສິ້ນສຸດ',
    lt_report_receive_loss: 'ແຈ້ງຮັບຍອດເສຍ',
    lt_loss_credit_note: 'ຍອດເສຍ ລະບົບຄືນຍອດເສຍ ຈະຖອນເຂົ້າເປັນເງິນເຄຣດິດ',
    lt_current_amount_remaining: 'ຍອດປັດຈຸບັນ - ຄົງເຫຼືອ',
    lt_recent_loss_history: 'ປະຫວັດການຮັບຍອດເສຍລ່າສຸດ',
    lt_minigame: 'ມິນິເກມ',
    lt_number_set_detail: 'ລາຍລະອຽດເລກຊຸດ',
    lt_delete_this_item: 'ລຶບລາຍການນີ້',
    lt_set_name: 'ຊື່ຊຸດ',
    lt_created_at: 'ສ້າງເມື່ອ',
    lt_number_set: 'ຊຸດຕົວເລກ',
    lt_notification_msg: 'ຂໍ້ຄວາມແຈ້ງເຕືອນ',
    lt_confirm_delete_set: 'ທ່ານແນ່ໃຈບໍ່ວ່າຕ້ອງການລຶບ ເລກຊຸດນີ້ ?',
    lt_profile: 'ໂປຣໄຟລ໌',
    lt_manage_password: 'ຈັດການລະຫັດຜ່ານ',
    lt_password_note: 'ໝາຍເຫດ: ກໍລະນີຈຳລະຫັດຜ່ານປັດຈຸບັນບໍ່ໄດ້ ກະລຸນາຕິດຕໍ່ແອັດມິນ ທາງໄລນ໌',
    lt_old_password: 'ລະຫັດຜ່ານເດີມ',
    lt_new_password: 'ລະຫັດຜ່ານໃໝ່',
    lt_confirm_new_password: 'ຢືນຢັນລະຫັດຜ່ານໃໝ່',
    lt_change_password: 'ປ່ຽນລະຫັດຜ່ານ',
    lt_deposit_withdraw_status: 'ສະຖານະ ຝາກ-ຖອນເງິນ',
    lt_report_deposit_withdraw: 'ແຈ້ງບັນຫາຝາກ / ຖອນ',
    lt_deposit_short: 'ຝາກ',
    lt_withdraw_short: 'ຖອນ',
    lt_click_item_for_detail: '*ຄລິກທີ່ລາຍການເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມ',
    lt_deposit_credit: 'ຝາກເຄຣດິດ',
    lt_withdraw_credit: 'ຖອນເຄຣດິດ',
    lt_bonus: 'ໂບນັດ',
    lt_status: 'ສະຖານະ',
    lt_processing: 'ກຳລັງດຳເນີນການ',
    lt_pending: 'ລໍຖ້າດຳເນີນການ',
    lt_cancelled_by_player: 'ຍົກເລີກ (ຍົກເລີກໂດຍຜູ້ຫຼິ້ນ)',
    lt_failed_by_system: 'ບໍ່ສຳເລັດ (ໂດຍລະບົບ)',
    lt_success_status: 'ສຳເລັດ',
    lt_transaction_no: 'ເລກທີ່ລາຍການ',
    lt_remaining: 'ຄົງເຫຼືອ',
    lt_note_colon: 'ໝາຍເຫດ:',
    lt_topup_by_user: 'ເຕີມເງິນໂດຍຜູ້ໃຊ້ງານ',
    lt_play_game: 'ຫຼິ້ນເກມ',
    lt_bet_lotto2: 'ແທງຫວຍ',
    lt_system: 'ລະບົບ',
    lt_financial_report2: 'ລາຍງານການເງິນ',
    lt_click_item_history_3days: '*ຄລິກທີ່ລາຍການເພື່ອເບິ່ງລາຍລະອຽດເພີ່ມເຕີມ - ລາຍການຍ້ອນຫຼັງບໍ່ເກີນ 3 ວັນ',
    lt_prize_result: 'ຜົນລາງວັນ',
    lt_search_lotto_name: 'ຄົ້ນຫາຊື່ຫວຍ',
    lt_search_lotto_ph: 'ພິມຊື່ຫວຍ, ລະຫັດຫວຍ ຫຼືຮອບຫວຍ',
    lt_no_lotto_found: 'ບໍ່ພົບຂໍ້ມູນຫວຍທີ່ຄົ້ນຫາ',
    lt_foreign_lotto_group: 'ກຸ່ມຫວຍຕ່າງປະເທດ',
    lt_online_lotto_group: 'ກຸ່ມຫວຍອອນລາຍ',
    lt_stock_lotto_group: 'ກຸ່ມຫວຍຫຸ້ນ',
    lt_special_stock_lotto_group: 'ກຸ່ມຫວຍຫຸ້ນພິເສດ',
    lt_past_results: 'ຜົນຍ້ອນຫຼັງ',
    lt_how_to_deposit: 'ວິທີຝາກເງິນ',
    lt_image: 'ຮູບພາບ',
    lt_video: 'ວີດີໂອ',
    lt_how_to_buy_lotto: 'ວິທີຊື້ຫວຍ',
    lt_how_to_change_password: 'ວິທີການປ່ຽນລະຫັດຜ່ານ',
    lt_change_password_short: 'ປ່ຽນລະຫັດຜ່ານ',
    lt_deposit_money: 'ຝາກເງິນ',
    lt_how_to_register2: 'ວິທີການສະໝັກສະມາຊິກ',
    lt_register_member: 'ສະໝັກສະມາຊິກ',
    lt_forgot_password_title: 'ຫາກລືມລະຫັດຜ່ານ',
    lt_how_to_catch_win: 'ວິທີການຈັບວິນ',
    lt_catch_win: 'ຈັບວິນ',
    lt_how_to_bet_rood: 'ວິທີການແທງຮູດ',
    lt_bet_rood: 'ແທງຮູດ',
    lt_how_to_deposit_decimal: 'ວິທີການຝາກເງິນລະບົບທศนิยม',
    lt_boss: 'ເຖົ້າແກ່',
    lt_bank_account_title: 'ບັນຊີທະນາຄານ',
    lt_usable_bank_account: 'ບັນຊີທະນາຄານທີ່ສາມາດໃຊ້ໄດ້',
    lt_game: 'ເກມ',
    lt_wheel: 'ກົງລໍ້',
    lt_checkin: 'ເຊັກອິນ',
    lt_open_card: 'ເປີດໄພ່',
    lt_search_game_name: 'ຄົ້ນຫາລາຍຊື່ເກມ',
    lt_upload_slip: 'ອັບໂຫຼດ Slip',
    lt_upload_slip_only: 'ອັບໂຫຼດສະເພາະຮູບ Slip',
    lt_upload: 'ອັບໂຫຼດ',
    lt_confirm_upload: 'ຢືນຢັນການອັບໂຫຼດ',
    lt_upload_slip_success: 'ອັບໂຫຼດສະລິບສຳເລັດແລ້ວ',
    lt_username_account: 'ຊື່ຜູ້ໃຊ້ງານ',
    lt_select_transaction_channel: 'ກະລຸນາເລືອກຊ່ອງທາງທຸລະກຳ',
    lt_amount_only_numbers_ph: 'ລະບຸສະເພາະຕົວເລກ',
    lt_company_pleased: 'ບໍລິສັດມີຄວາມຍິນດີເປັນຢ່າງຍິ່ງທີ່ໄດ້ຮັບໃຊ້ທ່ານ',
    lt_terms_intro: 'ເພື່ອໃຫ້ທ່ານຮູ້ເຖິງສິດທິປະໂຫຍດຂອງສະມາຊິກ ກະລຸນາອ່ານຂໍ້ຕົກລົງຢ່າງລະອຽດກ່ອນທີ່ຈະລົງທະບຽນສະໝັກເປັນສະມາຊິກແລະໃຊ້ບໍລິການ',
    lt_terms_accept_intro: 'ເມື່ອສະໝັກສະມาຊິກແລ້ວ ທາງເວັບຈະຖືວ່າ ສະມາຊິກໄດ້ອ່ານແລະຍອມຮັບ',
    lt_terms_policy: '"ນະໂยບາຍແລະເງື່ອນໄຂການໃຫ້ບໍລິການຂອງເວັບໄຊທ໌"',
    lt_terms_h_benefit: 'ການຮັກສາຜົນປະໂຫຍດແລະຊ່ວຍເຫຼືອການເດີມພັນອອນລາຍ',
    lt_terms_b1: 'ຖ້າສະມາຊິກຫຼຸດອອກຈາກເວັບໄຊທ໌ລະຫວ່າງການເດີມພັນ ບັນຊີຂອງທ່ານຈະບໍ່ມີຜົນກະທົບຕໍ່ຜົນລັບຂອງການເດີມພັນ',
    lt_terms_b2a: 'ບໍ່ຕ້ອງກັງວົນ ຖ້າສະມາຊິກອອກຈາກເວັບໄຊທ໌ລະຫວ່າງການເດີມພັນ ສະມາຊິກຈະຖືກອອກຈາກລະບົບຊ່ວງເວລາໜຶ່ງ ຈາກນັ້ນສະມາຊິກສາມາດເຂົ້າສູ່ລະບົບ',
    lt_terms_b2b: 'ໄດ້ອີກຄັ້ງຕາມປົກກະຕິ',
    lt_terms_h_protect: 'ການໃຫ້ຄວາມຄຸ້ມຄອງ',
    lt_terms_protect1: 'ໄດ້ມີການຈັດກຽມ ລະບົບທີ່ມີປະສິດທິພາບ ຄວາມວ່ອງໄວແລະການບໍລິການລູກຄ້າທີ່ເປັນມິດ ຖ້າຫາກທ່ານມີຄຳຖາມຫຼືຄຳແນະນຳໃດໆ ກະລຸນາຢ່າລັງເລໃຈທີ່ຈະໂທລະສັບມາທາງฝ่າຍບໍລິການລູກຄ້າ ເຊິ່ງຈະມີໃຫ້ບໍລິການຕະຫຼອດ 24 ຊົ່ວໂມງ ທຸກວັນບໍ່ມີວັນພັກແລະທາງເຮົາຈະຕอบກັບຢ່າງວ່ອງໄວທີ່ສຸດ',
    lt_terms_protect2: 'ຂໍຮັບຮອງວ່າຈະຮັກສາຂໍ້ມູນສ່ວນຕົວຂອງທ່ານໄວ້ເປັນຄວາມລັບຢ່າງปลอดภัย',
    lt_terms_h_bet: 'ຂໍ້ຕົກລົງໃນການເດີມພັນ',
    lt_terms_bet1: 'ເພື່ອຫຼີກລ່ຽງບັນຫາຕ່າງໆໃນຂະນະທີ່ໃຊ້ງານເວັບໄຊທ໌ ສະມາຊິກກະລຸນາອ່ານກົດກະຕິກາຂອງບໍລິສັດຢ່າງລະອຽດແລະລະมัดລະວັງ ເມື່ອສະມາຊິກເຂົ້າສູ່ໜ້າເດີມພັນທາງບໍລິສັດจะຖືວ່າທ່ານໄດ້ຍອມຮັບຂໍ້ຕົກລົງຂອງທາງ',
    lt_terms_bet2a: 'ການເດີມພັນຈະຕ້ອງຢູ່ໃນ',
    lt_terms_period: '"ໄລຍະເວລາທີ່ກຳນົດ"',
    lt_terms_bet2b: 'ມິฉะนั้นจะຖືວ່າການເດີມຄັ້ງນັ້ນເປັນ',
    lt_terms_void: '"ໂມฆะ"',
    lt_terms_bet2c: 'ຖ້າການເດີມພັນໄດ້ມີການຍົກເລີກຫຼືຢຸດพักຊົ່ວຄາວ ເນື່ອງຈາກເຫตุผลใดๆก็ตามກ່ອນການຫຼິ້ນ ການເດີມພັນຄັ້ງນັ້ນຈะຖືວ່າເປັນ',
    lt_terms_bet2d: 'ແລະທາງບໍລິສັດຈะຄືນເຄຣดิดໃຫ້ກັບສະມາຊິກ',
    lt_terms_bet3a: 'ເປັນຄວາມຮັບผิดຊອບຂອງສະມາຊິກທີ່ຈะຄອยดูผົนລັບ ຈາກຊ່ອງໜ້າต่างที่ສະແດງໃຫ້ເຫັນເຖิงผົนການເດີມພັນແພ້ຫຼືຊະนะ ທາງບໍລິສັດจะຍึดຖือຂໍ້ມູນ',
    lt_terms_bet_detail: '"ລາຍລະອຽດການວາງເດີມພັน"',
    lt_terms_bet3b: 'ຂອງສະມາຊິກ ໃນກໍລະນີที่ສະມາຊິກມີຄວາมສงสัย ແລະຕ້องการตรวจสอบຂໍ້ມູນໃນການคำนวณຂອງການເດີມພันนั้นๆ',
    lt_terms_bet4: 'ຖ້າຫາກເກີດຄວາມຜิดพลาดของລະບົບລະຫວ່າງການເດີມພันຫຼືຄວາมຜิดพลาดໂดยไม่ได้ເຈตนาของพนักงาน ທາງບໍລິສัดຂໍສະຫງວນสิทธ์ที่จะແກ້ໄຂผົนລับໃຫ້ຖูกต้อง ແລະจะมีการพิมพ์ຂໍ້ຄວາมที่ໄດ້ມีการแก้ไขເຜີຍແพร่ໄວ້ที่ແถบຕัววิ่งในໜ້າເວັບໄຊທ໌ ບໍລິສัดจะไม่มีการแจ้งສະມາຊິກເປັນการส่วนตัว',
    lt_terms_bet5: 'ເປັນຄວາມຮັບຊອບຂອງສະມາຊິກที่จะทำให้ແน่ใจว่าຊื່ผู้ใช้ແລະລະຫัดຜ່ານສຳລັບເຂົ້າເວັບໄຊທ໌ນັ້ນຖูกต้อง ແລະກະລຸນາປ່ຽนລະຫัดຜ່ານຂອງສະມາຊິກຢ່າງໜ້ອยເดือนລະຄັ້ງ ເພື່ອความปลอดภัย ຖ້າຫາກທ່ານພບຫຼือສงสัยว่ามีผู้อื่นได้ເຂົ້າໄປຫຼິ້ນໃນບັນຊีของท่านໂดยไม่รับอนุญาต ກະລຸນາ ແຈ້ງຕัวแทนของท่านທັນທີเพื่อປ່ຽนລະຫัดส่วนตัว (ຫากมีการເດີມພันก่อนที่จะປ່ຽนລະຫัดເດີມຈะຖือว่าการເດີມພันนั้นเป็นผล)',
    lt_terms_bet6: 'ກ່ອນເລີ່ມການເດີມພันแต่ละครั้ง ທ່ານສະມາຊິກควรจะตรวจสอบວงເງินของท่านเสียก่อน ຖ້າຫากท่านมีຂໍ້ສงสัยใดๆ ກ່ຽວກັບວงເງิน ກະລຸນາແຈ້ງຕัวแทนของท่านສະມາຊິກທັນທີ',
    lt_terms_bet7: 'ໃນກໍລະນีที่ເຫตุการณ์ไม่คาดคิดເກີດขึ้น ຢ່າງເຊັ່ນ ຂໍ້ມູນສูญหายเนื่องจากລະບົບอินเตอร์เน็ตขัดข้อง ທາງບໍລິສัดจะมีการประกาศให้รู้ເຖิงสาเหตุ ແລະວິທีการแก้ปัญหา',
    lt_terms_bet8: 'ຊົ່ວໂມງการให้บริการ 24 ຊົ່ວໂມง/ວัน ແລະไม่มีວັນພัก',
    lt_terms_bet9: 'ກໍລະນีตรวจพบการใช้ຕั้งแต่ 1 ຍูสເຊີຂึ้นไปเพื่อແທງທບ, ແທງຫວຍ 2 ໂຕ ເກີນ 50 ໝາຍເລກ/ແທງຫວຍ 3 ໂຕ ເກີນ 250 ໝາຍເລກ ຕໍ່ຫວຍງວດนั้นๆ ບໍ່ວ່າจะແຍກຫຼືรวมบิล ຫຼືทางບໍລິສัดຕัดสินแล้วว่าการເດີມພันผิดปกติ ທາງບໍລິສัดມีສิทธิ์ในการระงับการใช้งานແລະຍึดເຄຣดิดของສະມາຊິກໂดยไม่ต้องແຈ້ງລ່ວງໜ້າ',
    lt_terms_bet10: 'ຄຳຕັດສິນຂອງບໍລິສັດຖືເປັນທີ່ສິ້ນສຸດ',
    lt_terms_h_security: 'ລະບົບການຮັກສາຄວາມປອດໄພ',
    lt_terms_sec1: 'ຂໍ້ມູນທາງດ້ານບັນຊີເພື່ອวัตถุประสงค์ສະເພາະບຸคคล ຂໍ້ມູນที่ทางສະມາຊິກให้มาในการเปิดบัญชีจะຖูกເກັບເປັນຄວາມລັບຂັ້ນສູງສຸด ທາງບໍລິສัดจะไม่ເຜີຍແพร่ຂໍ້ມູນນີ້ໃຫ້ກັບບຸคคลที่สามฮ州ือองค์กรอื่นๆ ລ່ວງຮู้ ບໍ່ວ່າจะເປັນບັນຊีอีเมล์ ฮ州ือຂໍ້ມູນอื่นๆ ที่ทางສະມາຊິກກรอกในใบสมัคร ຂໍ້ມູນເຫຼົ່ານີ້จะใช้ในจุดมุ่งหมายที่ตั้งใจເອົາໄວ້ເທົ່ານັ້ນ ເຊັ່ນ การส่งเช็คເງินสดສຳລັບผู้ชนะฮ州ือຂໍ້ມູນอื่นๆ ຕາມที่ສະມາຊິກร้องขอ',
    lt_terms_sec2: 'ຄວາມປອດໄພທາງບໍລິສັດໄດ້ໃຊ້ວິທີທີ່ມີປະສິດທິພາບທີ່ສຸດເພື່ອให้ท่านແน่ใจในความปลอดภัยของຂໍ້ມູນของท่าน ທາງເຮົາจะພະຍາຍາມให้ดีที่สุดที่จะຮັກສາความถูกต้องແน่นอน ແລະความลับສະເພາະຂອງຂໍ້ມູນ ເພື່ອປ້ອງກັນບໍ່ให้ຂໍ້ມູນຮົ່ວໄຫຼฮ州ือนำไปใช้อย่างไม่ถูกต้อง ຖ້າທ່ານມີຂໍ້ສงสัยใดๆ ที่ກ່ຽວຂ้องກັບການຮັກສາความลับ ความปลอดภัยของຂໍ້ມູນ ກະລຸນາຕິดต่อฝ่ายบริการลูกค้า ພວກເຮົາຍິນດີໃຫ້ບໍລິການ 24 ຊົ່ວໂມง/ວัน ທຸກວັນບໍ່ມีວັນພัก',
  },
};
Object.keys(ext).forEach((l) => { translations[l] = Object.assign({}, translations[l], ext[l]); });
export default ext;
